'use strict';

angular.module('atex.dam').factory('UIConfigurationService', ['$rootScope', '$q', '$sce', '$filter', '$http', '$window',
  'AuthenticationService', 'ApplicationConfigurationService', 'DamService', 'DamNotificationService', 'DamActivityService',
  'DamAclPermissionService', 'DamStatusService', '$state', '$translate', 'ContentService', 'UserProfileService',
  'MetadataService', '$injector', 'ContentConfigurationService', 'configuration',
  function ($rootScope, $q, $sce, $filter, $http, $window, AuthenticationService, ApplicationConfigurationService,
            DamService, DamNotificationService, DamActivityService, DamAclPermissionService, DamStatusService, $state,
            $translate, ContentService, UserProfileService, MetadataService, $injector, ContentConfigurationService, configuration) {
    var _attributes = {};
    var _table;
    var usersInfo = {};

    var extIdsMap = {};

    var profilePromise;
    var copyfitPromise;
    var printSystem;
    var workingSitesPromise = [];

    var isEditAll = true;
    var isEditInCurrentWindow = false;

    var profile = function () {
      if (profilePromise === undefined) {
        profilePromise = ApplicationConfigurationService.getConfigurationFor(['printSystem']).then(function (_printSystem) {
          printSystem = _printSystem;
          return UserProfileService.getUserProfile({"application": "desk"}).then(function (configuration) {
            return configuration.data;
          }).then(null, function (error) {
            var message = "Error: " + error.cause;
            if ($translate.getTranslationTable() !== null) {
              message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
            }
            DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
          });
        });
      }
      return profilePromise;
    };

    var hidden = {"visibility": false};

    function _component(componentName, component, componentId) {
      return profile().then(function (_profile) {
        var components = _profile[component] || {};

        return _.find(components, function (configuration) {
          return (configuration.componentId === componentId);
        });
      });
    }

    function _userprofile(path) {
      return profile().then(function (_profile) {
        return atex.onecms.ObjectUtils.getByPath(_profile, 'userProfile/' + path);
      });
    }

    function translate(message, _default) {
      if (!_table) {
        _table = $translate.getTranslationTable();
      }
      return (message) ? (_table[message] || _default || message) : "";
    }


    function exist(attr) {
      return (attr !== undefined);
    }

    function toJson(id, entry) {
      var _json = {
        id: id
      };

      if (entry && entry.title) {
        _json.title = entry.title;
      }

      if (entry && entry.value) {
        _json.id = entry.value;
      }

      if(entry && typeof entry.value === "boolean") {
        _json.id = entry.value;
      }

      if (entry && entry.label) {
        _json.label = entry.label;
      }

      if (entry && entry.name) {
        _json.label = entry.name;
      }

      if (entry && entry.text) {
        _json.label = entry.text;
      }

      if (entry && entry.parent) {
        _json.parent = entry.parent;
      }

      if (entry && entry.icon) {
        _json.icon = entry.icon;
      }

      if (entry && entry.color) {
        _json.color = entry.color;
      }

      if (entry && entry['icon-color']) {
        _json['icon-color'] = entry['icon-color'];
      }

      if (entry && (!entry.icon && !entry.color)) {
        _json.text = true;
      }

      if (entry && entry['default-label']) {
        _json['default-label'] = entry['default-label'];
      }

      return _json;
    }

    function clean(value) {
      return (value instanceof Object) ? value.id : value;
    }

    function deep(content, values) {
      _.each(values, function (value) {
        content.values.push(clean(value));
      });
    }

    function isModelEqual(lhs, rhs) {
      var numberLhsOwn = 0;
      var numberRhsOwn = 0;
      var isEqual = true;

      if ( lhs && !rhs ) {
        return false;
      }

      if ( !lhs && rhs ) {
        return false;
      }

      if ( !lhs && !rhs ) {
        return true;
      }

      _.each(lhs, function( model, key) {
        if ( _.has(lhs, key) ) {
          numberLhsOwn++;

          if (!_.has(rhs, key)) {
            isEqual = false;
          } else {
            if (typeof model.name !== 'undefined' && typeof rhs[key].name !== 'undefined' && model.name !== rhs[key].name) {
              isEqual = false;
            }
            if (typeof model.id !== 'undefined' && typeof rhs[key].id !== 'undefined' && model.id !== rhs[key].id) {
              isEqual = false;
            }
          }
        }
      });

      _.each(rhs, function( model, key) {
        if (_.has(rhs, key)) {
             numberRhsOwn++;
        }
      });

      if ( numberLhsOwn !== numberRhsOwn ) {
        isEqual = false;
      }

      return isEqual;
    }

      function search(componentName, componentId, id, profile, selectedTab) {
      profile = (!profile) ? "forms" : profile;

      return _component(componentName, profile, componentId).then(function (component) {
        var deferred = $q.defer();

        if(selectedTab && component.entries) {
          component = _.find(component.entries, function(entry) {
            return entry.id === selectedTab;
          });
        }

        var promises = component.sections.map(function (section) {
          return _.find(section.fields, function (field) {
            var _id = atex.onecms.ObjectUtils.getByPath(field, "value/model/attribute") || "";
            return (_id === id);
          });
        });

        $q.all(promises).then(function (fields) {
          var content = _.find(fields, function (field) {
            return (field !== undefined);
          }) || {};
          deferred.resolve(content);
        });

        return deferred.promise;
      });
    }

    function setEditInCurrentWindow() {
      isEditInCurrentWindow = true;
    }

    function edit(entries, showEdit) {
      var ids = atex.dam.AngularUtils.getIdsArray(entries);
      isEditAll = false;
      if (isEditInCurrentWindow === true) {
        isEditInCurrentWindow = false;
      } else if(entries.length > 1) {
        isEditAll = true;
      }

      DamAclPermissionService.hasWritePermissionEx(entries).then(function (hasPermission) {
        if (!hasPermission) {
          var message = $translate.getTranslationTable()._NO_EDIT_PERMISSION_LABEL_;
          DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
          return;
        }

        DamActivityService.getLockData(ids).then(function (lockData) {
          var isCollection = entries[0] && entries[0]._data.aspects.contentData.data.objectType === 'collection';
          if (lockData.lockedBy && !isCollection) {
            DamActivityService.notifyItemLocked(lockData.getUserName());
            return;
          } else {
            if (!showEdit) {
              return;
            }

            if (entries[0]._data.aspects.contentData.data.objectType === 'collection') {
              var overrides = configuration.getOverrideEditContentMenu();
              if (overrides && overrides[entries[0]._data.aspects.contentData.data._type]){
                $window.open(overrides[entries[0]._data.aspects.contentData.data._type] + entries[0]._data.id, '_blank').focus();
              }else{
                $state.go('list.collection', {'id': entries[0]._data.id, 'preview': null});
              }
            } else {
              DamActivityService.lock(ids).then(function () {
                $state.go('list.edit', {ids: entries, isEditAll: isEditAll});
              });
            }
          }
        });
      });
    }

    function find(contents, type) {
      return _.find(contents, function (content) {
        return content.id === type;
      });
    }

    function _widget(componentName, componentId) {
      return _component(componentName, "widgets", componentId).then(function (component) {
        return angular.copy(component);
      });
    }

    function configurations(configuration) {
      return _component(configuration.name, "field-configurations", configuration.id);
    }


    function _copyfit() {
      if (copyfitPromise === undefined) {
        copyfitPromise = UserProfileService.getConfigurationById({
          application: 'desk',
          id: 'copyfit-configurations'
        });
      }
      return copyfitPromise;
    }

    function _formField(componentName, componentId) {
      return _component(componentName, "search-fields", componentId).then(function (component) {
        return angular.copy(component);
      });
    }

    $rootScope.$on("dam:loadConfigurationEnd", function () {
      profile().then(function (_profile) {
        UserProfileService.disableAction({'action': 'redirect', 'application': 'desk'}).then(function (disable) {
          if (!disable) {
            var href = atex.onecms.ObjectUtils.getByPath(_profile, "disable-redirect-rules/href");
            $window.location.href = href;
          }
        });
      });
    });

    function htmlSpecialChars(unsafe) {
      return unsafe
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
    }

    function buildFileContentXML(extId, content) {
      var xml = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n" +
        "<batch xmlns=\"http://www.polopoly.com/polopoly/cm/xmlio\">\n" +
        "<content>\n" +
        "<metadata>\n" +
        "<contentid><externalid>" +
        extId +
        "</externalid></contentid>\n" +
        "</metadata>\n" +
        "<component group=\"data\" name=\"value\">" +
        htmlSpecialChars(content.data.aspects.contentData.data.dataValue) +
        "</component>\n" +
        "</content>\n" +
        "</batch>";
      return xml;
    }

    function workChild(id) {
      return ContentService.getContent({id: id}).then(function (content) {
        var type = atex.onecms.ObjectUtils.getByPath(content, 'type');
        if (!type) {
          return;
        }
        if (type === "com.atex.onecms.content.ConfigurationDataBean") {
          var extId = content.data.aspects["atex.Aliases"].data.aliases.externalId;
          zip.file(extId + ".xml", buildFileContentXML(extId, content));
        } else {
          var items = atex.onecms.ObjectUtils.getByPath(content, 'data/aspects/contentData/data/contentsContentList/list') || [];
          var subFoldersPromises = items.map(function (item) {
            return workChild(item.contentId);
          });
          return $q.all(subFoldersPromises);
        }
      }).then(null, function (err) {
        console.log("exportUICfg: Error getting child id(" + id + "): " + err);
      });
    }

    var zip;

    function _exportUICfg() {
      zip = new JSZip();
      return ContentService.getContent({id: 'atex.onecms.OneCMSTemplateConfiguration'}).then(function (content) {
        var items = atex.onecms.ObjectUtils.getByPath(content, 'data/aspects/contentData/data/contentsContentList/list') || [];
        var subFoldersPromises = items.map(function (item) {
          return workChild(item.contentId);
        });
        return $q.all(subFoldersPromises).then(function () {
          zip.generateAsync({type: "blob"}).then(function (content) {
            // see FileSaver.js
            saveAs(content, "UI_Cfg.zip");
          });
        });
      }).then(null, function (err) {
        console.log("exportUICfg: Error getting root atex.onecms.OneCMSTemplateConfiguration: " + err);
      });
    }

    function equals(resource, to) {
      return {
        "valid": (resource === to)
      };
    }

    function notEquals(resource, to) {
      return {
        "valid": (resource !== to)
      };
    }

    function notEmpty(resources) {
      var _valid = (resources !== undefined && resources.length > 0);
      var _size = (_valid) ? resources.length : 0;

      return {
        "valid": _valid,
        "size": _size
      };
    }

    function isNull(resource) {
      return {
        "valid": (_null(resource))
      };
    }

    function isZero(resource) {
      return {
        "valid": (_zero(resource))
      };
    }

    function _zero(resource) {
      return (resource === 0);
    }

    function notNull(resource) {
      return {
        "valid": (!_null(resource))
      };
    }

    function _null(resource) {
      return (!resource);
    }

    function contains(resource, to) {
      return {
        "valid": (_.contains(resource, to))
      };
    }

    function notContains(resource, to) {
      return {
        "valid": (!_.contains(resource, to))
      };
    }

    function _validate(_entry, ruleset) {
      var fields = atex.onecms.ObjectUtils.getByPath(ruleset, "fields") || [];
      var operator = atex.onecms.ObjectUtils.getByPath(ruleset, "operator") || "OR";

      var _fields = _.map(fields, function (field) {
        var _valid = {"valid": false, "size": 0};

        var path = atex.onecms.ObjectUtils.getByPath(field, "path");
        var dimension = atex.onecms.ObjectUtils.getByPath(field, "dimension");
        var queryField = atex.onecms.ObjectUtils.getByPath(field, "query-field");
        var condition = atex.onecms.ObjectUtils.getByPath(field, "condition") || "";
        var to = atex.onecms.ObjectUtils.getByPath(field, "to") || "";
        var _in = atex.onecms.ObjectUtils.getByPath(field, "in") || "";
        var label = atex.onecms.ObjectUtils.getByPath(field, "label");
        var icon = atex.onecms.ObjectUtils.getByPath(field, "icon");

        var _field = [];

        if(path) {
          _field =  atex.onecms.ObjectUtils.getByPath(_entry, path);
        } else if(dimension) {
          var _dimensions = atex.onecms.ObjectUtils.getByPath(_entry, "_data/aspects/atex.Metadata/data/metadata/dimensions") || [];

          var _dimension = _.find(_dimensions, function (_dimension) {
            return _dimension.id === dimension;
          });

          if(_dimension) {
            _field = _.map(_dimension.entities, function(entity) {
              return entity.id;
            });
          }
        } else if(queryField) {
          if (_entry.fields) {
            var found = _entry.fields.find(function (field) {
              return field.key === queryField;
            });

            _field = (found) ? found.values : undefined;
          }
        }

        if (condition === "NOT-EMPTY") {
          _valid = notEmpty(_field);
        } else if (condition === "IS-NULL") {
          _valid = isNull(_field);
        }else if (condition === "IS-ZERO") {
          _valid = isZero(_field);
        } else if (condition === "NOT-NULL") {
          _valid = notNull(_field);
        } else if (condition === "EQUALS") {
          _valid = equals(_field, to);
        } else if (condition === "NOT-EQUALS") {
          _valid = notEquals(_field, to);
        } else if (condition === "CONTAINS") {
          _valid = contains(_field, to);
        } else if (condition === "NOT-CONTAINS") {
          _valid = notContains(_field, to);
        } else if (condition === "CONTAINS-IGNORE-CASE") {
          _in = _.map(_in, function(_to) {
            return _to.toLocaleLowerCase();
          });

          if(_field) {
            _field = _field.toLocaleLowerCase();
          }
          _valid = contains(_in, _field);
        }

        _valid.icon = icon;
        _valid.label = label;

        return _valid;
      });

      var template = {"valid": false};
      if (operator === "OR") {
        var entry = _.find(_fields, function (value) {
          return (value.valid);
        }) || {valid: false};

        template.valid = entry.valid;
      } else if (operator === "AND") {
        template.valid = _.every(_fields, function (value) {
          return (value.valid);
        });
      }

      template.fields = _fields;

      return template;
    }

    function getNullStatus () {
      var nullStatus = {
        attributes: [],
        color: "#FFFFFF",
        entryConditions: [],
        name: "No Status",
        next: [],
        statusID: "noStatus",
        users: []
      };
      return nullStatus;
    }

    function flat(site, tags, txt) {
      var text = (txt) ? txt + "/" + site.name : site.name;
      tags.push({id: atex.dam.AngularUtils.removePrefix(site.id), text: text});

      if (site.children) {
        _.each(site.children, function (child) {
          flat(child, tags, text);

        });
      } else {
        return;
      }

      return tags;
    }

    function flatWorkingSites(sites) {
      var tags = [];
      _.each(sites, function (site) {
        flat(site, tags);
      });

      return tags;
    }

    function getLevels(sites, currentDepth, excludedSites) {
      var variant = (excludedSites) ? "atex.onecms.structure" + '&excludedSites=' + encodeURI(excludedSites.join(','))
        : "atex.onecms.structure";

      var sitePromises = sites.map(function (site) {
        return ContentService.getContent({id: site.id, variant: variant}).then(function (responseInfo) {
          var id = atex.dam.AngularUtils.getWithContentId(responseInfo.id);
          var name = responseInfo.data.aspects.contentData.data.name || responseInfo.id;
          var data = atex.dam.AngularUtils.withExternalId({id: id, name: name}, responseInfo);

          if (currentDepth < 100) {
            data.children = atex.onecms.ObjectUtils.getByPath(responseInfo, 'data/aspects/contentData/data/children') || [];

            data.children.forEach(function (child) {
              var currentChildren = child.children;
              var depth = currentDepth;
              while (currentChildren !== undefined && depth < 100 && currentChildren.length > 0) {
                depth++;
                if (depth === 100) {
                  child.children = [];
                } else {
                  currentChildren = currentChildren.children;
                }
              }
            });
          }

          return data;
        });
      });

      return $q.allSettled(sitePromises).then(function (sites) {
        return atex.onecms.AngularUtils.splitSettled(sites).fulfilled;
      });
    }

    function pruneExcludedSites(sites, excludedSites, excludedSiteRegex) {
      if (excludedSites || excludedSiteRegex) {
        var _pruneSites = function (sites) {
          for (var idx = sites.length - 1; idx >= 0; idx--) {
            var s = sites[idx];
            if (s.externalId && _.contains(excludedSites, s.externalId) || s.externalId && isSiteExcluded(s.externalId, excludedSiteRegex)) {
              sites.splice(idx, 1);
            } else if (s.children) {
              _pruneSites(s.children);
            }
          }
        };
        _pruneSites(sites);
        return $q.when(sites);
      } else {
        return $q.when(sites);
      }
    }

    function isSiteExcluded(workingSite, excludedSiteRegex) {
      if (excludedSiteRegex !== undefined) {
        if (workingSite.match(excludedSiteRegex)) {
          return true;
        }
      }
      return false;
    }

    function getWorkingSites(exclude, excludedSitesRegex) {
      var key = exclude + "/" + excludedSitesRegex;
      if(workingSitesPromise[key] === undefined) {
        workingSitesPromise[key] = getPossibleSelections(exclude).
          then(function (possibleSelections) {
            return pruneExcludedSites(possibleSelections, exclude,
              excludedSitesRegex);
          });
      }
      return workingSitesPromise[key];
    }

    function getPossibleSelections(exclude) {
      return AuthenticationService.getCurrentUser().then(function (currentUser) {
        return ContentService.getContent({id: currentUser.userId, variant: 'onecms'});
      }).then(function (userDataContent) {
        var workingSites = atex.onecms.ObjectUtils.getByPath(userDataContent, 'data/aspects/contentData/data/workingSites') || [];
        return getLevels(workingSites.map(function (workingSite) {
          return {id: 'externalid/' + workingSite.id};
        }), 1, exclude);
      });
    }

    function updateContentWithPermissionChecks(entry, data, field, path, lambda) {
      return DamAclPermissionService.hasWritePermission([entry.id]).
        then(function (hasPermission) {
          if (!hasPermission) {
            var errorMessage = $translate.getTranslationTable()._NO_EDIT_PERMISSION_LABEL_;
            DamNotificationService.addNotification(atex.dam.Notification({
              type: 'error',
              message: errorMessage,
            }), true);
            return false;
          } else {
            return DamActivityService.getLockData([entry.id]).
              then(function (lockData) {
                if (lockData.edit) {
                  DamActivityService.notifyItemLocked(lockData.getUserName());
                  return false;
                } else {
                  var locked = false;
                  return DamActivityService.lock([entry.id]).
                    then(function (responses) {
                      locked = true;
                      return ContentService.getContent({ id: entry.id }).
                        then(function (content) {
                          //Specific function passed in by the widget calling it
                          lambda(content, field, data, path);
                          var updateInfo = {
                            id: content.id,
                            data: content.data,
                            revision: content.revision,
                          };
                          return ContentService.updateContent(updateInfo).
                            then(function (response) {
                              entry._data = response.data;
                              entry.revision = response.revision;
                              $rootScope.$broadcast('dam:updatedItem', entry);
                              var message = $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__;
                              DamNotificationService.addNotification(
                                atex.dam.Notification({
                                  type: 'success',
                                  message: message,
                                }), true);
                              return DamActivityService.unlock([entry.id]);
                            });
                        });
                    }).
                    then(null, function (error) {
                      if (locked) {
                        DamActivityService.unlock([entry.id]);
                      }
                      var errorMessage = $translate.getTranslationTable().__GENERIC_ERROR_MSG__;
                      DamNotificationService.addNotification(
                        atex.dam.Notification({
                          type: 'error',
                          message: errorMessage,
                        }), true);
                      return false;
                    });
                }
              });
          }
        });
    }

    function getStatusTextColor(status) {
      if (status) {
        if (status && status.textColor) {
          if (atex.dam.AngularUtils.isHexColor(status.textColor)) {
            return status.textColor;
          } else {
            return atex.dam.AngularUtils.getHex(
              status.textColor);
          }
        }

        var textColor = status.color;

        if (!atex.dam.AngularUtils.isHexColor(textColor)) {
          textColor = atex.dam.AngularUtils.getHex(textColor);
        }

        return atex.dam.AngularUtils.textColorOnBgColor(status.color);
      }

      return "#000000";
    }

    return {
      commit: function (query, name, id, profile, selectedTab) {
        var deferred = $q.defer();

        query.fields = [];

        var contents = [];
        _.each(query.set, function (values, key) {
          var content = {
            "key": key,
            "values": [],
            "operator": (atex.onecms.ObjectUtils.getByPath(query, "operators/" + key) === true),
            "extraValues": _.pluck((atex.onecms.ObjectUtils.getByPath(query, "extraValues/" + key) || []), "id"),
            "model": atex.onecms.ObjectUtils.getByPath(query, "models/" + key)
          };

          if (typeof values !== "undefined") {
            if (values instanceof Array) {
              deep(content, values);
            } else if (values.id instanceof Array) {
              deep(content, values.id);
            } else {
              content.values.push(clean(values));
            }
          }

          if (values) {
            contents.push(content);
          }
        });

        var promises = contents.map(function (content) {
          return search(name, id, content.key, profile, selectedTab).then(function (field) {
            content.type = atex.onecms.ObjectUtils.getByPath(field, "value/model/type");
            content.fulltext = atex.onecms.ObjectUtils.getByPath(field, "value/model/fulltext") || false;
            content.subQuery = atex.onecms.ObjectUtils.getByPath(field, "value/model/sub-query");
            content.useId = atex.onecms.ObjectUtils.getByPath(field, "value/use-id") || false;
            content.useValue = atex.onecms.ObjectUtils.getByPath(field, "value/use-value") || false;
            content.useBoolean = atex.onecms.ObjectUtils.getByPath(field, "value/use-boolean") || false;
            content.split = atex.onecms.ObjectUtils.getByPath(field, "value/model/split") || false;
            content.queryOperator = atex.onecms.ObjectUtils.getByPath(field, "value/model/queryoperator") || "";
            content.disablePatchDate = atex.onecms.ObjectUtils.getByPath(field, "value/model/disablePatchDate") || "";
            content.offsetDateInterval = atex.onecms.ObjectUtils.getByPath(field, "value/model/offsetDateInterval") || "";

            if("physicalPage_ss" === content.key) {
              content.ignore = !printSystem.hasPHPages;
            }

            query.fields.push(content);
          });
        });

        $q.all(promises).then(function () {
          deferred.resolve(query);
        });

        return deferred.promise;
      },

      draw: function (field, name, id, profile, selectedTab) {
        var deferred = $q.defer();

        this.configuration(name, id, field.key, profile, selectedTab).then(function (configuration) {
          var values = field.values;

          var fields = atex.onecms.ObjectUtils.getByPath(configuration, "fields") || [];
          var type = atex.onecms.ObjectUtils.getByPath(configuration, "type") || "";

          if (fields && fields.length > 0) {
            values = field.values.map(function (id) {
              return _.find(fields, function (configuration) {
                if (configuration.id instanceof Array) {
                  return _.include(configuration.id, id);
                } else {
                  return configuration.id === id;
                }
              }) || _.map(values, function (value) {
                return {id: value, label: value};
              });
            });
          } else if ((type === "select") || (type === "publication-dates")) {
            values = _.map(values, function (value) {
              return {id: value, label: value, text: value};
            });
          }

          values = ((field.type === "BOOLEAN") || (field.type === "STRING") || (field.type === "ENGAGE") || (field.type === "PRINT-DATE")) ? values[0] : values;
          deferred.resolve(values);
        });

        return deferred.promise;
      },

      configurations: function (configuration) {
        return configurations(configuration);
      },

      configuration: function (componentName, componentId, id, profile, selectedTab) {
        var deferred = $q.defer();

        this.search(componentName, componentId, id, profile, selectedTab).then(function (component) {
          var info = atex.onecms.ObjectUtils.getByPath(component, "configuration/field-configuration") ||
            atex.onecms.ObjectUtils.getByPath(component, "configuration/fields-configuration") || {id: "", name: ""};

          _component(info.name, "field-configurations", info.id).then(function (config) {
            var fields = atex.onecms.ObjectUtils.getByPath(config, "configurations") || [];
            var type = atex.onecms.ObjectUtils.getByPath(component, "value/type") || "";

            var configuration = _.map(fields, function (field, key) {
              return toJson(key, field);
            });

            deferred.resolve({fields: configuration, type: type});
          });
        });

        return deferred.promise;
      },

      search: function (componentName, componentId, id, profile, selectedTab) {
        return search(componentName, componentId, id, profile, selectedTab);
      },

      terms: function (term) {
        return AuthenticationService.callWithAuthentication(function () {
          var url = '/onecms/dam/content/find/' + term;
          return $http.get(url);
        });
      },

      remote: function (url) {
        return AuthenticationService.callWithAuthentication(function () {
          return $http.get(url);
        });
      },

      form: function (componentName, componentId, profile) {
        profile = (!profile) ? "forms" : profile;

        return _component(componentName, profile, componentId).then(function (component) {
          return component;
        });
      },

      operation: function (componentName, componentId) {
        return _component(componentName, "operations", componentId).then(function (component) {
          return component;
        });
      },

      css: function (componentName, componentId) {
        return _component(componentName, "css", componentId).then(function (component) {
          return component.css || [];
        });
      },

      resultSet: function (componentName, componentId, position, fieldId) {
        return _component(componentName, "result-set", componentId).then(function (component) {
          var fields = component[position] || [];
          return _.find(fields, function (field) {
            return (field.fieldId === fieldId);
          }) || hidden;
        });
      },

      type: function (componentName, componentId, type, profile) {
        profile = (!profile) ? "result-set" : profile;

        return _component(componentName, profile, componentId).then(function (component) {
          var contents = component["body"] || [];
          return find(contents, type) || find(contents, "default") || {};
        });
      },

      widget: function (componentName, componentId) {
        return _widget(componentName, componentId);
      },

      copyfit: function () {
        return _copyfit();
      },

      formField: function (componentName, componentId) {
        return _formField(componentName, componentId);
      },

      field: function (componentName, componentId, fieldId) {
        return _component(componentName, "fields", componentId).then(function (component) {
          return _.find(component.fields, function (field) {
            return (field.fieldId === fieldId);
          }) || hidden;
        });
      },

      facet: function (componentName, componentId, facetId) {
        return _component(componentName, "facets", componentId).then(function (component) {
          return _.find(component.facets, function (facet) {
            return (facet.facetId === facetId);
          }) || hidden;
        });
      },

      menu: function (componentName, componentId) {
        return _component(componentName, "menus", componentId).then(function (component) {
          return atex.onecms.ObjectUtils.getByPath(component, "templates") || [];
        });
      },

      toolbar: function (componentName, componentId) {
        return _component(componentName, "toolbars", componentId).then(function (component) {
          return component;
        });
      },

      dropDown: function (componentName, componentId) {
        return _component(componentName, "menus", componentId).then(function (component) {
          return component;
        });
      },

      button: function (componentName, componentId, buttonId) {
        return _component(componentName, "toolbars", componentId).then(function (component) {
          var buttons = atex.onecms.ObjectUtils.getByPath(component, "buttons") || [];
          return _.find(buttons, function (field) {
            return (field.buttonId === buttonId);
          }) || hidden;
        });
      },

      filter: function (componentName, componentId, templates) {
        return this.menu(componentName, componentId).then(function (contents) {
          return _.filter(templates, function (template) {
            return (contents.indexOf(template.id) > -1);
          }) || templates;
        });
      },

      fields: function (componentName, componentId) {
        return _component(componentName, "fields", componentId).then(function (_component) {
          var component = angular.copy(_component);
          var _results = atex.onecms.ObjectUtils.getByPath(component, "fields");
          _.each(_results, function (_result) {
            _result.label = translate(_result.label);
          });

          return _results;
        });
      },

      translate: function (message, _default) {
        return translate(message, _default);
      },

      toCss: function (_string, json) {
        json = (!json) ? {} : json;
        var originalJson = json;
        try {
        if (_string) {
          var properties = _string.split(";") || [];
          _.each(properties, function (property) {
            var split = property.split(":");
            json[split[0].trim()] = split[1].trim();
          });
        }
        } catch (error) {
          json = originalJson;
          console.error(error);
        }
        return json;
      },

      toJson: function (id, entry) {
        return toJson(id, entry);
      },

      isModelEqual: function (lhs, rhs) {
        return isModelEqual(lhs, rhs);
      },

      edit: function (entries, showEdit) {
        return edit(entries, showEdit);
      },

      editInCurrentWindow: function () {
        return setEditInCurrentWindow();
      },

      attributes: function (view) {
        var attributes = _attributes[view];
        if (!attributes) {
          attributes = [];
          DamStatusService.getAttributesList().then(function (attrs) {
            attrs.forEach(function (attribute) {
              if (attribute.views.includes(view)) {
                var attr = {
                  id: attribute.attributeID,
                  name: attribute.name,
                  shortName: attribute.shortName,
                  icon: attribute.icon
                };
                attributes.push(attr);
              }
            });

            _attributes[view] = attributes;
            return attributes;
          }).then(null, function (error) {
            var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
            DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
          });
        }
        return $q.when(attributes);
      },

      getLockData: function (id) {
        var deferred = $q.defer();
        DamActivityService.getLockData([id]).then(function (data) {
          deferred.resolve(data);
        }).then(null, function (error) {
          deferred.reject(error);
        });
        return deferred.promise;
      },

      _configuration: function (widgets) {
        return _.map(widgets, function (widget) {
          return _widget(widget.name, widget.id).then(function (_widget) {
            if (widget.css) {
              _widget.css = widget.css;
            }

            if (widget.style) {
              _widget.style = widget.style;
            }

            if (widget.view) {
              _widget.view = widget.view;
            }

            if (exist(widget['display-at-startup'])) {
              _widget['display-at-startup'] = widget['display-at-startup'];
            }

            if (exist(widget['display-if-empty'])) {
              _widget['display-if-empty'] = widget['display-if-empty'];
            }

            if (exist(widget['hide-label'])) {
              _widget['hide-label'] = widget['hide-label'];
            }

            return _widget;
          });
        });
      },

      getText: function (content) {
        if (typeof content === "object" && typeof content.text === 'string') {
          content = content.text;
        }

        return content;
      },

      getTimeZoneDate: function (res, offset) {
        if (res === ""){
          return "";
        }else{
          var d = new Date(parseInt(res));
          var utc = d.getTime() + (d.getTimezoneOffset() * 60000);  //This converts to UTC 00:00
          var nd = new Date(utc + (3600000 * offset));
          return nd.getTime();
        }
      },

      to_trusted: function (txt, limit, expand) {
        if (txt) {
          if (!expand && limit > 0) {
            txt = String(txt).replace(/<[^>]+>/gm, '');
            txt = $filter('limitHtml')(txt, limit, "...");
          }
        }

        return $sce.trustAsHtml(String(txt));
      },

      exportUICfg: function () {
        return _exportUICfg();
      },

      loadCfgContent: function (extID, cfgListPath) {
        if (extIdsMap[extID]) {
          return $q.when(extIdsMap[extID]);
        }
        var deferred = $q.defer();
        ContentService.getContent({id: extID}).then(function (data) {
          var list = atex.onecms.ObjectUtils.getByPath(data, cfgListPath) || data;
          deferred.resolve(list);
          extIdsMap[extID] = list;
        }).then(null, function (error) {
          deferred.reject(error);
        });
        extIdsMap[extID] = deferred.promise;
        return deferred.promise;
      },

      validate: function (entry, ruleset) {
        return _validate(entry, ruleset);
      },

      filterWorkingSites: function (tags, term) {
        return _.filter(tags, function (_tag) {
          var text = _tag.text.toLowerCase();
          term = term.toLowerCase();
          return (text.indexOf(term) > -1);
        });
      },

      getExcludedSites: function () {
        return profile().then(function (_profile) {
          return atex.onecms.ObjectUtils.getByPath(_profile, 'exclude-sites/sites') || [];
        });
      },

      getWorkingSites: function (exclude, excludedSitesRegex) {
        return getWorkingSites(exclude, excludedSitesRegex);
      },

      flatWorkingSites: function (sites) {
        return flatWorkingSites(sites);
      },

      getNullStatus: function () {
        return getNullStatus();
      },

      getLevels: function (sites) {
        return getLevels(sites.map(function (site) {
          return {id: 'externalid/' + site};
        }), 1);
      },

      getSearchOptions: function () {
        return profile().then(function (_profile) {
          return atex.onecms.ObjectUtils.getByPath(_profile, 'search-options');
        });
      },

      widgets: function (componentName, componentId) {
        return _component(componentName, "widget-configurations", componentId).then(function (component) {
          return atex.onecms.ObjectUtils.getByPath(component, "widgets") || [];
        });
      },

      domainWidget: function (componentName, componentId, type, id) {
        return this.widgets(componentName, componentId).then(function (widgets) {
          return _.find(widgets, function (widget) {
            return (widget.type === type && widget.id === id);
          }) || {};
        });
      },

      save: function (_profile) {
        return AuthenticationService.callWithAuthentication(function () {
          var url = '/onecms/configuration/profile/me/desk';
          return $http.post(url, _profile);
        });
      },

      profile: function () {
        return profile();
      },

      userprofile: function(path,_profile) {
        if (_profile) {
          return $q.when(atex.onecms.ObjectUtils.getByPath(_profile, path));
        } else {
          return _userprofile(path);
        }
      },

      updateContentWithPermissionChecks: function(entry, data, field, path, lambdaFunction) {
        return updateContentWithPermissionChecks(entry, data, field, path, lambdaFunction);
      },

      getUsersInfo: function() {
        return usersInfo;
      },

      getStatusTextColor: function(status) {
        return getStatusTextColor(status);
      }
    };
  }]).directive('uiField', ['UIConfigurationService', function (UIConfigurationService) {
  return {
    restrict: 'A',

    link: function (scope, element, attrs) {
      scope.$on('$destroy', function () {
        element.remove();
      });

      UIConfigurationService.field(attrs.componentName, attrs.componentId, attrs.fieldId).then(function (configuration) {
        if (!configuration.visibility) {
          element.remove();
        }
      });
    }
  };
}]).directive('uiLinkOperation', ['$q', 'UserProfileService', 'UIConfigurationService', 'DamTemplateService',
  function($q, UserProfileService, UIConfigurationService, DamTemplateService) {
    return {
      restrict: 'ACE',
      templateUrl: 'views/ui-configuration/operation/link-operation.html',

      scope: {
        componentName: "@",
        componentId: "@",
        linkStyle: "@",
        defaultText: "@",
        text: "@",
        entry: "="
      },

      controller: function ($scope) {
        function isEditDisabled() {
          if ($scope.componentId === "desk-edit") {
            return UserProfileService.disableAction({'action': 'edit', 'application': 'desk', 'data': $scope.entry._data});
          } else {
            $q.when(false);
          }
        }

        UIConfigurationService.operation($scope.componentName, $scope.componentId).then(function (_operation) {
          isEditDisabled().then(function (status) {
            $scope.editEnabled = (status) ? false : true;
            var template = atex.onecms.ObjectUtils.getByPath($scope.entry, "_data/aspects/contentData/data/inputTemplate");

            if (_operation && template) {
          $scope.operationTmp = (_operation.templates[0] !== "*") ? (_operation.templates.indexOf(template) > -1) ? _operation : undefined : _operation;

          if ($scope.operationTmp && $scope.operationTmp.callback) {
                DamTemplateService.getActTemplateFor($scope.entry, false).then(function (templates) {
                  if (templates.length === 0) {
                    $scope.operation = undefined;
              }else{
                $scope.operation = $scope.operationTmp;
                  }
                });
          }else{
            $scope.operation = $scope.operationTmp;
              }
            }
          });
        });
      },

      link: function (scope, element) {
        scope.$on('$destroy', function () {
          element.remove();
        });

        scope.edit = function (entries) {
          UIConfigurationService.edit(entries, true);
        };
      }
    };
  }]).directive('uiCss', ['UIConfigurationService', function (UIConfigurationService) {
  return {
    restrict: 'A',

    link: function (scope, element, attrs) {
      scope.$on('$destroy', function () {
        element.remove();
      });

      function build(configuration) {
        var css = configuration.selector + '{';

        angular.forEach(configuration.properties, function (property) {
          css = css + property;
        });

        return css + "}";
      }

      UIConfigurationService.css(attrs.componentName, attrs.componentId).then(function (_configurations) {
        angular.forEach(_configurations, function (_configuration) {
          $("<style>").prop("type", "text/css").html(build(_configuration)).appendTo("head");
        });
      });
    },
  };
}]).directive('uiResultSetField', ['UIConfigurationService', function (UIConfigurationService) {
  return {
    restrict: 'A',

    link: function (scope, element, attrs) {
      scope.$on('$destroy', function () {
        element.remove();
      });

      UIConfigurationService.resultSet(attrs.componentName, attrs.componentId, attrs.position, attrs.fieldId).then(function (configuration) {
        if (!configuration.visibility) {
          element.remove();
        }
      });
    }
  };
}]).directive('uiSearchForm', ['$q', '$rootScope', '$injector', 'UIConfigurationService', 'DamFoldersService',
  function ($q, $rootScope, $injector, UIConfigurationService, DamFoldersService) {
  return {
    restrict: 'ACE',
    templateUrl: 'views/ui-configuration/search-form/template.html',
    replace: true,

    scope: {
      componentName: "@",
      componentId: "@",
      profile: "@",
      queryModel: "=",
      properties: "=",
      onUiExec: "&",
      onChange: "&",
      queryId: "@"
    },

    controller: function ($scope) {

      var ADMUtils;

      function findComponentInFields( _fields, componentId ) {
        var field;

        if ( _fields && !_.isEmpty( componentId ) ) {
          if (_.isArray(_fields)) {
            _.each(_fields, function (_field) {
              if (_.isObject(_field)) {
                if (_field.componentId === componentId) {
                  field = _field;
                }
              }
            });
          }
        }

        return field;
      }

      function findField( _form, componentId ) {
        var field;

        if ( _form && !_.isEmpty( componentId ) ) {
          var _sections = atex.onecms.ObjectUtils.getByPath(_form, "sections");

          _.each(_sections, function (_section) {
            var _field = findComponentInFields(atex.onecms.ObjectUtils.getByPath(_section, "fields"), componentId);

            if (_field) {
              field = _field;
            }
          });
        }

        return field;
      }

      function findAttributeInFields( _fields, attribute ) {
        var field;

        if (_.isArray(_fields)) {
          _.each(_fields, function (_field) {
            if (_.isObject(_field)) {
              var model = atex.onecms.ObjectUtils.getByPath(_field, "value/model/attribute");
              if (model === attribute) {
                field = _field;
              }
            }
          });
        }

        return field;
      }

      function findModelField( _form, attribute, uiForm ) {
        var field;

        if ( _form && !_.isEmpty( attribute ) ) {
          var _sections = atex.onecms.ObjectUtils.getByPath(_form, "sections");

          _.each(_sections, function (_section) {
            var _field = findAttributeInFields(atex.onecms.ObjectUtils.getByPath(_section, "fields"), attribute);

            if (_field) {
              field = _field;
            }
          });

          if ( !field && uiForm && _.isObject(uiForm) ) {
            field = findAttributeInFields(atex.onecms.ObjectUtils.getByPath(uiForm, "fields"), attribute);
           }

          if ( !field && uiForm ) {
            field = findModelField( uiForm, attribute );
          }

        }

        return field;
      }

      function findSection( _form, componentId ) {
        var foundSection = {};

        if ( _form && !_.isEmpty( componentId ) ) {
          var _sections = atex.onecms.ObjectUtils.getByPath(_form, "sections");

          _.each(_sections, function (_section) {
            if ( _section.componentId === componentId ) {
              foundSection = _section;
            }
          });
        }

        return foundSection;
      }

      function processSections(_form, uiForm) {
        var formChanged = false;
        var newSections = atex.onecms.ObjectUtils.getByPath( uiForm, 'sections') || [];

        if (_.isArray(newSections) && !_.isEmpty(newSections)) {
          _.each(newSections, function (newSection) {
            var foundSection = findSection(_form, newSection.componentId);

            if (_.isEmpty(foundSection)) {
              _form.sections.push(angular.copy(newSection));
              formChanged = true;
            }
          });
        }

        return formChanged;
      }

      $scope.addedFields = {};

      function isFieldAdded( field_id ) {
        return $scope.addedFields[field_id];
      }

      function addField(field) {
        var componentId = _.isObject(field) ? field.componentId : field;
        var field_name = componentId.replace("desk-", "");
        var field_id = "desk-" + field_name;


        if ( _.isString( field ) ) {
          $scope.addedFields[field_id] = { name: field_name, componentId: field_id };
        } else {
          $scope.addedFields[field_id] = field;
        }
      }

      function removeField(field) {
        var componentId = _.isObject(field) ? field.componentId : field;
        var field_name = componentId.replace("desk-", "");
        var field_id = "desk-" + field_name;

        delete $scope.addedFields[field_id];
      }


      function processClearGroups(_form, uiForm) {
        var formChanged = false;
        var groups = atex.onecms.ObjectUtils.getByPath( uiForm, 'clearGroups');

        if ( _form && groups ) {
          _.each(groups, function (group) {
            var _sections = atex.onecms.ObjectUtils.getByPath(_form, "sections");

            _.each(_sections, function (_section) {
              var _fields = atex.onecms.ObjectUtils.getByPath(_section, "fields");

              if (_.isArray(_fields)) {
                var index = -1;

                while ( ++index < _fields.length ) {
                  var _field = _fields[index];

                  if (_.isObject(_field) && _field.group === group) {
                    removeField(_field);
                    _fields.splice(index, 1);
                    index--;
                    formChanged = true;
                  }
                }
              }
            });
          });
        }

        return formChanged;
      }

      function processNewFields(_form, uiForm, resolvedFields, wantedFields ) {
        var formChanged = false;
        var newFields = atex.onecms.ObjectUtils.getByPath(uiForm, "fields");

        _.each(newFields, function (newField) {
          var componentId = _.isObject(newField) ? newField.componentId : newField;
          var field_name = componentId.replace("desk-", "");
          var field_id = "desk-" + field_name;

          var field_found = _.find(resolvedFields, function (fld) {
            return fld && fld.componentId === field_id;
          });

          if (  !field_found && !isFieldAdded( field_id ) ) {
            addField( newField );

            var value_type = atex.onecms.ObjectUtils.getByPath(newField, "value/type");

            if ( !_.isEmpty( value_type ) ) {
              if ( newField && newField.configuration ) {
                newField.configuration.useUiForm = true;
              }
              field_found = newField;
            }
          }

          if ( field_found ) {
            var sectionId = atex.onecms.ObjectUtils.getByPath(newField, "section");
            var foundSection = findSection(_form, sectionId);

            if ( !_.isEmpty( foundSection ) ) {
              if ( !_.isArray( foundSection.fields ) ) {
                foundSection.fields = [];
              }
              foundSection.fields.push( field_found );
            } else {
              _form.sections[0].fields.push( field_found );
            }

            formChanged = true;
          }
        });

        return formChanged;
      }

      function processNewModel(_form, uiForm) {
        var formChanged = false;
        var uiModel = atex.onecms.ObjectUtils.getByPath( uiForm, 'uiModel') || [];

        if (!ADMUtils) {
          ADMUtils = $injector.get("ADMUtils");
        }

        if ( !ADMUtils ) {
          return false;
        }

        if ( uiModel && !_.isEmpty( uiModel.values ) ) {
          if ( !_.isObject( $scope.queryModel.values ) ) {
            $scope.queryModel.values = {};
          }

          if ( !_.isArray( $scope.queryModel.clearValues ) ) {
            $scope.queryModel.clearValues = {};
          }

          if ( !_.isObject( $scope.queryModel.readOnly ) ) {
            $scope.queryModel.readOnly = {};
          }

          if ( !_.isArray( $scope.queryModel.forPrint ) ) {
            $scope.queryModel.forPrint = [];
          }

          if ( _.isArray( uiModel.forPrint) && !_.isEmpty( uiModel.forPrint) ) {
            $scope.queryModel.forPrint = _.union($scope.queryModel.forPrint, uiModel.forPrint);
          }

          _.each( uiModel.values, function( model, key ) {
            var modelValues = atex.onecms.ObjectUtils.getByPath($scope.queryModel, "values/" + key);
            var values = model.values.configurations;

            if ( !modelValues && values ) {
              $scope.queryModel.values[key] = values;
              modelValues = atex.onecms.ObjectUtils.getByPath($scope.queryModel, "values/" + key);
            }

            if ( modelValues ) {
              if ( values && !UIConfigurationService.isModelEqual( modelValues, values ) ) {
                $scope.queryModel.values[key] = values;
              }
            }

            var selectKey = atex.onecms.ObjectUtils.getByPath($scope.queryModel, "set/" + key);

            var modelType;
            var _field = findModelField(_form, key, uiForm);

            if (_field) {
              modelType = atex.onecms.ObjectUtils.getByPath(_field, "value/model/type");
            }

            if ( modelType && model.value && selectKey && !ADMUtils.ModelUtils.isType( selectKey, modelType) ) {
              model.pmodified = true;
              selectKey = ADMUtils.ModelUtils.initValue(modelType);
              $scope.queryModel.set[key] = selectKey;
            }

            if ( model.pmodified ) {
              if (model.value) {
                if (typeof selectKey === "undefined") {
                  selectKey = ADMUtils.ModelUtils.initValue(modelType);
                  $scope.queryModel.set[key] = selectKey;
                }
                if (_.isObject(selectKey)) {
                  if (selectKey.id) {
                    if (selectKey.id !== model.value) {
                      selectKey.id = model.value;
                      selectKey.label = model.value;
                      selectKey.text = model.value;
                    }
                  } else {
                    selectKey.id = model.value;
                    selectKey.label = model.value;
                    selectKey.text = model.value;
                  }
                }
                if (_.isString(selectKey)) {
                  $scope.queryModel.set[key] = model.value;
                }
              } else {
                if ($scope.queryModel.set) {
                  delete $scope.queryModel.set[key];
                }
              }
            }

            $scope.queryModel.clearValues[key] = model.clear;
            $scope.queryModel.readOnly[key] = model.readOnly;
          });
        }

        return formChanged;
      }

      function processQueries(_form, uiForm) {
        var formChanged = false;
        var uiModel = atex.onecms.ObjectUtils.getByPath( uiForm, 'uiModel') || [];

        if ( _form  ) {
          var _sections = atex.onecms.ObjectUtils.getByPath(_form, "sections");

          _.each(_sections, function (_section) {
            var _fields = atex.onecms.ObjectUtils.getByPath(_section, "fields");

            if (_.isArray(_fields)) {
              _.each(_fields, function (_field) {
                if (_.isObject(_field)) {
                  var uiQuery = atex.onecms.ObjectUtils.getByPath(_field, "configuration/uiQuery");
                  var attribute = atex.onecms.ObjectUtils.getByPath(_field, "value/model/attribute");

                  if (uiQuery && attribute) {
                    $scope.remoteModelCache.uiQueries[attribute] = true;
                  }
                }
              });
            }
          });

          if (uiModel && !_.isEmpty(uiModel.values)) {
            _.each(uiModel.values, function (model, key) {
              var _field = findModelField(_form, key);
              if (_field) {
                var uiQuery = atex.onecms.ObjectUtils.getByPath(_field, "configuration/uiQuery");

                if (uiQuery) {
                  $scope.remoteModelCache.uiQueries[key] = true;
                }

                if ( !_.isEmpty( model.placeholder ) ) {
                  var placeholder = atex.onecms.ObjectUtils.getByPath(_field, "value/placeholder");

                  if ( placeholder !== model.placeholder ) {
                    if ( !_field.value ) {
                      _field.value = {};
                    }
                    _field.value.placeholder = model.placeholder;
                  }
                }
              }
            });
          }
        }

        return formChanged;
      }

      function processUiRequest( uiForm, resolvedFields, wantedFields ) {
        var formChanged = false;
        var form = angular.copy($scope.form);

        if ( processClearGroups( form, uiForm ) ) {
          formChanged = true;
        }

        if ( processSections( form, uiForm ) ) {
          formChanged = true;
        }

        // Now we need to Add all the chanegd Selections
        if ( processNewModel( form, uiForm ) ) {
          formChanged = true;
        }

        if ( processNewFields( form, uiForm, resolvedFields ) ) {
          formChanged = true;
        }

        if ( processQueries( form, uiForm ) ) {
          formChanged = true;
        }

        // Now we need to Add all the chanegd models

        if ( formChanged ) {
          $scope.form = form;
        }
      }

      $scope.remoteModelCache = {
        urls: [],
        uiQueries: {},
        queryModel: $scope.queryModel,
        uiRequestInProgress: false,
        uiRequests: []
      };

      $scope.foldersService = DamFoldersService;

      $scope.changed = function () {
        if ($scope.onChange) {
          $scope.onChange();
          $rootScope.$broadcast('uiSearchForm:changed', $scope.queryModel);
        }
      };

      $scope.uiRequest = function ( uiForm ) {
        if ( uiForm ) {
          var newFields = atex.onecms.ObjectUtils.getByPath(uiForm, "fields");
          var promises = [];
          var wantedFields = [];


          if (_.isArray(newFields) && !_.isEmpty(newFields)) {
            _.each(newFields, function (newField) {
              var componentId = _.isObject(newField) ? newField.componentId : newField;
              var field_name = componentId.replace("desk-", "");
              var field_id = "desk-" + field_name;
              var field = findField($scope.form, field_id);

              if (_.isEmpty(field)) {
                promises.push(UIConfigurationService.formField(field_name, field_id));
                wantedFields.push(field_id);
              }
            });

          }

          $q.all(promises).then(function (resolvedFields) {
            processUiRequest( uiForm, resolvedFields, wantedFields );
          });
        }
      };

      $scope.onUiExec = $scope.onUiExec();
      if (!$scope.onUiExec) {
        $scope.onUiExec = function (id) {
        };
      }

      UIConfigurationService.form($scope.componentName, $scope.componentId, $scope.profile).then(function (_form) {
        // search-fields
        var promises = [];

        var _sections = atex.onecms.ObjectUtils.getByPath(_form, "sections");

        _.each(_sections, function (_section) {
          var _fields = atex.onecms.ObjectUtils.getByPath(_section, "fields");

         // var fields = [];

          if ( _.isArray(_fields) ) {
            _.each(_fields, function (_field) {
              if ( _.isString(_field) ) {
                var field_name = _field;
                var field_id = 'desk-' + _field;

                promises.push( UIConfigurationService.formField(field_name, field_id) );
              }
            });
          }
        });

        $q.all(promises).then(function (fields) {
          _.each(_sections, function (_section) {
            var _fields = atex.onecms.ObjectUtils.getByPath(_section, "fields");

            // var fields = [];

            if ( _.isArray(_fields) ) {
              _.each(_fields, function (_field, key) {
                if ( _.isString(_field) ) {
                  var field_name = _field;
                  var field_id = 'desk-' + _field;


                  var field_found = _.find(fields, function (fld) {
                    return _.isObject(fld) && fld.componentId === field_id;
                  });

                  if ( field_found ) {
                    _fields[key] = field_found;
                  }
                }
              });
            }
          });
          $scope.form = _form;
        });
      });
    },

    link: function (scope, element) {
      scope.$on('$destroy', function () {
        element.remove();
      });
    }
  };
}]).directive('uiSearchField', ['$q', '$injector', '$rootScope', '$timeout',
          'UIConfigurationService', 'ContentConfigurationService',
  function($q, $injector, $rootScope, $timeout,
           UIConfigurationService, ContentConfigurationService) {
  return {
    restrict: 'ACE',
    template: '<div ng-include="getContentUrl()"></div>',
    replace: true,

    scope: {
      queryModel: "=",
      properties: "=",
      field: "=",
      onUiRequest: "&",
      onUiExec: "&",
      onChange: "&"
    },

    controller: function ($scope) {
      $scope.focused = false;

      $scope.onUiRequest = $scope.onUiRequest();
      if (!$scope.onUiRequest) {
        $scope.onUiRequest = function (uiForm) {
        };
      }

      $scope.onUiExec = $scope.onUiExec();
      if (!$scope.onUiExec) {
        $scope.onUiExec = function (id) {
        };
      }

      var empty = {id: "", name: ""};
      var PrintService;

      function collapseByField(array, field) {
        var newArray = [];
        array.forEach(function (obj) {
          var found = _.find(newArray, function (newObj) {
            return newObj[field] === obj[field];
          });
          if (found) {
            if (found.color && found.color !== obj.color) {
              found.color = "none";
            }
          } else {
            newArray.push(obj);
          }
        });
        return newArray;
      }

      function createLocalModel(inArray, _field) {
        var cfgKey = atex.onecms.ObjectUtils.getByPath(_field, "configuration/cfg-key") || 'id';
        var cfgValuesMap = atex.onecms.ObjectUtils.getByPath(_field, "configuration/cfg-values-map");
        var cfgCollapseField = atex.onecms.ObjectUtils.getByPath(_field, "configuration/cfg-collapse-field");
        var outArray = [];
        inArray.forEach(function (entry, key) {
          var _key = entry[cfgKey] || key;
          var field = {};
          if (cfgValuesMap) {
            _.each(cfgValuesMap, function (f, k) {
              field[k] = entry[f];
            });
          } else {
            field = entry;
          }
          outArray.push(UIConfigurationService.toJson(_key, field));
        });
        if (cfgCollapseField) {
          outArray = collapseByField(outArray, cfgCollapseField);
        }
        return outArray;
      }

      function model(terms) {
        var externalID = atex.onecms.ObjectUtils.getByPath($scope.field, "configuration/cfg-ext-id");
        if (externalID) {
          var cfgListPath = atex.onecms.ObjectUtils.getByPath($scope.field, "configuration/cfg-list-path") || '';
          UIConfigurationService.loadCfgContent(externalID, cfgListPath).then(function (cfgList) {
            var newCfgList = createLocalModel(cfgList, $scope.field);
            terms.forEach(function (term, key) {
              if (key % 2 === 0) {
                var entry = _.find(newCfgList, function (cfg) {
                  return cfg['id'] === term;
                });
                if (entry) {
                  $scope.model.push(entry);
                }
              }
            });
            UIConfigurationService.getSearchOptions().then(function (options) {
              atex.dam.AngularUtils.highlightInputFields(atex.onecms.ObjectUtils.getByPath(options, 'defaultHighlightInputCss') || "");
            });
          });
        } else {
          var info = atex.onecms.ObjectUtils.getByPath($scope.field, "configuration/field-configuration") || empty;
          var ignoreIds = atex.onecms.ObjectUtils.getByPath($scope.field, "configuration/field-configuration/ignore-id") || [];

          UIConfigurationService.configurations(info).then(function (configuration) {
            terms.forEach(function (term, key) {
              if (key % 2 === 0) {
                var entry = atex.onecms.ObjectUtils.getByPath(configuration, "configurations/" + term);
                if (entry) {
                  if (!_.contains(ignoreIds, term)) {
                    $scope.model.push(UIConfigurationService.toJson(term, entry));
                  }
                } else if ($scope.field.configuration['use-lookup-values']) {
                  $scope.model.push({id: term, label: term, text: true});
                }
              }
            });
            UIConfigurationService.getSearchOptions().then(function (options) {
              atex.dam.AngularUtils.highlightInputFields(atex.onecms.ObjectUtils.getByPath(options, 'defaultHighlightInputCss') || "");
            });
          });
        }
      }

      function configuration(info) {
        return UIConfigurationService.configurations(info).then(function (configuration) {
          return atex.onecms.ObjectUtils.getByPath(configuration, "configurations") || [];
        });
      }

      function tags(configId, level) {
        var deferred = $q.defer();

        var tags = [];
        ContentConfigurationService.getConfiguration({id: "externalid/" + configId}).then(function (content) {
          var publications = atex.onecms.ObjectUtils.getByPath(content, 'data/aspects/contentData/data/publications') || [];

          _.each(publications, function (publication, key) {
            if (!key.endsWith("_type") && !key.endsWith("_types")) {
              if (publication.level === level) {
                tags.push(UIConfigurationService.toJson(publication.id, publication));
              }
            }
          });

          deferred.resolve(tags);
        });

        return deferred.promise;
      }

      function pick(id, parents, level, model) {
        tags(id, level).then(function (_tags) {
          _.each(_tags, function (_tag, key) {
            if (_.contains(parents, _tag.parent)) {
              $scope.model.push(_tag);
            }
          });

          var objects = atex.onecms.ObjectUtils.getByPath($scope.queryModel, "set/" + model);
          if (objects) {
            $scope.queryModel.set[model] = _.filter(objects, function (object) {
              return _.findWhere($scope.model, {id: object.id});
            });
          }
        });
      }

      function all(id, level) {
        tags(id, level).then(function (_tags) {
          _.each(_tags, function (_tag) {
            $scope.model.push(_tag);
          });
        });
      }

      function filter(configId) {
          $scope.model = [];

          var level = atex.onecms.ObjectUtils.getByPath($scope.field, "configuration/level");
          var parent = atex.onecms.ObjectUtils.getByPath($scope.field, "configuration/parent");
          var model = atex.onecms.ObjectUtils.getByPath($scope.field, "value/model/attribute");

          if (parent) {
            var parents = atex.onecms.ObjectUtils.getByPath($scope.queryModel, "set/" + parent) || [];

            parents = _.map(parents, function (parent) {
              return parent.id;
            });

            pick(configId, parents, level, model);
          } else {
            all(configId, level);
          }
        }

      function valid(value) {
        var valid = false;

        if (value) {
          if (Array.isArray(value)) {
            valid = value.length > 0;
          } else if (typeof value === "object") {
            valid = Object.keys(value).length > 0;
          }
        }

        return valid;
      }

      function clean(keys) {
        var values = [];

        if (Array.isArray(keys)) {
          values = _.map(keys, function (key) {
            return key.id;
          });
        } else if (typeof keys === "object") {
          values.push(keys.id || keys);
        }

        return values;
      }

      function updateUiForm( ) {
        var attribute = atex.onecms.ObjectUtils.getByPath($scope.field, "value/model/attribute");
        var newModel = [];
        var modelValues = atex.onecms.ObjectUtils.getByPath($scope.queryModel, "values/" + attribute);

        if ( modelValues ) {
          _.each(modelValues, function (value) {
            var key = value.id ? value.id : value.name;
            newModel.push(UIConfigurationService.toJson(key, value));
          });

          if ( !UIConfigurationService.isModelEqual( $scope.model, newModel ) ) {
            $scope.model.length = 0;
            _.each(newModel, function (field) {
              $scope.model.push(field);
            });
          }
        }
      }

      function getUIModel( queryModel, lastModel, attribute, uiQueries ) {
        var uiModel = {
          initial: false,
          modified: false,
          values: {}
        };
        var clearValues = queryModel.clearValues || {};
        var readOnly = queryModel.readOnly || {};
        var forPrint = queryModel.forPrint || [];

        if ( _.isObject( queryModel.set ) ) {
          _.each(queryModel.set, function (keys, key) {
            var value;

            if (valid(keys)) {
              keys = clean(keys);

              if (_.isArray(keys) && !_.isEmpty(keys) && keys[0] && typeof keys[0].id !== 'undefined') {
                keys[0] = keys[0].id;
              }

              value = keys.join("@@SEPARATOR@@");
            } else if (_.isString(keys)) {
              value = keys;
            }

            if (typeof value !== "undefined") {
              var modified = false;
              var processModel = false;

              if (!(lastModel && lastModel.values)) {
                processModel = true;
                uiModel.initial = true;
              }

              if (uiQueries && uiQueries[key]) {
                processModel = true;
              }

              var isForPrint = _.isEmpty( forPrint );

              if ( !isForPrint ) {
                isForPrint =  _.find(forPrint, function (entry) {
                  return entry === key;
                });
              }

              if ( isForPrint ) {
                if (processModel) {
                  var lastKey = {
                    name: key,
                    value: ""
                  };

                  if (lastModel && lastModel.values && lastModel.values[key]) {
                    lastKey = lastModel.values[key];
                  }

                  modified = value !== lastKey.value;
                }

                var modelValue = {
                  name: key,
                  value: value,
                  focus: key === attribute,
                  modified: modified,
                  clear: clearValues[key] || false,
                  readOnly: readOnly[key] || false
                };

                uiModel.values[key] = modelValue;

                if (modelValue.modified) {
                  uiModel.modified = true;
                }
              }
            }
          });

          if (_.isObject(lastModel) && lastModel.values) {
            _.each(lastModel.values, function (keys, key) {

              if ( typeof uiModel.values[key] === 'undefined') {
                var lastKey;

                if (lastModel && lastModel.values && lastModel.values[key]) {
                  lastKey = lastModel.values[key];
                }

                if ( lastKey && !_.isEmpty(lastKey.value) ) {
                  var modelValue = angular.copy(keys);

                  modelValue.value = "";
                  modelValue.modified = true;

                  uiModel.values[key] = modelValue;
                  uiModel.modified = true;
                }
              }
            });
          }
        }

        return uiModel;
      }

      function getParentMember( scope, memberIn ) {
        var gotMember;
        var memberScope = scope;
        var member = memberIn || "form";

        while ( memberScope && !_.isObject( memberScope[member] ) ) {
          memberScope = memberScope.$parent;
        }

        if ( memberScope && _.isObject( memberScope[member] ) ) {
          gotMember = memberScope[member];
        }

        return gotMember;
      }

      function remote(info) {
        var uiRequestStart = function( remoteModelCache, info, uiModel ) {
          if (remoteModelCache) {
            if (remoteModelCache.uiRequestInProgress) {
              var found = _.find(remoteModelCache.uiRequests, function (entry) {
                return entry.url === info.url;
              });

              if ( !found ) {
                remoteModelCache.uiRequests.push(info);
              }

              return false;
            }

            remoteModelCache.lastUiModel = remoteModelCache.uiModel;
            remoteModelCache.uiModel = uiModel;
            remoteModelCache.uiRequestInProgress = true;
          }

          return true;
        };

        var uiRequestEnd = function( remoteModelCache ) {
          if (remoteModelCache) {
            remoteModelCache.uiRequestInProgress = false;

            if ( !_.isEmpty(remoteModelCache.uiRequests) ) {
              var info = remoteModelCache.uiRequests.splice(0,1);

              remote( info );
            }

          }
        };

        var copyModel = atex.onecms.ObjectUtils.getByPath($scope.field, "value/copy-model");
        var params = atex.onecms.ObjectUtils.getByPath($scope.field, "configuration/path-params") || [];
        var attribute = atex.onecms.ObjectUtils.getByPath($scope.field, "value/model/attribute");

        _.each(params, function (param) {
          var keys = atex.onecms.ObjectUtils.getByPath($scope.queryModel, "set/" + param.key);

          if (valid(keys)) {
            keys = clean(keys);
            info.url = info.url.replace(param.path, keys.join("@@SEPARATOR@@"));
          } else {
            $scope.model = [];
            if ($scope.queryModel.set) {
              delete $scope.queryModel.set[info.attribute];
            }

            info.valid = false;
          }
        });

        if (info.valid) {
          if ( info.url.includes('/handj/content') && $scope.queryModel ) {
            var _remoteModelCache = getParentMember($scope, "remoteModelCache");
            var lastUiModel = _remoteModelCache ? _remoteModelCache.uiModel : {};
            var uiQueries = _remoteModelCache ? _remoteModelCache.uiQueries : {};
            var isGetRequest = info.url.toLowerCase().includes('/handj/content/uiget');
            var uiModel = getUIModel( $scope.queryModel, lastUiModel, attribute, uiQueries );

            if ( uiModel.modified ) {
              if ( !uiRequestStart( _remoteModelCache, info, uiModel ) ) {
                return;
              }

              if (!PrintService) {
                try {
                  PrintService = $injector.get("PrintService");
                } catch ( error ) {
                  console.log("Unable to inject PrintService error = ", error );
                }
              }

              if (!PrintService) {
                return;
              }

              PrintService.uiRequest(info.url, {}, isGetRequest ? undefined : uiModel ).then(function (response) {
                var uiForm = atex.onecms.ObjectUtils.getByPath(response, 'data/UIForm');
                if ($scope.onUiRequest && uiForm ) {
                  $scope.onUiRequest(uiForm);
                }

                updateUiForm();

                var uiExecs = [];
                var uiExec = atex.onecms.ObjectUtils.getByPath(uiForm, "uiModel/uiExec");

                if ( _.isObject( uiExec ) && !_.isEmpty(uiExec.id) ) {
                  uiExecs.push(uiExec);
                } else if ( _.isArray( uiExec ) ) {
                  uiExecs = uiExec;
                }
                _.each( uiExecs,function (exec) {
                  if ( _.isObject( exec ) && !_.isEmpty(exec.id) ) {
                    $timeout( function( ) {
                      $scope.onUiExec(exec);
                    }, uiExec.timeout );
                  }
                });

                uiRequestEnd( _remoteModelCache );
               }).catch(function(err) {
                uiRequestEnd( _remoteModelCache );
              });
            } else {
              updateUiForm();
            }
          } else {
            UIConfigurationService.remote(info.url).then(function (response) {
              var values = response.data || [];
              if (!_.isEqual(values, _.pluck($scope.model, 'id'))) {
                $scope.model = [];
                _.each(values, function (value) {
                  var contents = _.findWhere($scope.model, {id: value});
                  if (!contents) {
                    $scope.model.push({id: value, label: value, text: value});
                  }
                });
              }
              if (copyModel) {
                if (!$scope.queryModel.model) {
                  $scope.queryModel.models = {};
                }

                var keys = atex.onecms.ObjectUtils.getByPath($scope.queryModel, "set/" + copyModel.key);
                if (valid(keys)) {
                  keys = clean(keys);
                  $scope.queryModel.models[info.attribute] = keys;
                }
              }

              if ($scope.model.length === 0) {
                if ($scope.queryModel.set) {
                  delete $scope.queryModel.set[info.attribute];
                }
              }
            });
          }
        }
      }

      $scope.updateConfiguredField = function () {
        if ($scope.field.configuration) {

          $scope.model = [];
          $scope.configuration = {};

          var configured = atex.onecms.ObjectUtils.getByPath($scope.field, "configuration/use-configured-values") || false;

          if (configured) {
            var externalID = atex.onecms.ObjectUtils.getByPath($scope.field, "configuration/cfg-ext-id");
            var _field = atex.onecms.ObjectUtils.getByPath($scope.field, "configuration/field-configuration");
            var ignoreIds = atex.onecms.ObjectUtils.getByPath($scope.field, "configuration/field-configuration/ignore-id") || [];
            var _model = atex.onecms.ObjectUtils.getByPath($scope.field, "configuration/model-configuration");
            var configId = atex.onecms.ObjectUtils.getByPath($scope.field, "configuration/configuration-id");
            var configUrl = atex.onecms.ObjectUtils.getByPath($scope.field, "configuration/configuration-url");
            var _fields = atex.onecms.ObjectUtils.getByPath($scope.field, "configuration/fields-configuration");
            var attribute = atex.onecms.ObjectUtils.getByPath($scope.field, "value/model/attribute");
            var uiQuery = atex.onecms.ObjectUtils.getByPath($scope.field, "configuration/uiQuery");
            var uiMethod= atex.onecms.ObjectUtils.getByPath($scope.field, "configuration/uiMethod") === 'GET' ? "uiGet" : "uiQuery";
            var useUiForm = atex.onecms.ObjectUtils.getByPath($scope.field, "configuration/useUiForm");

            if (uiQuery) {
              configUrl = "/onecms/layout/handj/content/"  + uiMethod + "/" + uiQuery;
            }

            if (externalID) {
              var cfgListPath = atex.onecms.ObjectUtils.getByPath($scope.field, "configuration/cfg-list-path") || '';
              UIConfigurationService.loadCfgContent(externalID, cfgListPath).then(function (cfgList) {
                $scope.model = createLocalModel(cfgList, $scope.field);
              });
            }  else if ( useUiForm ) {
              updateUiForm();
            } else if (_field) {
              configuration(_field).then(function (fields) {
                _.each(fields, function (field, key) {
                  if (!_.contains(ignoreIds, key)) {
                    $scope.model.push(UIConfigurationService.toJson(key, field));
                  }
                });
              });
            } else if (_model) {
              configuration(_model).then(function (config) {
                $scope.configuration = config;
              });
            } else if (configId) {
              filter(configId);
            } else if (configUrl) {
              if(_fields) {
                configuration(_fields).then(function (config) {
                  $scope.presets = [];
                  _.each(config, function (_config, key) {
                    $scope.presets.push(UIConfigurationService.toJson(key, _config));
                  });
                  remote({url: configUrl, attribute: attribute, valid: true});
                });
              } else {
                remote({url: configUrl, attribute: attribute, valid: true});
              }
            }
          } else {
            var term = atex.onecms.ObjectUtils.getByPath($scope.field, "value/model/attribute") || "";
            UIConfigurationService.terms(term).then(function (response) {
              var terms = atex.onecms.ObjectUtils.getByPath(response, "data/terms/" + term) || [];
              model(terms);
            });
          }
        }
      };

      $scope.modelChanged = function () {
        var configId = atex.onecms.ObjectUtils.getByPath($scope.field, "configuration/configuration-id");
        var attribute = atex.onecms.ObjectUtils.getByPath($scope.field, "value/model/attribute");
        var configUrl = atex.onecms.ObjectUtils.getByPath($scope.field, "configuration/configuration-url");
        var uiQuery = atex.onecms.ObjectUtils.getByPath($scope.field, "configuration/uiQuery");
        var uiMethod= atex.onecms.ObjectUtils.getByPath($scope.field, "configuration/uiMethod") === 'GET' ? "uiGet" : "uiQuery";

        if (uiQuery) {
          configUrl = "/onecms/layout/handj/content/"  + uiMethod + "/" + uiQuery;
        }

        if (configId) {
          filter(configId);
        } else if (configUrl) {
          remote({url: configUrl, attribute: attribute, valid: true});
        }

        if ($scope.onChange) {
          $scope.onChange();
        }
      };


      $scope.$watch("queryModel", function (newValue, oldValue) {
        if (newValue !== oldValue) {
            //$scope.queryModel = newValue;

            var attribute = atex.onecms.ObjectUtils.getByPath($scope.field, "value/model/attribute");

            if ( attribute ) {
              var oldModelValues = atex.onecms.ObjectUtils.getByPath(oldValue, "values/" + attribute);
              var newModelValues = atex.onecms.ObjectUtils.getByPath(newValue, "values/" + attribute);

              if ( oldModelValues && newModelValues ) {
                updateUiForm();
              }
            }

            $scope.modelChanged();
          }
        }, true);

        $scope.updateConfiguredField();
      },

      link: function (scope, element) {

        scope.fieldClass = function(field) {
          var classTypes = [];

          var value = field.value || {};
          var fieldType = value.type;
          if (fieldType) {
            classTypes.push("search-field-type-" + fieldType.toLowerCase()
            .replace(/[_.]/g, "-"));
          }
          var model = value.model || {};
          var attribute = model.attribute;
          if (attribute) {
            classTypes.push("search-field-attr-" + attribute.toLowerCase()
            .replace(/[_.]/g, "-"));
          }

          return classTypes.join(' ');
        };

        scope.$on('$destroy', function () {
          element.remove();
        });

        scope.parentOperation = function(show, id) {
          if (show) {
            $(id? '.' + id :'.parent-visibility').show();
          } else {
            $(id? '.' + id :'.parent-visibility').hide();
          }
        };

        scope.updateFocused = function (focus) {
          scope.focused = focus;
          if(!scope.$$phase) {
            scope.$apply();
          }
        };

        scope.change = function () {
          var value = atex.onecms.ObjectUtils.getByPath(scope.queryModel, "set/" + scope.field.value.model.attribute);
          if (!value) {
            if (scope.queryModel.operators) {
              delete scope.queryModel.operators[scope.field.value.model.attribute];
            }

            scope.focused = false;
          }
        };

        scope.formButton = function (view) {
          var uiExec = atex.onecms.ObjectUtils.getByPath(scope.field, "configuration/uiExec");
          if (uiExec) {
            scope.onUiExec({id: view.id, subject: uiExec} );
          }
        };

        scope.searchEnabled = atex.onecms.ObjectUtils.getByPath(scope.field, "value/search-enabled");

        scope.onSelect = function ($select) {
        };

        scope.filterModel = function ($select, model) {
          if (scope.searchEnabled && $select.search ) {
            return _.filter(model, function (_item) {
                return (_item.label.toLowerCase().indexOf($select.search.toLowerCase()) > -1);
              });
          } else {
            return model;
          }
        };

        scope.changeOperator = function () {
          if (!scope.queryModel.operators) {
            scope.queryModel.operators = {};
          }

          var operator = atex.onecms.ObjectUtils.getByPath(scope.queryModel, "operators/" + scope.field.value.model.attribute) === true;
          scope.queryModel.operators[scope.field.value.model.attribute] = !operator;
        };

        scope.translate = function (message, _default) {
          if (!message) {
            console.error("scope.translate (uiSearchField): UNDEFINED message for " + scope.field.value.model.attribute);
          }
          var translation = message;
          if (message) {
            translation = UIConfigurationService.translate(message, _default) || message;
          }

          return translation;
        };

        scope.changeSort = function (sortValue) {
          scope.queryModel.sortValue = sortValue;
          if (sortValue === '') {
            scope.queryModel.sortOrderValue = 'desc';
          }
        };

        scope.changeSortOrder = function (sortOrderValue) {
          scope.queryModel['sortOrderValue'] = sortOrderValue;
          scope.$root.damSortData.currentSortOrderValue = sortOrderValue;
        };

        scope.showDateTimePicker = function(value) {
          var show = false;

          value = (value) ? (value.id || value) : value;
          if (value) {
            if (value !== "TODAY" && value !== "NEXT") {
              show = true;
              $('#publications-date').find('.select2-chosen span').text(UIConfigurationService.translate('__PH_PAGE_CUSTOM__'));
            } else if (value === "TODAY") {
              show = false;
              $('#publications-date').find('.select2-chosen span').text(UIConfigurationService.translate('__PH_PAGE_TODAY__'));
            } else if (value === "NEXT") {
              show = false;
              $('#publications-date').find('.select2-chosen span').text(UIConfigurationService.translate('__PH_PAGE_NEXT_PUB_DATE__'));
            }
          }

          return show;
        };

        scope.getContentUrl = function () {
          var template;

          switch (scope.field.value.type) {
            case "select": {
              template = (scope.field.value.multiple) ? 'views/ui-configuration/search-form/type/' + scope.field.value.type + '-multiple.html'
                : 'views/ui-configuration/search-form/type/' + scope.field.value.type + '-single.html';

              break;
            }

            default: {
              template = 'views/ui-configuration/search-form/type/' + scope.field.value.type + '.html';
            }
          }

          return template;
        };
      }
    };
  }]).directive('uiResultSetTable', ['$q', '$timeout', 'UIConfigurationService', 'DamListService', 'DamService', 'DamSearchService', '$translate', 'uiGridConstants', 'fieldService', 'ContentService', 'DamNotificationService', '$rootScope', function($q, $timeout, UIConfigurationService, DamListService, DamService, DamSearchService, $translate, uiGridConstants, fieldService, ContentService, DamNotificationService, $rootScope) {
  return {
    restrict: 'ACE',
    template: '<div ng-include="getContentUrl()"></div>',
    replace: true,
    scope: {
      componentName: "@",
      componentId: "@",
      profile: "@",
      querying: "=",
      entries: "=",
      tick: "=",
      setPreviewingItem: "&",
      selectEntryCallback: '&',
      hasRead: '&',
      isHasReadEnabled: '&',
      selectAll: '&',
      toggleSelectAll: "&",
      handleDragStart: "&",
      handleDragEnd: "&",
      openEntryCallback: "&",
      loadMore: "&",
      showMore: "=",
      isEntryNew: '&'
    },

    controller: function ($scope) {
      $scope.selected = DamListService.getSelected();

      $scope.handleDragStart = $scope.handleDragStart();
      if (!$scope.handleDragStart) {
        $scope.handleDragStart = function (attributes) {
        };
      }

      $scope.handleDragEnd = $scope.handleDragEnd();
      if (!$scope.handleDragEnd) {
        $scope.handleDragEnd = function (attributes) {
        };
      }

      $scope.selectEntryCallback = $scope.selectEntryCallback();
      if (!$scope.selectEntryCallback) {
        $scope.selectEntryCallback = function (entry) {
        };
      }

      $scope.hasRead = $scope.hasRead();
      if (!$scope.hasRead) {
        $scope.hasRead = function (entry) {
        };
      }

      $scope.isHasReadEnabled = $scope.isHasReadEnabled();
      if (!$scope.isHasReadEnabled) {
        $scope.isHasReadEnabled = function (entry) {
        };
      }

      $scope.setPreviewingItem = $scope.setPreviewingItem();
      if (!$scope.setPreviewingItem) {
        $scope.setPreviewingItem = function (entry) {
        };
      }

      $scope.toggleSelectAll = $scope.toggleSelectAll();
      if (!$scope.toggleSelectAll) {
        $scope.toggleSelectAll = function () {
        };
      }

      $scope.openEntryCallback = $scope.openEntryCallback();
      if (!$scope.openEntryCallback) {
        $scope.openEntryCallback = function () {
        };
      }

      $scope.loadMore = $scope.loadMore();
      if (!$scope.loadMore) {
        $scope.loadMore = function () {
        };
      }

      $scope.isEntryNew = $scope.isEntryNew();
      if (!$scope.isEntryNew) {
        $scope.isEntryNew = function (entry) {
          return false;
        };
      }

      function isSafariMobile() {
        var mobile = false;

        if (window.navigator !== undefined && window.navigator.userAgent !== undefined) {
          var agent = navigator.userAgent.toLowerCase();
          var test = (agent.match(/iPad/i) || agent.match(/iPhone/i)) || (agent.match(/iPad/i) || agent.match(/safari/i));
          if (test) {
            mobile = test.length > 0;
          }
        }

        return mobile;
      }

      function isIpad() {
        var ipad = false;

        if (window.navigator !== undefined && window.navigator.userAgent !== undefined) {
          var agent = navigator.userAgent.toLowerCase();
          var test = agent.match(/iPad/i);
          if (test) {
            ipad = test.length > 0;
          }
        }

        return ipad;
      }

      function filter(widgets) {
        _.each(widgets, function (widget, key) {
          var rules = atex.onecms.ObjectUtils.getByPath(widget, "display");
          if(rules) {
            var remove = UIConfigurationService.validate(DamSearchService.getCurrentAdvQuery(), rules);
            if (!remove.valid) {
              widgets = _.without(widgets, _.findWhere(widgets, {
                id: widget.id
              }));
            }
          }
        });

        return widgets;
      }

      angular.element("#table-wrapper").bind('scroll', function () {
        var wrapper = angular.element("#table-wrapper");

        if (wrapper && wrapper.length > 0) {
          var offset = wrapper.scrollLeft();
          angular.element("#laodMoreResultBtn").css('margin-left', offset);
        }
      });

      $scope.$on("dam:search", function () {
        build();
      });

      //UI grid code starts here
      $scope.loading = false;
      $scope.localEntries = angular.copy($scope.entries);
      var columnDefs = [];
      var headerTitles = [];
      var rowData = [];
      $scope.gridEnabled = false;
      $scope.widgetMapping = {};
      $scope.filterMapping = {};
      function build() {
        UIConfigurationService.type($scope.componentName, $scope.componentId, "default", $scope.profile).then(function (_configuration) {
          $scope.configuration = _configuration;
          if (_configuration.widgets) {
            var widgets = filter(angular.copy(_configuration.widgets));
            var promises = UIConfigurationService._configuration(widgets);
            $q.all(promises).then(function (_widgets) {
              $scope.widgets = _widgets;
              UIConfigurationService.profile().then(function (_profile) {
                if (_profile['grid-state'] && _profile['grid-state'].gridEnabled && $scope.componentId === 'desk-job-list') {
                  $scope.gridEnabled = _profile['grid-state'].gridEnabled;
                  $scope.widgetMapping = _profile['grid-state'].widgetMapping;
                  $scope.filterMapping = _profile['grid-state'].filterMapping;
                  $scope.widgets.forEach(function (widget) {
                    var col = {
                      displayName: '', name: widget.componentId, field: widget.componentId, enableSorting: false, enableFiltering: false, width: 180,
                      cellTemplate: '<div class="ui-grid-cell-contents"><ui-widget widget="row.entity[col.field]" entry="row.entity.entry" key="{{row.entity.key+1}}" select-callback="select"></ui-widget></div>'
                    };
                    if(widget.title) {
                      if(widget.title.value) {
                        col.displayName = $translate.getTranslationTable()[widget.title.value];
                        col.name = col.displayName;
                      }
                      else if(widget.title.icon) {
                        return;
                      }
                      if(_profile['grid-state'].fixedColumns.includes(widget.componentId)){
                        col.enableHiding = false;
                      }
                    }
                    var filter = $scope.filterMapping[widget.componentId];
                    switch(filter) {
                      case 'modalFilter':
                        col.filterHeaderTemplate = '<div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters"><div modal-filter></div></div>';
                        col.enableFiltering = true;
                        col.enableSorting = true;
                        col.sortCellFiltered = true;
                        break;
                      case 'textFilter':
                        col.filterHeaderTemplate = '<div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters"><div text-filter></div></div>';
                        col.enableFiltering = true;
                        col.enableSorting = true;
                        col.sortCellFiltered = true;
                        break;
                      case 'numberFilter':
                        col.filterHeaderTemplate = '<div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters"><div number-filter></div></div>';
                        col.enableFiltering = true;
                        col.enableSorting = true;
                        col.sortCellFiltered = true;
                        break;
                      case 'dateFilter':
                        col.type = 'date';
                        col.filterCellFiltered = true;
                        col.enableFiltering = true;
                        col.enableSorting = true;
                        col.sortCellFiltered = true;
                        col.filterHeaderTemplate = '<div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters"><div date-filter></div></div>';
                        break;
                      case 'deadlineFilter':
                        col.type = 'date';
                        col.filterCellFiltered = true;
                        col.enableFiltering = true;
                        col.enableSorting = true;
                        col.sortCellFiltered = true;
                        col.filterHeaderTemplate = '<div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters"><div deadline-filter></div></div>';
                        break;
                    }
                    col.sortingAlgorithm = function(a, b, rowA, rowB, direction) {
                      rowA = rowA.entity;
                      rowB = rowB.entity;
                      var fieldA = fieldService.getField(widget.componentId, rowA);
                      var fieldB = fieldService.getField(widget.componentId, rowB);
                      if(typeof fieldA === 'string') {
                        if(!fieldA) {
                          return -1;
                        }
                        return fieldA.localeCompare(fieldB, undefined, {numeric: true, sensitivity: 'base'});
                      }
                      else {
                        return fieldA - fieldB;
                      }
                    };
                    columnDefs.push(col);
                  });

                  $scope.gridOptions = {

                    enableFiltering: true,
                    useExternalFiltering: true,
                    enableRowSelection: true,
                    enableSelectAll: true,
                    selectionRowHeaderWidth: 35,
                    enableSorting: true,
                    enableGridMenu: true,
                    columnDefs: columnDefs,
                    gridMenuCustomItems: [
                      {
                        title: 'Toggle Filter',
                        action: function ($event) {
                          $scope.toggleFilterRow();
                        },
                        order: 1
                      },
                      {
                        title: 'Save State',
                        action: function ($event) {
                          $scope.saveStateInUserProfile();
                        },
                        order: 2
                      },
                      {
                        title: 'Restore State',
                        action: function ($event) {
                          $scope.restoreStateFromUserProfile();
                        },
                        order: 3
                      },
                      {
                        title: 'Clear State',
                        action: function ($event) {
                          loadDefaultGridState();
                        },
                        order: 4
                      }
                    ]
                  };
                  getRowData();
                  $scope.gridOptions.multiSelect = true;
                  $scope.query = angular.copy(DamSearchService.getCurrentAdvQuery());
                  $scope.gridOptions.onRegisterApi = function(gridApi) {
                    //set gridApi on scope
                    $scope.gridApi = gridApi;
                    $scope.gridApi.colMovable.on.columnPositionChanged($scope, $scope.saveState);
                    $scope.gridApi.colResizable.on.columnSizeChanged($scope, $scope.saveState);
                    $scope.gridApi.core.on.columnVisibilityChanged($scope, $scope.saveState);
                    $scope.gridApi.core.on.sortChanged($scope, $scope.saveState);
                    gridApi.core.on.rowsRendered($scope, function () {
                      saveDefaultGridState();
                    });
                    $scope.restoreState();
                    $scope.getAllRecords(50);
                    gridApi.selection.on.rowSelectionChanged($scope,function(row){
                      //Calling the select callback if a row is selected.
                      $scope.selectEntryCallback(row.entity.entry);
                    });
                    gridApi.grid.clearAllFilters = function() {
                      $rootScope.$broadcast('dam:allFiltersCleared');
                      this.columns.forEach(function(column) {
                        column.filters.forEach(function(filter) {
                          filter.term = undefined;
                          filter.listTerm = [];
                        });
                      });
                      $scope.getAllRecords(0);
                    };
                    $scope.gridApi.core.on.filterChanged( $scope, $scope.filterChanged );
                    var elem = document.getElementsByClassName('ui-grid-menu-button');
                    if(elem.length){
                      var parent = document.getElementById('ui-result-set-table-2');
                      var wrapper = document.createElement('div');
                      parent.appendChild(wrapper);
                      wrapper.appendChild(elem[0]);
                    }
                  };
                }
              });
            });
          }
        });
      }

      build();

      $scope.getAllRecords = function (start) {
        if(start < 1) {
          $scope.loading = true;
        }
        var searchCopy = {
          container: {
            aspects: {
              contentData: {
                data: angular.copy(DamSearchService.getCurrentAdvQuery())
              }
            }
          }
        };
        //Converting the simple search query to advanced search query to entertain filters later on
        if((searchCopy.container.aspects.contentData.data.fullText === "" || searchCopy.container.aspects.contentData.data.fullText) && !searchCopy.container.aspects.contentData.data._type) {
          searchCopy.container.aspects.contentData.data = DamService.getBlankQuery(searchCopy.container.aspects.contentData.data.fullText);
          $scope.query = searchCopy.container.aspects.contentData.data;
        }
        DamService.getQuery(searchCopy.container).then(function (queryData) {
          queryData.data.onlyLatest = searchCopy.container.aspects.contentData.data.allArchive !== "true" && queryData.data.physicalPages !== "true";
          DamService.getFilterResults(queryData.data, start, null, $scope.query.sortValue, $scope.query.sortOrderValue).then(function (response) {
            if(response.data.response.numFound > 0 && start > 0) {
              response.data.response.docs.forEach( function(doc) {
                $scope.localEntries.push(doc);
              });
            }
            else if (response.data.response.numFound > 0) {
              $scope.localEntries = response.data.response.docs;
            }
            else {
              showNoResultsMessage();
            }
            getRowData();
            $scope.loading = false;
          });
        });
      };
      $scope.filterChanged = function () {

        var grid = $scope.gridApi.grid;
        var fields = [];
        var notQuery = '';
        var numberFilters = [];
        var deadlineFilters = [];
        grid.columns.forEach( function(column) {
          var filter = $scope.filterMapping[column.field];
          switch(filter) {
            case 'modalFilter':
              var field = {};
              field.key = $scope.widgetMapping[column.field];
              field.type = 'LIST';
              field.useId = false;
              field.values = [];
              if(column.filters[0].listTerm) {
                column.filters[0].listTerm.forEach( function(term) {
                  field.values.push(term);
                });
                if(field.values.length > 0) {
                  fields.push(field);
                }
              }
              break;
            case 'textFilter':
              var stringfield = {};
              stringfield.key = $scope.widgetMapping[column.field];
              stringfield.type = 'STRING';
              stringfield.useId = false;
              stringfield.values = [];
              if(column.filters[0].listTerm[0]) {
                if(column.filters[0].type) {
                  notQuery += ' -' + stringfield.key + ': ' + column.filters[0].listTerm[0];
                }
                else {
                  stringfield.values.push(column.filters[0].listTerm[0]);
                }
                if(stringfield.values.length > 0) {
                  fields.push(stringfield);
                }
              }
              break;
            case 'dateFilter':
              var datefield = {};
              datefield.key = $scope.widgetMapping[column.field];
              datefield.type = 'DATE';
              datefield.useId = false;
              datefield.values = [];
              if(column.filters[0].listTerm[0]) {
                datefield.values.push(column.filters[0].listTerm[0]);
                if(datefield.values.length > 0) {
                  fields.push(datefield);
                }
              }
              break;
            case 'deadlineFilter':
              if(column.filters[0].listTerm[0]) {
                var deadlineFilter = {};
                deadlineFilter.term = column.filters[0].term;
                deadlineFilter.field = column.field;
                deadlineFilters.push(deadlineFilter);
              }
              break;
            case 'numberFilter':
              if(column.filters[0].listTerm[0]) {
                var numberFilter = {};
                numberFilter.term = column.filters[0].listTerm[0];
                numberFilter.type = column.filters[0].type;
                numberFilter.field = column.field;
                numberFilters.push(numberFilter);
              }
              break;
          }
        });
        if(fields.length > 0 || notQuery || numberFilters.length > 0 || $scope.query.sortChanged || deadlineFilters.length > 0) {
          $scope.query.fields = fields;
          $scope.loading = true;
          delete $scope.query.sortChanged;
          var searchCopy = {
            container: {
              aspects: {
                contentData: {
                  data: angular.copy($scope.query)
                }
              }
            }
          };
          DamService.getQuery(searchCopy.container).then(function (queryData) {
            queryData.data.solr_query += notQuery;
            queryData.data.onlyLatest = searchCopy.container.aspects.contentData.data.allArchive !== "true" && queryData.data.physicalPages !== "true";
            DamService.getFilterResults(queryData.data, 0, null, $scope.query.sortValue, $scope.query.sortOrderValue).then(function (response) {
              if(response.data.response.numFound > 0) {
                if(numberFilters.length > 0) {
                  numberFilters.forEach( function(numberFilter) {
                    response.data.response.docs = filterNumber(response.data.response.docs, numberFilter);
                  });
                }
                if(deadlineFilters.length > 0) {
                  deadlineFilters.forEach( function(deadlineFilter) {
                    response.data.response.docs = filterDeadline(response.data.response.docs, deadlineFilter);
                  });
                }
                if(response.data.response.docs.length > 0) {
                  $scope.localEntries = response.data.response.docs;
                  getRowData();
                }
                else {
                  showNoResultsMessage();
                }
              }
              else {
                showNoResultsMessage();
              }
              $scope.loading = false;
            });
          });
        }
      };
      function filterNumber(docs, numberFilter) {
        var row = {};
        var results = [];
        var numberField;
        $scope.widgets.forEach(function (widget) {
          row[widget.componentId] = widget;
        });
        docs.forEach(function (data, index) {
          row.entry = data;
          numberField = fieldService.getField(numberFilter.field, row);
          if(numberField && numberTermFilter(numberField, numberFilter)) {
            results.push(data);
          }
        });
        return results;
      }
      function numberTermFilter(numberField, numberFilter) {
            switch(numberFilter.type) {
              case 'equals':
            return numberField === numberFilter.term;
              case 'does_not_equal':
            return numberField !== numberFilter.term;
              case 'less_than':
            return numberField < numberFilter.term;
              case 'greater_than':
            return numberField > numberFilter.term;
              case 'less_than_or_equal':
            return numberField <= numberFilter.term;
              case 'greater_than_or_equal':
            return numberField >= numberFilter.term;
              case 'between':
            return (numberFilter.term[0] < numberField &&  numberField < numberFilter.term[1]);
                }
            }
      function filterDeadline(docs, deadlineFilter) {
        var row = {};
        var date;
        var results = [];
        $scope.widgets.forEach(function (widget) {
          row[widget.componentId] = widget;
        });
        docs.forEach(function (data) {
          row.entry = data;
          date = fieldService.getDateField(deadlineFilter.field, row);
          if(!date) {
            return false;
          }
          var momentDate = moment(date);
          if(deadlineDateFilter(momentDate, deadlineFilter)) {
            results.push(data);
          }
        });
        return results;
      }
      function deadlineDateFilter(momentDate, deadlineFilter) {
        var diff;
          var currentDate = moment();
          switch(deadlineFilter.term) {
            case 'NextHour':
              diff = momentDate.diff(currentDate, "hours");
            return (diff >= 0 && diff <= 1);
            case 'Today':
            return momentDate.isSame(currentDate, 'day');
            case 'Next24H':
              diff = momentDate.diff(currentDate, "hours");
            return (diff >= 0 && diff <= 24);
            case 'Next7D':
              diff = momentDate.diff(currentDate, "days");
            return (diff >= 0 && diff <= 7 );
            default:
            return (momentDate.isBetween(deadlineFilter.term[0], deadlineFilter.term[1]));
              }
          }
      function showNoResultsMessage() {
        DamNotificationService.addNotification(atex.dam.Notification({
          type: 'error',
          message: $translate.getTranslationTable()._NO_RESULT_
        }), true);
      }
      function getRowData() {
        var row = {};
        var gridEntries = [];
        $scope.widgets.forEach(function (widget) {
          row[widget.componentId] = widget;
        });
        $scope.localEntries.forEach(function (entry, index) {
          row.entry = entry;
          row.key = index;
          gridEntries.push(angular.copy(row));
        });
        $scope.gridOptions.data = gridEntries;
      }
      var saveDefaultGridState = function () {
        if (!$scope.defaultState) {
          $scope.defaultState = $scope.gridApi.saveState.save();
        }
      };
      var loadDefaultGridState = function () {
        $scope.gridApi.saveState.restore($scope, $scope.defaultState);
      };
      $scope.toggleFilterRow = function() {
        $scope.gridOptions.enableFiltering = !$scope.gridOptions.enableFiltering;
        $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
      };
      $scope.saveState = function() {
        var state = $scope.gridApi.saveState.save();
        angular.forEach(state.columns, function (column) {
          column.filters = [];
        });
        localStorage.setItem('gridState', angular.toJson(state));
      };
      $scope.restoreState = function() {
        $timeout(function() {
          var state = angular.fromJson(localStorage.getItem('gridState'));
          if (state) {
            $scope.gridApi.saveState.restore($scope, state);
          }
        });
      };
      $scope.saveStateInUserProfile = function() {
        UIConfigurationService.profile().then(function (_profile) {
          var state = $scope.gridApi.saveState.save();
          angular.forEach(state.columns, function (column) {
            column.filters = [];
          });
          _profile['grid-state'].state = state;
          UIConfigurationService.save(_profile).then(function (_updated) {
            DamNotificationService.addNotification(atex.dam.Notification({
              type: 'success',
              message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__
            }), false);
          });
        });
      };
      $scope.restoreStateFromUserProfile = function() {
        UIConfigurationService.profile().then(function (_profile) {
          var state = _profile['grid-state'].state;
          $timeout(function() {
            if (state) {
              $scope.gridApi.saveState.restore($scope, state);
            }
          });
        });
      };
      $scope.info = function (entry) {
        var info = {};

        info.name = atex.onecms.ObjectUtils.getByPath(entry, "_data/aspects/contentData/data/name") || "";
        info.id = atex.onecms.ObjectUtils.getByPath(entry, "id") || "";
        info.type = atex.onecms.ObjectUtils.getByPath(entry, "_data/aspects/contentData/data/inputTemplate") || "";
        info.objectType = atex.onecms.ObjectUtils.getByPath(entry, "_data/aspects/contentData/data/objectType") || "";
        info._type = atex.onecms.ObjectUtils.getByPath(entry, "_data/aspects/contentData/data/_type") || "";

        return info;
      };
    },

    link: function (scope, element) {
      scope.$on('$destroy', function () {
        element.remove();
      });

      scope.style = function (entry) {
        var configuration = atex.onecms.ObjectUtils.getByPath(scope.configuration, "add-class");

        if (configuration) {
          var valid = UIConfigurationService.validate(entry, configuration.rules).valid;

          if (valid) {
            return configuration.css.join(" ");
          }
        }
      };

      scope.selectAll = function () {
        scope.toggleSelectAll();
      };

      scope.select = function (entry) {
        scope.selectEntryCallback(entry);
      };

      scope.getContentUrl = function () {
        return 'views/ui-configuration/result-list/' + scope.componentName + '/template.html';
      };

      scope.getText = function (content) {
        return UIConfigurationService.getText(content);
      };

      scope.getTimeZoneDate = function (path, offset) {
        return UIConfigurationService.getTimeZoneDate(atex.onecms.ObjectUtils.getByPath(scope.entry, path) || "", offset);
      };

      scope.to_trusted = function (txt, limit, expand) {
        return UIConfigurationService.to_trusted(txt, limit, expand);
      };

      scope.finished = function () {
        scope.$root.$broadcast('ui-config:last-element');
      };

    }
  };
}])
.directive('uiSpinner', function() {
    return {
      scope: false,
      link: function (scope, element) {
        scope.$on('$destroy', function () {
          element.remove();
        });

        var opts = {
          lines: 8,
          length: 3,
          width: 2,
          radius: 3,
          corners: 1,
          rotate: 0,
          direction: 1,
          color: '#aaa',
          speed: 1,
          trail: 60,
          shadow: false,
          hwaccel: false,
          className: 'spinner',
          zIndex: 100,
          top: 'auto',
          left: 'auto'
        };

        var spinner = new Spinner(opts).spin();
        element.append(spinner.el);
      }
    };
  }
).directive('uiWidget', ['ContentService','$translate', '$state', 'configuration','UIConfigurationService', 'DamNotificationService', 'DamListService', 'DrawerService', 'DamStatusService', '$q',
  function(ContentService, $translate, $state, configuration, UIConfigurationService, DamNotificationService, DamListService, DrawerService, DamStatusService, $q) {
    return {
      restrict: 'ACE',
      template: '<div ng-include="getContentUrl()"></div>',
      replace: true,
      scope: {
        widget: "=",
        entry: "=",
        key: "@",
        selectCallback: "&"
      },

      controller: function ($scope) {
        function random() {
          return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        }

        function valid(dimension) {
          return (dimension && dimension.entities && dimension.entities.length > 0);
        }

        $scope.selectCallback = $scope.selectCallback();

        if (!$scope.selectCallback) {
          $scope.selectCallback = function () {
          };
        }

        $scope.$watch("entry._data.version", function (newValue, oldValue) {
          // This watch is also triggered as the ui-grid element scrolls through the data and switches out UI elements
          if (newValue !== oldValue) {
           updateWidgets();
          }
        });

        $scope.checkLock = function (spinner) {
          $scope.checking = spinner;
          UIConfigurationService.getLockData([$scope.entry.id]).then(function (lockData) {
            $scope.entry._data.lockData = lockData;
            $scope.checking = false;
          }).then(null, function (error) {
            var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
            DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
            $scope.checking = false;
          });
        };

        $scope.id = random();

        $scope.force = atex.onecms.ObjectUtils.getByPath($scope.widget, "display-if-empty");

        $scope.setupAssigneesConfWidget = function () {
          $scope.fields = [];
          $scope.configurations = [];
          var fields = angular.copy ($scope.widget.fields) || [];

          angular.forEach(fields, function (field) {

            var configuration = field.configuration;
            var dimension = field.dimension;
            var index = field.index || "0";
            var hide = atex.onecms.ObjectUtils.getByPath(field, "display/hide");

            var _field = atex.onecms.ObjectUtils.getByPath($scope.entry, field.path);

            if (_field && dimension) {
              var _dimension = _.find(_field, function (_field) {
                return _field.id === dimension;
              });

              _field = "";
              if (valid(_dimension)) {
                if (isNaN(index)) {
                  if (index === "ALL") {
                    _field = _.pluck(_dimension.entities, 'id');
                  }
                } else {
                  _field = _dimension.entities[Number(index)].id;
                }
              }
            }

            field.visibility = {
              hide: false
            };

            if (hide) {
              field.visibility.hide = UIConfigurationService.validate($scope.entry, hide).valid;
              if (!$scope.widget['hide-label']) {
                $scope.widget['hide-label'] = false;
              }

              $scope.widget['hide-label'] = $scope.widget['hide-label'] || field.visibility.hide;
            }

            if (configuration) {
              var _default = configuration.default;
              UIConfigurationService.configurations(configuration).then(function (_configurations) {
                _configurations = _configurations.configurations || [];

                if (_default) {
                  _default = _configurations[_default.id];
                }

                var _found = _.find(_configurations, function (configuration, key) {
                  return key === _field;
                }) || _default;

                if (_found) {
                  _found.css = field.css;
                  _found.style = field.style;
                  if($scope.configurations.indexOf(_found) === -1) {
                    $scope.configurations.push(_found);
                  }
                }
              });
            } else {
              field.text = _field;
              $scope.fields.push(field);
            }
          });
        };

        var updateWidgets = function () {
          var path = atex.onecms.ObjectUtils.getByPath($scope.widget, "field/path");
          $scope.force = atex.onecms.ObjectUtils.getByPath($scope.widget, "display-if-empty");

          if ($scope.widget) {
            if (  typeof $scope.widget.type === 'undefined') {
              console.log("updateWidgets widget.type undefined $scope.widget = ", $scope.widget);
            }
          switch ($scope.widget.type) {
            case "assignees-widget":
            case "editable-text-widget":
            case "configuration-widget": {
              $scope.setupAssigneesConfWidget();
              break;
            }

            case "link-to-page-widget": {

              $scope.field = $scope.widget.field || [];
              $scope.queryModel = {};
              break;
            }

            case "auto-link-to-page-widget": {
              $scope.field = $scope.widget.field || [];
              $scope.queryModel = {};
              break;
            }

            case "security-parent-widget": {
              // fields should only contain 1 row
              var fields = angular.copy($scope.widget.fields) || [];
              angular.forEach(fields, function (field) {
                var path = field.path;
                var _field = atex.onecms.ObjectUtils.getByPath($scope.entry, path);
                var excludedSites = field.excludedSites;
                var excludedSiteRegexConfig = atex.onecms.ObjectUtils.getByPath($scope.field, "value/config/excludedSiteRegex");
                var excludedSiteRegex = (excludedSiteRegexConfig) ? new RegExp(excludedSiteRegexConfig) : null;
                UIConfigurationService.getWorkingSites(excludedSites, excludedSiteRegex).then(function (sites) {
                  var _workingSites = UIConfigurationService.flatWorkingSites(sites);
                  _workingSites.forEach(function (site) {
                    var _site = atex.dam.AngularUtils.getWithContentId(site.id);
                    if (_site === _field) {
                      field.id = _site;
                      field.text = site.text;
                      $scope.field = field;
                    }
                  });
                });
              });
              break;

            }

            case "associated-sites-widget": {

              var dataField = atex.onecms.ObjectUtils.getByPath($scope.widget, "field") || [];
              var excludedSites = atex.onecms.ObjectUtils.getByPath(dataField, 'excludedSites');
              var excludedSiteRegexConfig = atex.onecms.ObjectUtils.getByPath($scope.field, "value/config/excludedSiteRegex");
              var excludedSiteRegex = (excludedSiteRegexConfig) ? new RegExp(excludedSiteRegexConfig) : null;
              var _field = atex.onecms.ObjectUtils.getByPath($scope.entry, path);
              var obj = {
                ids: []
              };
              var siteNames = [];
                UIConfigurationService.getWorkingSites(excludedSites, excludedSiteRegex).then(function (sites) {
                  var _workingSites = UIConfigurationService.flatWorkingSites(sites);
                  _workingSites.forEach(function (site) {
                    var _site = atex.dam.AngularUtils.getWithContentId(site.id);
                    _field.forEach(function (field) {
                      if (_site === field) {
                        obj.ids.push(_site);
                        siteNames.push(site.text);
                      }
                    });
                  });
                  obj.text = siteNames.join();
                  obj.path = path;
                  obj.excludedSites = $scope.excludedSites;
                  $scope.field = obj;
                });
              break;
            }

            case "metadata-widget": {

              var topicNames = [];
              var metadata = atex.onecms.ObjectUtils.getByPath($scope.widget, "field") || [];
              var topicsField = atex.onecms.ObjectUtils.getByPath($scope.entry, path) || [];
              var metadataDimension;
              topicsField.forEach(function (field) {
                if (field.id === metadata.dimension) {
                  metadataDimension = field;
                }
              });
              if (!metadataDimension) {
                metadataDimension = {
                  "entities": [],
                  "localizations": {},
                  "enumerable": false,
                  "id": metadata.dimension
                };
              }
              var topicsObject = {
                path: path,
                dimension: metadata.dimension,
                metadataDimension: metadataDimension,
                ids: [],
                metadataObjects: []
              };
              metadataDimension.entities.forEach(function (entity) {
                if (entity.entities.length > 0) {
                  topicsObject.ids.push(entity.entities[0].id);
                  entity.entities[0].parent = angular.copy(entity);
                  entity.entities[0].parent.entities = [];
                  topicsObject.metadataObjects.push(entity.entities[0]);
                  topicNames.push(entity.entities[0].name);
                } else {
                  topicsObject.metadataObjects.push(entity);
                  topicsObject.ids.push(entity.id);
                  topicNames.push(entity.name);
                }
              });
              topicsObject.text = topicNames.join();
              $scope.field = topicsObject;
              break;
            }

            case "select-widget": {
              var configuration = atex.onecms.ObjectUtils.getByPath(
                $scope.widget, "field-configuration") || {
                name: "",
                id: ""
              };
              var dimension = atex.onecms.ObjectUtils.getByPath($scope.widget, "field/dimension");

              $scope.field = atex.onecms.ObjectUtils.getByPath($scope.entry, path);

                var offset = atex.onecms.ObjectUtils.getByPath($scope.widget, "field/offset");

                if ( offset ) {
                  $scope.field += offset;
                }

              if ($scope.field && dimension) {
                var _dimension = _.find($scope.field, function (_field) {
                  return _field.id === dimension;
                });

                $scope.field = "";
                if (valid(_dimension)) {
                  $scope.field = _dimension.entities[0].id;
                }
              }

                UIConfigurationService.configurations(configuration).then(function (_configurations) {
                  $scope.configurations = atex.onecms.ObjectUtils.getByPath(_configurations, "configurations") || [];
                  if ( $scope.widget.field && $scope.widget.field.natural ) {
                    var configurations = _.toArray($scope.configurations);

                    $scope.sortedConfigurations = configurations.sort(function(a, b) {
                      return a.label.localeCompare(b.label, undefined, {
                        numeric: true,
                        sensitivity: 'base'
                      });
                    });
                  }

                  var visible = atex.onecms.ObjectUtils.getByPath($scope.widget, "visible");

                  $scope.visibility = {
                    show: visible ? UIConfigurationService.validate($scope.entry, visible).valid : true
                  };

                var _default = atex.onecms.ObjectUtils.getByPath($scope.widget, "field-configuration/default");

                if (_default) {
                  _default = $scope.configurations[_default.id];
                }

                $scope.configuration = _.find($scope.configurations,
                  function (configuration, key) {
                        /*jshint -W116 */
                        return key == $scope.field;
                        /*jshint +W116 */
                  }) || _default;
              });

              break;
            }

            case "editable-status-widget": {
              var _editableStatus = atex.onecms.ObjectUtils.getByPath($scope.entry, path);
                if (!_editableStatus) {
                _editableStatus = UIConfigurationService.getNullStatus();
              }
              var _editableComment = atex.onecms.ObjectUtils.getByPath($scope.widget, "field/comment");
              var editableStatusList = atex.onecms.ObjectUtils.getByPath($scope.widget, "field/statusList");
              if (_editableStatus && _editableStatus.statusID) {
                  DamStatusService.getStatusById(editableStatusList, _editableStatus.statusID).then(function (status) {
                    $scope.status = {};
                    $scope.status.color = (status) ? status.color : "#FFFFFF";
                    $scope.status.name = (status) ? status.name : "No Status";
                    $scope.status.statusID = (status) ? status.statusID : "noStatus";
                    $scope.status.next = (status) ? status.next : [];
                    $scope.status.comment = atex.onecms.ObjectUtils.getByPath($scope.entry, _editableComment);
                    if (!atex.dam.AngularUtils.isHexColor($scope.status.color)) {
                      $scope.status.color = atex.dam.AngularUtils.getHex($scope.status.color);
                    }
                    $scope.status['text-color'] = UIConfigurationService.getStatusTextColor( status );
                    $scope.statusList = editableStatusList;
                    $scope.path = path;
                  });
              }
              var editableHide = atex.onecms.ObjectUtils.getByPath($scope.widget, "hide");
              $scope.visibility = {
                hide: UIConfigurationService.validate($scope.entry, editableHide).valid
              };

              break;
            }

            case "status-widget": {
              var parseEntry = function() {
                var _status = atex.onecms.ObjectUtils.getByPath($scope.entry, path);
                    if (!_status) {
                  _status = UIConfigurationService.getNullStatus();
                }
                var _comment = atex.onecms.ObjectUtils.getByPath($scope.widget, "field/comment");
                var statusList = atex.onecms.ObjectUtils.getByPath($scope.widget, "field/statusList");
                var hide = atex.onecms.ObjectUtils.getByPath($scope.widget, "hide");
                $scope.visibility = {
                  hide: UIConfigurationService.validate($scope.entry, hide).valid
                };

                if (_status && _status.statusID) {
                  return DamStatusService.getStatusById(statusList, _status.statusID).then(function (status) {
                    $scope.status = {};

                    $scope.status.color = (status) ? status.color : "#FFFFFF";
                    $scope.status.name = (status) ? status.name : "No Status";
                    $scope.status.comment = atex.onecms.ObjectUtils.getByPath($scope.entry, _comment);

                    if (!atex.dam.AngularUtils.isHexColor($scope.status.color)) {
                      $scope.status.color = atex.dam.AngularUtils.getHex($scope.status.color);
                    }
                    $scope.status['text-color'] = UIConfigurationService.getStatusTextColor( status );
                  });
                }
                return $q.when();
              };

              var statusHasChanged = function(newEntry, oldEntry) {
                var _newStatus = atex.onecms.ObjectUtils.getByPath(newEntry, path);
                var _oldStatus = atex.onecms.ObjectUtils.getByPath(oldEntry, path);
                var _newStatusID = _newStatus && _newStatus.statusID;
                var _oldStatusID = _oldStatus && _oldStatus.statusID;
                if (_newStatusID !== _oldStatusID) {
                  return true;
                }
                var _commentPath = atex.onecms.ObjectUtils.getByPath($scope.widget, "field/comment");
                var _newComment = atex.onecms.ObjectUtils.getByPath(newEntry, _commentPath);
                var _oldComment = atex.onecms.ObjectUtils.getByPath(oldEntry, _commentPath);
                if (_newComment !== _oldComment) {
                  return true;
                }
                return false;
              };

              parseEntry().then(function() {
                $scope.$watch('entry', function(newValue, oldValue) {
                  if (newValue !== oldValue) {
                    if (statusHasChanged(newValue, oldValue)) {
                      parseEntry();
                    }
                  }
                }, true);
              });

              break;
            }

            case "deadline-status-widget": {

              var contents = atex.onecms.ObjectUtils.getByPath($scope.widget, "fields") || [];
              // Assume only one for now
              angular.forEach(angular.copy(contents), function (field) {
                var path = atex.onecms.ObjectUtils.getByPath(field, "path");
                var thresholds = atex.onecms.ObjectUtils.getByPath(field, "configuration/thresholds") || [0, 1, 4];
                var hide = atex.onecms.ObjectUtils.getByPath(field, "display/hide");
                var _field = atex.onecms.ObjectUtils.getByPath($scope.entry, path);
                var colors = atex.onecms.ObjectUtils.getByPath(field, "configuration/colors/box") || ["#FF3333", "#FF9900", "#67FF32"];
                var textColors = atex.onecms.ObjectUtils.getByPath(field, "configuration/colors/text") || ["#FFFFFF", "#FFFFFF", "#000000"];


                field.visibility = {
                  hide: false
                };

                if (hide) {
                  field.visibility.hide = UIConfigurationService.validate(
                    $scope.entry, hide).valid;
                  if (!$scope.widget['hide-label']) {
                    $scope.widget['hide-label'] = false;
                  }

                  $scope.widget['hide-label'] = $scope.widget['hide-label'] ||
                    field.visibility.hide;
                }

                field.text = _field;
                var date = field.text;
                if (typeof field.text === 'string') {
                  date = parseInt(date);
                }
                if (date === 0) {
                  field.visibility.hide = true;
                }
                var currentDate = moment();
                var momentDate = moment(date);
                var diff = momentDate.diff(currentDate, "hours");
                  for (var i = 0; i < thresholds.length; i++) {
                  if (diff >= thresholds[i]) {
                    field.color = colors[i];
                    field.textColor = textColors[i];
                  } else if (diff <= thresholds[0]) {
                    field.color = colors[0];
                    field.textColor = textColors[0];
                  }
                }
                $scope.field = field;
              });
              break;
            }

            case "engagement-widget":
            case "conditional-widget": {
              var visible = atex.onecms.ObjectUtils.getByPath($scope.widget, "visible");
              $scope.template = UIConfigurationService.validate($scope.entry, visible);
              break;
            }

            case "attributes-widget": {
              var view = atex.onecms.ObjectUtils.getByPath($scope.widget, "view");
              var attributes = (path) ? atex.onecms.ObjectUtils.getByPath($scope.entry, path) : [];

              UIConfigurationService.attributes(view).then(function (_attributes) {
                $scope.attributes = angular.copy(_attributes);

                _.each($scope.attributes, function (_attribute) {
                  _attribute.visible = _.contains(attributes, _attribute.id);
                });
              });
              break;
            }

            case "lock-entry-widget": {
              var run = atex.onecms.ObjectUtils.getByPath($scope.widget, "display-at-startup") || false;

              if (run) {
                $scope.checkLock(false);
              }
              break;
            }

            case "select-entry-widget": {
              $scope.selected = DamListService.getSelected();
              break;
            }
              default: {
                console.log("unknown type widget: " + $scope.widget.componentId + " type: " + $scope.widget.type );
              }
          }
          }
        };

        updateWidgets();
      },

      link: function(scope, element) {
        scope.$on('$destroy', function () {
          element.remove();
        });

        function _keys(hints, data) {
          var keys = {};
          hints.forEach(function (hint) {
            if (hint.path) {
              keys[hint.id] = atex.onecms.ObjectUtils.getByPath(data, hint.path) || '';
            } else if (hint.format) {
              var date = atex.onecms.ObjectUtils.getByPath(data, hint.date);
              if (typeof date === 'string') {
                date = parseInt(date);
              }
              keys[hint.id] = moment(date).format(hint.format);
            } else if (hint.function) {
              keys[hint.id] = data[hint.function]();
            }

            if (keys[hint.id] && keys[hint.id] !== '') {
              if (hint.prefix) {
                keys[hint.id] = hint.prefix + keys[hint.id];
              }
              if (hint.suffix) {
                keys[hint.id] = keys[hint.id] + hint.suffix;
              }
            }
          });

          return JSON.stringify(keys);
        }

        scope.canCollect = function () {
          var template = atex.onecms.ObjectUtils.getByPath(scope.entry, "_data/aspects/contentData/data/inputTemplate") || '';

          if (!DrawerService.canCollectType(template)) {
            return false;
          }
          if (DrawerService.contains(scope.entry.id)) {
            return false;
          }

          return true;
        };

        scope.collect = function () {
          scope.$root.$broadcast("dam:addItemToCollector", scope.entry.id);
        };

        scope.menu = function (event) {
          if (event) {
            angular.element('#select-widget-' + scope.id).parent().css("overflow", "visible");
            angular.element('#select-widget-' + scope.id).children().toggleClass('open');
            event.stopPropagation();
          }
        };

        scope.getContentUrl = function () {
          return ('views/ui-configuration/widget/' + scope.widget.type + '.html');
        };

        scope.getKey = function (key) {
          return Number(key) + 1;
        };

        scope.keys = function (_hints, data) {
          return _keys(_hints, (data) ? data : scope.entry);
        };

        scope.isTrashed = function () {
          var trashed = false;

          if (configuration.getTrashId()) {
            var path = atex.onecms.ObjectUtils.getByPath(scope.widget, "field/path");
            var id = atex.onecms.ObjectUtils.getByPath(scope.entry, path);

            trashed = (id === configuration.getTrashId());
          }
          return trashed;
        };

        scope.open = function () {
          $state.go('list.relations', {'id': scope.entry.id});
        };

        scope.translate = function (label, _default) {
          return UIConfigurationService.translate(label, _default);
        };

        function createMedataInfoAspect() {
          return {
            _type: 'atex.Metadata',
            taxonomyIds: ['p.StandardCategorization'],
            metadata: {
              _type: "com.polopoly.metadata.Metadata",
              dimensions: []
            }
          };
        }

        function createDimension(dimensionId) {
          return {
            "id": dimensionId,
            "entities": []
          };
        }

        function createEntity(id) {
          return {"id": id, "name": id, "entities": []};
        }

        function update(dimensionId, id, content, configuration) {
          var aspect = atex.onecms.ObjectUtils.getByPath(content, "data/aspects/atex.Metadata");

          if (!aspect) {
            aspect = createMedataInfoAspect();
          }

          var dimensions = atex.onecms.ObjectUtils.getByPath(aspect, "data/metadata/dimensions");
          var dimension = _.find(dimensions, function (_dimension) {
            return _dimension.id === dimensionId;
          });

          if (!dimension && Number(id) > 0) {
            dimension = createDimension(dimensionId);
            aspect.data.metadata.dimensions.push(dimension);
          }

          if (Number(id) > 0) {
            dimension.entities[0] = createEntity(id);
          } else if (dimension) {
            aspect.data.metadata.dimensions = _.without(aspect.data.metadata.dimensions, _.findWhere(aspect.data.metadata.dimensions, {
              id: dimensionId
            }));
          }

          delete content.data.aspects['atex.Metadata'].data.metadata.dimensions_element_types;

          var transferInfo = {id: content.id, data: content.data, revision: content.revision};
          ContentService.updateContent(transferInfo).then(function () {
            scope.configuration = configuration;
            scope.saving = false;

            DamNotificationService.addNotification(atex.dam.Notification({
              type: 'success',
              message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__
            }), false);
          }).then(null, function (error) {
            scope.saving = false;

            var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
            DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
          });
        }

        scope.update = function (e, id, configuration) {
          scope.saving = true;

          scope.menu(e);
          var dimension = atex.onecms.ObjectUtils.getByPath(scope.widget, "field/dimension");
          var path = atex.onecms.ObjectUtils.getByPath(scope.widget, "field/path");
          var field = atex.onecms.ObjectUtils.getByPath(scope.widget, "field");

          if ( dimension ) {
          ContentService.getContent({id: scope.entry.id}).then(function (content) {
            update(dimension, id, content, configuration);
          });
          } else if ( path ) {
            scope.saving = false;
            return UIConfigurationService.updateContentWithPermissionChecks(scope.entry, id, field, path, function updateStatusLambda( content, field, id, path ) {
              scope.saving = false;
              var typevalue = atex.onecms.ObjectUtils.getByPath(content, path.substring(1));

              if ( _.isString(typevalue) ) {
                atex.onecms.ObjectUtils.accessor(content, path.substring(1)).value = id;
              } else if( !isNaN( parseInt(id) ) ) {
                var value = parseInt(id);

                if ( field && field.offset ) {
                  value -= field.offset;
                }

                atex.onecms.ObjectUtils.accessor(content, path.substring(1)).value = value;
              } else {
                var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (illegal type " + id + ")";
                DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
              }
            });
          }
        };

        scope.toggleSelection = function () {
          scope.selectCallback(scope.entry);
        };

        scope.getIconSource = function (source, path) {
          var icon = "";

          if(source) {
            source = source.replace(/\s/g, '').toLowerCase();
            icon = "img/incoming/" + source + ".png";
            icon = (path || "img/incoming/") + source + ".png";
          }

          return icon;
        };

        scope.getText = function (entry, path) {
          return UIConfigurationService.getText(atex.onecms.ObjectUtils.getByPath(entry, path) || "");
        };

        scope.getTimeZoneDate = function (path, offset) {
          return UIConfigurationService.getTimeZoneDate(atex.onecms.ObjectUtils.getByPath(scope.entry, path) || "", offset);
        };

        scope.getLimit = function (value) {
          return (value) ? (value.limit) ? value.limit : 0 : 0;
        };

        scope.to_trusted = function (txt, limit, expand) {
          return UIConfigurationService.to_trusted(txt, limit, expand);
        };

        if (scope.widget.type === "configuration-widget") {
          var fields = atex.onecms.ObjectUtils.getByPath(scope.widget, "fields");
          if (fields && fields[0] && fields[0].path) {
            scope.$watch(function () {
              return atex.onecms.ObjectUtils.getByPath(scope.entry, fields[0].path);
            }, function (newValue, oldValue) {
              if (newValue && !angular.equals(newValue, oldValue)) {
                scope.setupAssigneesConfWidget();
              }
            }, true);
          }
        }
      }
    };
  }]).directive('uiEditableText', ['ContentService', 'UIConfigurationService', 'DamAclPermissionService', '$translate', 'DamNotificationService', 'DamActivityService', '$rootScope', '$timeout', 'DamService', function (ContentService, UIConfigurationService, DamAclPermissionService, $translate, DamNotificationService, DamActivityService, $rootScope, $timeout, DamService) {
  return {
    restrict: 'ACE',
    templateUrl: 'views/ui-configuration/directive/editable-text.html',
    replace: true,
    scope: {
      field: "=",
      entry: "="
    },

    controller: function ($scope) {

      $scope.processEditableText = function (entry, data, field) {
        var path = field.path;
        return UIConfigurationService.updateContentWithPermissionChecks(entry, data, field, path, function securityParentLambda( content, field, data, path) {
          atex.onecms.ObjectUtils.accessor(content, path.substring(1)).value = data;
        });
      };

      $scope.updateEditableText = function (entries, data, field) {
        var originalValue = field.text;

        //timeout used to workaround scope already in progress
        if (field.text === data) {
          return false;
        }
        $timeout(function () {
          return $scope.processEditableText(entries, data, field).then(function (response) {
            if (!response) {
              //if error occurred - restore the model back to it's original value.
              field.text = originalValue;
            }
            return response ? response : false;
          }).then(null, function (error) {
            field.text = originalValue;
            return false;
          });
        }, 1);
      };

    },

    link: function (scope, element) {
      scope.$on('$destroy', function () {
        element.remove();
      });
    }
  };
}]).directive('uiEditableStatus', ['ContentConfigurationService', 'ContentService', 'UIConfigurationService','AuthenticationService', 'DamAclPermissionService', '$translate', 'DamNotificationService', 'DamActivityService', '$rootScope', '$timeout', 'DamService', function (ContentConfigurationService, ContentService, UIConfigurationService, AuthenticationService, DamAclPermissionService, $translate, DamNotificationService, DamActivityService, $rootScope, $timeout, DamService) {
  return {
    restrict: 'ACE',
    templateUrl: 'views/ui-configuration/directive/editable-status.html',
    replace: true,
    scope: {
      path: "=",
      entry: "=",
      status: "=",
      list: "="
    },
    controller: function ($scope) {

      $scope.currentUserInfo = undefined;
      $scope.currentStatus = $scope.status;

      $scope.toggleDropdown = function (state) {
        $scope.dropDown = state;
      };

      $scope.listOfStatus = [];

      $scope.loadDropdownOptions = function (status) {
        if (status.statusID !== "noStatus") {
          var transferInfo = {
            id: $scope.list ? $scope.list : 'atex.WFStatusList'
          };
          ContentConfigurationService.getConfiguration(transferInfo).
            then(function (response) {
              $scope.listOfStatus = atex.onecms.ObjectUtils.getByPath(response, 'data/aspects/contentData/data/status');
              return $scope.loadCurrentUserInfo();
            }).
            then(function () {
              $scope.filterStatusList();
            }).
            then(function () {
              $scope.setSelected();
              $scope.toggleDropdown(true);
            });
        }
      };

      $scope.setSelected = function () {
        $scope.selectedOption = $scope.status.name;
      };


      $scope.loadCurrentUserInfo = function () {
        return DamService.getCurrentDamUserInfo().then(function (currentUser) {
          $scope.currentUserInfo = currentUser;
          return currentUser;
        });

      };
      $scope.getStatusFromId = function (statusID) {
        return $scope.statusList.find(function(status) {
          return status.statusID === statusID;
        });
      };
      $scope.userCanSet = function (users) {
        if (!users || users.length===0 || !$scope.checkUsers) {
          return true;
        }
        for (var i=0; i<users.length; i++) {
          if (users[i]===$scope.currentUserInfo.externalId) {
            return true;
          }
          for (var j=0; j<$scope.currentUserInfo.groups.length; j++) {
            if (users[i]===$scope.currentUserInfo.groups[j].principalId) {
              return true;
            }
          }
        }
        return false;
      };
      $scope.filterStatusList = function () {
        var index = -1;
        var _status;
        var nextStatusIDs = [];
        $scope.listOfStatus.forEach( function (status, _index) {
          if (status.statusID === $scope.status.statusID) {
            index = _index;
            _status = status;
            nextStatusIDs = angular.copy(status.next);
          }
        });
        if (index>0) {
          var removed = $scope.listOfStatus.splice(index, 1);
          if (removed[0]) {
            $scope.listOfStatus.unshift(removed[0]);
          }
        }
        if (nextStatusIDs) {
          var newStatutsList = [];
          nextStatusIDs.forEach( function (nextStatusID) {
            for (var i=0; i<$scope.listOfStatus.length; i++) {
              if ($scope.listOfStatus[i].statusID===nextStatusID) {
                if ($scope.userCanSet($scope.listOfStatus[i].users)) {
                  newStatutsList.push($scope.listOfStatus[i]);
                }
                break;
              }
            }
          });
          var found = false;
          newStatutsList.forEach( function (status){
            if (status.statusID === $scope.status.statusID) {
              found = true;
            }
          });
          if (!found) {
            newStatutsList.unshift($scope.status);
          }

          $scope.noFilterStatusList = angular.copy(newStatutsList);
          $scope.listOfStatus = newStatutsList;
        }
      };

      $scope.getStatusTextColor = function(status) {
        return UIConfigurationService.getStatusTextColor(status);
      };

      $scope.processStatusUpdate = function (entry, status, field) {
        var path = $scope.path;
        return UIConfigurationService.updateContentWithPermissionChecks(entry, status, field, path, function updateStatusLambda( content, field, status, path) {
          atex.onecms.ObjectUtils.accessor(content, path.substring(1)).value = JSON.parse(angular.toJson(status));
        });
      };

      $scope.setStatus = function (entries, status) {
        if ($scope.currentStatus.name === status) {
          $scope.toggleDropdown(false);
          return false;
        }
        var updatedStatus;
        $scope.listOfStatus.forEach( function (stat){
          if(stat.name === status){
            updatedStatus = angular.copy(stat);
          }
        });
        if (updatedStatus.$$hashKey) {
          delete updatedStatus.$$hashKey;
        }

        $timeout(function () {
          return $scope.processStatusUpdate(entries, updatedStatus, null).
            then(function (response) {
              $scope.toggleDropdown(false);
              $scope.currentStatus = $scope.status;
              return response ? response : false;
            }).
            then(null, function (error) {
              $scope.toggleDropdown(false);
              return false;
            });
        }, 1);
      };

    },

    link: function (scope, element) {

      scope.$on('$destroy', function () {
        scope.toggleDropdown(false);
        element.remove();
      });
    }
  };
}]).directive('uiSecurityParent', ['ContentService', 'UIConfigurationService','AuthenticationService', 'DamAclPermissionService', '$translate', 'DamNotificationService', 'DamActivityService', '$rootScope', '$timeout', 'DamService', function (ContentService, UIConfigurationService, AuthenticationService, DamAclPermissionService, $translate, DamNotificationService, DamActivityService, $rootScope, $timeout, DamService) {
  return {
    restrict: 'ACE',
    templateUrl: 'views/ui-configuration/directive/security-parent.html',
    replace: true,
    scope: {
      field: "=",
      entry: "="
    },
    controller: function ($scope) {
      $scope.toggleDropdown = function (state) {
        $scope.dropDown = state;
      };

      $scope.loadDropDownOptions = function () {
        $scope.options = [];
        $scope.selectedOption = null;
        var excludedSites = $scope.field.excludedSites;
        var excludedSitesRegex = $scope.excludedSiteRegex;

        return UIConfigurationService.getWorkingSites(excludedSites, excludedSitesRegex).
          then(function (sites) {
            var workingSites = UIConfigurationService.flatWorkingSites(sites);
            var siteNames = [];
            workingSites.forEach(function (site) {
              var _site = atex.dam.AngularUtils.getWithContentId(site.id);
              if (_site === $scope.field.id) {
                $scope.selectedOption = site;
              }
              $scope.options.push(site);
              siteNames.push(site.text);
            });
            $scope.selectedOptionIndex = siteNames.indexOf($scope.field.text);
            $scope.toggleDropdown(true);
          });
      };

      $scope.processSecurityParent = function (entry, data, field) {
        var path = field.path;
        return UIConfigurationService.updateContentWithPermissionChecks(entry, data, field, path, function securityParentLambda( content, field, data, path) {
          var insertParentIdPath = atex.onecms.ObjectUtils.getByPath(field, 'insertParentIdPath');
          atex.onecms.ObjectUtils.accessor(content, path.substring(1)).value = data;
          if (atex.onecms.ObjectUtils.accessor(content, insertParentIdPath.substring(1)).value) {
            atex.onecms.ObjectUtils.accessor(content, insertParentIdPath.substring(1)).value = data;
          }
        });
      };

      $scope.updateSecurityParent = function (entries, option, field) {
        var originalValue = field.text;
        //timeout used to workaround scope already in progress
        if (field.text === option.name) {
          $scope.toggleDropdown(false);
          return false;
        }

        $timeout(function () {
          return ContentService.getContent({ id: option.id }).
            then(function (siteContent) {
              var newSiteId = atex.dam.AngularUtils.getWithContentId(siteContent.data.id);
              return $scope.processSecurityParent(entries, newSiteId, field).
                then(function (response) {
                  if (!response) {
                    //if error occurred - restore the model back to it's original value.
                    field.text = originalValue;
                  }
                  $scope.toggleDropdown(false);
                  return response ? response : false;
                }).
                then(null, function (error) {
                  field.text = originalValue;
                  $scope.toggleDropdown(false);
                  return false;
                });
            });
        }, 1);
      };

    },

    link: function (scope, element) {

      scope.$on('$destroy', function () {
        scope.toggleDropdown(false);
        element.remove();
      });
    }
  };
}]).directive('uiAssociatedSite', ['ContentService', '$modal', 'UIConfigurationService','AuthenticationService', 'DamAclPermissionService', '$translate', 'DamNotificationService', 'DamActivityService', '$rootScope', '$timeout', 'DamService', function (ContentService, $modal, UIConfigurationService, AuthenticationService, DamAclPermissionService, $translate, DamNotificationService, DamActivityService, $rootScope, $timeout, DamService) {
  return {
    restrict: 'ACE',
    templateUrl: 'views/ui-configuration/directive/associated-sites.html',
    replace: true,
    scope: {
      field: "=",
      entry: "="
    },
    controller: function ($scope) {
      $scope.setUpModal = function () {
        var modalScope = $scope.$new(true);
        modalScope.availableOptions = $scope.options;
        modalScope.selectedOptions = $scope.selectedOptions;
        modalScope.header = "Associated Sites";
        modalScope.select = function (key) {
          modalScope.current = key;
        };

        modalScope.isSelected = function (option) {
          if(modalScope.selectedOptions.indexOf(option.id) > -1){
            option.selected = true;
          } else {
            option.selected = false;
          }
        };

        modalScope.updateSelections = function (option) {
          if(modalScope.selectedOptions.indexOf(option.id) > -1){
            modalScope.selectedOptions.splice(modalScope.selectedOptions.indexOf(option.id),1);
          } else {
            modalScope.selectedOptions.push(option.id);
          }
        };

        var modal = $modal({
          show: true,
          scope: modalScope,
          template: 'views/ui-configuration/widget/modal/associated-sites-widget-modal.html',
          modalClass: 'confirm-modal ng-cloak',
          backdrop: 'static',
          keyboard: false
        });
        modalScope.verified = (modalScope.confirm !== true);

        var destroyModal = function () {
          modal.then(function (modalEl) {
            modalEl.on('hidden.bs.modal', function () {
              modalScope.$destroy();
              modalEl.remove();
            });

            modalEl.modal('hide');
          });
        };

        modalScope.doClose = function () {
          destroyModal();
        };

        modalScope.doSave = function () {
          $scope.updateAssociatedSites($scope.entry, modalScope.selectedOptions, $scope.field, modalScope);
        };
      };

      $scope.loadModal = function () {
        $scope.options = [];
        $scope.selectedOptions = [];
        var excludedSites = $scope.field.excludedSites;
        var excludedSitesRegex = $scope.excludedSiteRegex;
        return UIConfigurationService.getWorkingSites(excludedSites, excludedSitesRegex).
          then(function (sites) {
            var workingSites = UIConfigurationService.flatWorkingSites(sites);
            workingSites.forEach(function (site) {
              var _site = atex.dam.AngularUtils.getWithContentId(site.id);
              if($scope.field.ids.indexOf(_site)> -1){
                $scope.selectedOptions.push(_site);
              }
            });
            $scope.options = sites;
            $scope.setUpModal();
          });
      };

      $scope.processAssociatedSites = function (entry, data, field) {

        var path = field.path;

        return UIConfigurationService.updateContentWithPermissionChecks(entry, data, field, path, function associatedSitesLambda( content, field, data, path) {
          var path_element_types = "_data/aspects/p.InsertionInfo/data/associatedSites_element_types";
          atex.onecms.ObjectUtils.accessor(content,
            path.substring(1)).value = data;
          var dataTypeArray = [];
          data.forEach(function(dataPiece){
            dataTypeArray.push("com.atex.onecms.content.ContentId");
          });
          atex.onecms.ObjectUtils.accessor(content,
            path_element_types.substring(1)).value = dataTypeArray;
        });
      };


      $scope.updateAssociatedSites = function (entries, options, field, modal) {
        var originalValue = field.text;
        //timeout used to workaround scope already in progress

        $timeout(function () {
          return $scope.processAssociatedSites(entries, options, field).
            then(function (response) {
              if (!response) {
                //if error occurred - restore the model back to it's original value.
                field.text = originalValue;
              } else {
                modal.doClose();
              }

              return response ? response : false;
            }).
            then(null, function (error) {
              field.text = originalValue;
              return false;
            });
        },  1);
      };

    },

    link: function (scope, element) {

      scope.$on('$destroy', function () {
        element.remove();
      });

    }
  };
}]).directive('uiMetadataWidget', ['ContentService','MetadataService', '$modal', 'UIConfigurationService','AuthenticationService', 'DamAclPermissionService', '$translate', 'DamNotificationService', 'DamActivityService', '$rootScope', '$timeout', 'DamService',
  function (ContentService, MetadataService, $modal, UIConfigurationService, AuthenticationService, DamAclPermissionService, $translate, DamNotificationService, DamActivityService, $rootScope, $timeout, DamService) {
    return {
      restrict: 'ACE',
      templateUrl: 'views/ui-configuration/directive/metadata.html',
      replace: true,
      scope: {
        field: "=",
        entry: "="
      },
      controller: function ($scope) {

        $scope.setUpModal = function () {
          var modalScope = $scope.$new(true);
          modalScope.availableOptions = $scope.options.metadata;
          modalScope.selectedObjects = $scope.field.metadataObjects;
          modalScope.selectedOptions = $scope.selectedOptions;
          modalScope.header = "Topics";
          modalScope.select = function (key) {
            modalScope.current = key;
          };

          modalScope.isSelected = function (option) {
            if(modalScope.selectedOptions.indexOf(option.id) > -1) {
              option.selected = true;
            } else {
              option.selected = false;
            }
            if(option.entities.length > 0){
              option.entities.forEach(function(entity){
                entity.parent = angular.copy(option);
                entity.parent.entities = [];
              });
            }
          };

          modalScope.updateSelections = function (option) {
            if(modalScope.selectedOptions.indexOf(option.id) > -1) {
              var index = modalScope.selectedOptions.indexOf(option.id);
              modalScope.selectedOptions.splice(index,1);
              modalScope.selectedObjects.splice(index,1);
            } else {
              modalScope.selectedOptions.push(option.id);
              modalScope.selectedObjects.push(option);
            }
          };

          var modal = $modal({
            show: true,
            scope: modalScope,
            template: 'views/ui-configuration/widget/modal/metadata-widget-modal.html',
            modalClass: 'confirm-modal ng-cloak',
            backdrop: 'static',
            keyboard: false
          });
          modalScope.verified = (modalScope.confirm !== true);

          var destroyModal = function () {
            modal.then(function (modalEl) {
              modalEl.on('hidden.bs.modal', function () {
                modalScope.$destroy();
                modalEl.remove();
              });

              modalEl.modal('hide');
            });
          };

          modalScope.doClose = function () {
            destroyModal();
          };

          modalScope.doSave = function () {
            var metadataObject =  $scope.buildEntityList(modalScope.selectedObjects);
            $scope.updateMetadata($scope.entry, metadataObject, $scope.field, modalScope);
          };
        };

        $scope.buildEntityList = function (entityList) {
          var entityArray = [];
          entityList.forEach(function (entity) {
            if(entity.parent) {
              var parent = $scope.buildEntity(entity.parent);
              delete parent['parent'];
              delete parent['selected'];
              delete entity['parent'];
              delete entity['selected'];
              var childEntity = $scope.buildEntity(entity);
              parent.entities.push(childEntity);
              entityArray.push(parent);
            } else {
              var entry = $scope.buildEntity(entity);
              entry.entities = [];
              delete entry['parent'];
              delete entry['selected'];
              entityArray.push(entry);
            }
          });
          return entityArray;
        };

        $scope.buildEntity = function (entity) {
          entity.attributes = [];
          entity.attributes_type = "java.util.List<com.polopoly.metadata.Attribute>";
          entity.childrenOmitted_type = "boolean";
          entity.childrenOmitted = false;
          entity.entities_type = "java.util.List<com.polopoly.metadata.Entity>";
          entity.id_type = "java.lang.String";
          entity.localizations = {_type: "java.util.Map"};
          entity.localizations_type = "java.util.Map";
          entity.name_type = "java.lang.String";
          entity._type = "com.polopoly.metadata.Entity";
          delete entity['children-omitted'];
          delete entity['$$hashKey'];
          return entity;
        };

        $scope.cleanEntity = function (entity) {
          delete entity['parent'];
          delete entity['selected'];
        };

        $scope.buildMetadataObject = function (selections) {
          return {
            _type: "com.polopoly.metadata.Dimension",
            entities_type: "java.util.List<com.polopoly.metadata.Entity>",
            enumerable_type: "boolean",
            id_type: "java.lang.String",
            localizations: {_type: "java.util.Map"},
            localizations_type: "java.util.Map",
            name: $scope.field.dimension.split('.')[1],
            name_type: "java.lang.String",
            id: $scope.field.dimension,
            enumerable: (selections.length > 0),
            entities: selections.length > 0 ? $scope.buildEntityList(selections) : []
          };
        };

        $scope.getName = function (entry, parent, dimension) {
          return (parent && parent.name && parent.id !== dimension) ? parent.name + "/" + entry.name : entry.name;
        };

        $scope.flat = function (entry, tags, dimension, parent) {
          tags.push({id: entry.id, text: $scope.getName(entry, parent, dimension), dimension: dimension});

          if (entry.entities) {
            _.each(entry.entities, function (child) {
              $scope.flat(child, tags, dimension, {id: entry.id, name: $scope.getName(entry, parent, dimension)});
            });
          } else {
            return;
          }

          return tags;
        };

        $scope.getMetadata = function (dimension) {
          return $scope.getMetadataStructure(dimension).then(function (metadata) {
            return $scope.flatMetadata(metadata, dimension);
          });
        };

        $scope.getMetadataStructure = function (dimension) {
          return MetadataService.getStructure({id: dimension}).then(function (responseInfo) {
            return atex.onecms.ObjectUtils.getByPath(responseInfo, 'data/entities') || [];
          });
        };

        $scope.getMetadataTree = function (dimension) {
          return $scope.getMetadataStructure(dimension).then(function (metadata) {
            return {id: dimension, metadata: metadata};
          });
        };

        $scope.flatMetadata = function (metadata, dimension) {
          var tags = [];
          _.each(metadata, function (entry) {
            $scope.flat(entry, tags, dimension);
          });

          return tags;
        };

        $scope.loadModal = function () {
          $scope.options = [];
          $scope.selectedOptions = [];
          $scope.selectedObjects = [];
          $scope.isLoading = true;
          return $scope.getMetadataTree($scope.field.dimension).
            then(function (metadataContent) {
              $scope.options = metadataContent;
              $scope.selectedOptions = $scope.field.ids;
              $scope.setUpModal();
              $scope.isLoading = false;
            }, function (error) {
              var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
              DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
              $scope.isLoading = false;
            });
        };

        $scope.processMetadata = function (entry, data, field) {
          var path = field.path;
          return UIConfigurationService.updateContentWithPermissionChecks(entry, data, field, path, function metadataLambda( content, field, data, path) {
            var metadataArrayElementTypeList = [];
            data.forEach(function (element) {
              metadataArrayElementTypeList.push("com.polopoly.metadata.Entity");
            });
            var metadataArray = atex.onecms.ObjectUtils.accessor(content, path.substring(1)).value;
            var dimensionIndex = -1;
            for (var i = 0; i < metadataArray.length; i++) {
              if(metadataArray[i].id === field.dimension){
                dimensionIndex = i;
              }
            }
            if(dimensionIndex >= 0){
              metadataArray[dimensionIndex].entities = data;
              metadataArray[dimensionIndex].enumerable = (data.length > 0);
              metadataArray[dimensionIndex].entities_element_types = metadataArrayElementTypeList;
            } else {
              var newDimension = field.metadataDimension;
              newDimension.entities = data;
              newDimension.entities_element_types = metadataArrayElementTypeList;
              newDimension.entities_type = "java.util.List<com.polopoly.metadata.Entity>";
              newDimension.enumerable = (data.length > 0);
              newDimension.enumerable_type = "boolean";
              newDimension.id_type = "java.lang.String";
              newDimension.localizations = { _type: "java.util.Map" };
              newDimension.localizations_type = "java.util.Map";
              newDimension._type = "com.polopoly.metadata.Dimension";
              metadataArray.push(newDimension);
            }
            var dimensionArrayList = [];
            metadataArray.forEach(function (element) {
              dimensionArrayList.push("com.polopoly.metadata.Dimension");
            });
            var dimensionTypePath = "_data/aspects/atex.Metadata/data/metadata/dimensions_element_types";
            atex.onecms.ObjectUtils.accessor(content, dimensionTypePath.substring(1)).value = dimensionArrayList;
            atex.onecms.ObjectUtils.accessor(content, path.substring(1)).value = metadataArray;
          });

        };


        $scope.updateMetadata = function (entries, options, field, modal) {
          var originalValue = field.text;
          //timeout used to workaround scope already in progress

          $timeout(function () {
            return $scope.processMetadata(entries, options, field).
              then(function (response) {
                if (!response) {
                  //if error occurred - restore the model back to it's original value.
                  field.text = originalValue;
                } else {
                  modal.doClose();
                }
                return response ? response : false;
              }).
              then(null, function (error) {
                field.text = originalValue;
                return false;
              });
          },  1);
        };

      },

      link: function (scope, element) {

        scope.$on('$destroy', function () {
          element.remove();
        });

      }
    };
  }]).directive('uiFieldWidget', ['$q', 'ContentService', 'UIConfigurationService', 'DamService', function ($q, ContentService, UIConfigurationService, DamService) {
  return {
    restrict: 'ACE',
    template: '<span ng-include="getContentUrl()"></span>',
    replace: true,
    scope: {
      field: "=",
      entry: "="
    },

    controller: function ($scope) {
      function findUserById(users, userId) {
        var user = _.find(users, function (obj) {
          return obj.principalId === userId;
        });
        return user;
      }

      function getUserInfo(userId) {
        var usersInfo = UIConfigurationService.getUsersInfo();
        if (usersInfo[userId]) {
          return $q.when(usersInfo[userId]);
        } else {
          return DamService.getUserInfo(userId).then(function (users) {
            var user = atex.onecms.ObjectUtils.getByPath(users, "data");
            var info = userId;
            if (user && user.firstname && user.lastname) {
              info = user.firstname + " " + user.lastname;
            }
            if (info === userId && user.loginName !== undefined){
              info = user.loginName;
            }
            UIConfigurationService.getUsersInfo()[userId] = info;
            return info;
          });
        }
      }

      UIConfigurationService.widget($scope.field.name, $scope.field.id).then(function (widget) {
        $scope.widget = widget;

        if (  typeof $scope.widget === 'undefined' ) {
          console.log("widget not found for field = ", $scope.field.id);
          return;
        }

        if ( typeof $scope.widget.type === 'undefined' ) {
          console.log("widget type unknown for field = ", $scope.field.id);
          return;
        }

        switch ($scope.widget.type) {
          case "history-widget": {
            $scope.version = undefined;

            ContentService.getContentHistory({id: $scope.entry.id}).then(function (content) {
              var versions = atex.onecms.ObjectUtils.getByPath(content, "data/versions");

              if (versions) {
                var index = atex.onecms.ObjectUtils.getByPath($scope.widget, "version") || $scope.field.version || "last";

                if (index === "first") {
                  index = 0;
                } else if (index === "last") {
                  index = (versions.length - 1);
                }
                var item = versions[Number(index)];

                DamService.getUsers().then(function (users) {
                  var user = findUserById(users, item.creatorId);
                  $scope.version = {};
                  $scope.version.user = (user && user.name) ? user.name : item.creatorId;
                  $scope.version.date = item.creationTime;
                });
              }
            });

            break;
          }

          case "user-info-widget": {
            var path = atex.onecms.ObjectUtils.getByPath($scope.widget, "path") || "_data/aspects/p.ContentMetadata/data/creatorId";
            var userId = atex.onecms.ObjectUtils.getByPath($scope.entry, path);
            $scope.ready = false;

            if(userId) {
              $scope.info = {};
              getUserInfo(userId).then(function(data) {
                $scope.info.user = data;
                $scope.ready = true;
              });
            }
            break;
          }
        }
      });
    },

    link: function (scope, element) {
      scope.$on('$destroy', function () {
        element.remove();
      });

      scope.translate = function (label) {
        return UIConfigurationService.translate(label);
      };

      scope.getContentUrl = function () {
        return ('views/ui-configuration/widget/field/' + scope.field.name + '-widget.html');
      };
    }
  };
}]).directive('uiResultSetType', ['$q','$rootScope', 'UIConfigurationService', 'ContentService', 'ContentCacheService', function ($q, $rootScope, UIConfigurationService, ContentService, ContentCacheService) {
  return {
    restrict: 'ACE',
    template: '<div ng-include="getContentUrl()"></div>',
    replace: true,
    scope: {
      componentName: "@",
      componentId: "@",
      profile: "@",
      type: "@",
      entry: "=",
      key: "@",
      openEntryCallback: '&',
      selectEntryCallback: '&',
      hasRead: '&',
      isHasReadEnabled: '&',
      expand: "=",
      useLazySource: "@"
    },

    controller: function ($scope) {
      $scope.openEntryCallback = $scope.openEntryCallback();
      $scope.selectEntryCallback = $scope.selectEntryCallback();
      $scope.hasRead = $scope.hasRead();
      $scope.isHasReadEnabled = $scope.isHasReadEnabled();

      function process(widgets) {
        var promises = UIConfigurationService._configuration(widgets);

        $q.all(promises).then(function (_widgets) {
          $scope.widgets = _widgets;
          $scope.style();
        });
      }

      $scope.style = function() {
        var configuration = atex.onecms.ObjectUtils.getByPath($scope.configuration, "add-class");

        if(configuration) {
          var valid = UIConfigurationService.validate($scope.entry, configuration.rules).valid;

          if (valid) {
            $scope.rowStyle = configuration.css.join(" ");
          }
        }
      };

      UIConfigurationService.type($scope.componentName, $scope.componentId, $scope.type, $scope.profile).then(function (_configuration) {
        $scope.configuration = _configuration;
        var _widgets = $scope.configuration.widgets;

        if (!_widgets) {
          UIConfigurationService.type($scope.componentName, $scope.componentId, "default", $scope.profile).then(function (_configuration) {
            if (_configuration.widgets) {
              process(_configuration.widgets);
            }
          });
        } else {
          process(_widgets);
        }
      });
    },

    link: function (scope, element) {
      var publevents = atex.onecms.ObjectUtils.getByPath(scope.entry, "_data/aspects/atex.dam.standard.Publevents/data/publevents");
      var descFullPath = "";
      var isDescFullPathTrim = false;
      if (publevents && publevents.length > 0) {
        if (!scope.publevent) {
          scope.publevent = {};
        }
        scope.publevent.outOfDate = publevents[0].outOfDate;
        scope.publevent.nonPlan = publevents[0].nonPlan;
      }

      scope.resolveDesc = function (path, id, externalId) {
        if (!$rootScope.cache) {
          $rootScope.cache = {};
        }
        // make sure we have a promise cachegit
        if (!$rootScope.resolveDescPromises) {
          $rootScope.resolveDescPromises = {};
        }
        var contentToTranslate;
        if ($rootScope.cache[id]) {
          if(!contentToTranslate) {
            contentToTranslate = atex.onecms.ObjectUtils.getByPath(scope.entry, path);
          }
          if(Array.isArray(contentToTranslate) ){
            if(contentToTranslate.length >0) {
              isDescFullPathTrim = true;
              var contentDetail = contentToTranslate.shift();
              if (contentDetail.startsWith('contentid/')) {
                contentDetail = contentDetail.replace('contentid/', '');
              }
              var contentDescription;
              contentDescription = _.find($rootScope.cache[id], function (obj) {
                return (obj.id === contentDetail);
              });
              if (contentDescription !== undefined) {
                descFullPath = descFullPath.concat(contentDescription.text, " \u2022 ");
                return descFullPath;
              } else {
                return undefined;
              }
            }else{
              if(isDescFullPathTrim){
                descFullPath = descFullPath.slice(0,-2);
                isDescFullPathTrim = false;
              }
              return descFullPath;
            }
          }else {
            if (contentToTranslate.startsWith('contentid/')) {
              contentToTranslate = contentToTranslate.replace('contentid/', '');
            }
            var description;
            description = _.find($rootScope.cache[id], function (obj) {
              return (obj.id === contentToTranslate);
            });
            if (description !== undefined) {
              return description.text;
            } else {
              return undefined;
            }
          }
        } else {
          // check if we already have a call in progress for the same externalId.
          var p = $rootScope.resolveDescPromises[externalId];
          if (!p) {

            // create a deferred and cache it.
            var deferred = $q.defer();
            $rootScope.resolveDescPromises[externalId] = deferred.promise;
            p = $rootScope.resolveDescPromises[externalId];

            // build up the cache
            UIConfigurationService.getLevels(externalId).then(function (returned) {
              $rootScope.cache[id] = UIConfigurationService.flatWorkingSites(returned);
              deferred.resolve(id);
            });
          }
          // not really sure this is working...the 'resolveDesc' seems to be called by a template to resolve
          // the site name...but here it was called in a promise and do not return anything.
          p.then(function() {
            return scope.resolveDesc(path, id, externalId);
          });
          return p;
        }
      };

      scope.showDesc = function(path) {
        return atex.onecms.ObjectUtils.getByPath(scope.entry, path) !== undefined;
      };

      scope.$on('$destroy', function () {
        element.remove();
      });

      if (!scope.openEntryCallback) {
        scope.openEntryCallback = function () {
        };
      }

      if (!scope.selectEntryCallback) {
        scope.selectEntryCallback = function () {
        };
      }

      if (!scope.hasRead) {
        scope.hasRead = function () {
        };
      }

      if (!scope.isHasReadEnabled) {
        scope.isHasReadEnabled = function () {
        };
      }

      scope.hide = function(ruleset) {
        var hide = false;

        if(ruleset) {
          hide = UIConfigurationService.validate(scope.entry, ruleset).valid;
        }

        return hide;
      };

      scope.select = function (entry) {
        scope.selectEntryCallback(entry);
      };

      scope.getContentUrl = function () {
        return 'views/ui-configuration/result-list/' + scope.componentName + '/template.html';
      };

      scope.translate = function (message) {
        if (!message && scope.field !== undefined) {
          console.error("scope.translate (uiResultSetType): UNDEFINED message for " + scope.field.value.model.attribute);
        }
        return UIConfigurationService.translate(message);
      };

      var translateArrayOfContentIdToText = function(path, name) {
        var contentIdArray = atex.onecms.ObjectUtils.getByPath(scope.entry, path) || [];
        var namePath = name.replace("_data/", "data/");
        var defaultFallback = "";

        if (_.isArray(contentIdArray) && contentIdArray.length > 0) {
          var promises = contentIdArray.map(function (contentId) {
            return ContentCacheService.get('name-' + contentId, function () {
              return ContentService.getContent({id: contentId}).then(function(item) {
                return atex.onecms.ObjectUtils.getByPath(item, namePath);
              }, function(error) {
                console.log("Error getting " + contentId + "\nERROR: " + error.cause);
                return defaultFallback;
              });
            });
          });

          return $q.all(promises).then(function (resolved) {
            return _.reduce(resolved, function (acc, entry) {
              return acc + ", " + entry;
            });
          });
        }
        return $q.when(defaultFallback);
      };

      scope.publicTranslateArrayOfContentId = function (config) {
        var path = config.path || '_data/aspects/contentData/data/relatedSections';
        var name = config.name || '_data/aspects/contentData/data/name';
        translateArrayOfContentIdToText(path, name).then(function (data) {
          scope.text = data;
        });
      };

      scope.getText = function (path) {
        return UIConfigurationService.getText(atex.onecms.ObjectUtils.getByPath(scope.entry, path) || "");
      };

      scope.getTimeZoneDate = function (path, offset) {
        return UIConfigurationService.getTimeZoneDate(atex.onecms.ObjectUtils.getByPath(scope.entry, path) || "", offset);
      };

      scope.getPath = function (path) {
        return atex.onecms.ObjectUtils.getByPath(scope.entry, path);
      };

      scope.getEntities = function (path, id) {
        var dimensions = scope.getPath(path) || [];

        var dimension = _.find(dimensions, function (dimension) {
          return (dimension.id === id);
        });

        var entities = atex.onecms.ObjectUtils.getByPath(dimension, "entities") || [];

        return _.map(entities, function (entity) {
          return entity.name;
        });
      };

      scope.evalCondition = function (field) {
        var result = false;

        var lhsText = scope.getText(field.value.path);

        if (lhsText === '') {
          return false;
        }

        var evalStr = "\"use strict\";return (\"" + lhsText + "\" ";

        if (field.display.condition) {
          evalStr += field.display.condition;
        }

        if (field.display.path) {
          evalStr += " \"" + scope.getText(field.display.path) + "\"";
        }

        if (field.display.value) {
          evalStr += " \"" + field.display.value + "\"";
        }

        evalStr += ")";

        try {
          /*jshint -W054 */
          var codeRunner = new Function(evalStr);
          result = codeRunner.call();
          /*jshint +W054 */
        } catch (error) {
        }

        return result;
      };

      scope.getDimension = function (path) {
        return atex.onecms.ObjectUtils.getByPath(scope.entry, path);
      };


      scope.getLimit = function (value) {
        return (value) ? (value.limit) ? value.limit : 0 : 0;
      };

      scope.to_trusted = function (txt, limit, expand) {
        return UIConfigurationService.to_trusted(txt, limit, expand);
      };

      scope.hasClip = function() {
        return !!atex.onecms.ObjectUtils.getByPath(scope.entry, "_data/aspects/contentData/data/clippingPath");
      };
    }
  };

}]).directive('uiGridEntry', ['$q', 'UIConfigurationService', 'DamListService','$rootScope', function ($q, UIConfigurationService, DamListService, $rootScope) {
  return {
    restrict: 'ACE',
    template: '<div ng-include="getContentUrl()"></div>',
    replace: true,
    scope: {
      key: "@",
      componentName: "@",
      componentId: "@",
      profile: "@",
      type: "@",
      entry: "=",
      fullscreen: "=",
      selectEntryCallback: '&',
      hasRead: '&',
      isHasReadEnabled: '&',
      handleDragStart: "&",
      handleDragEnd: "&",
      openEntryCallback: "&"
    },

    controller: function ($scope) {
      $scope.selected = DamListService.getSelected();

      $scope.selectEntryCallback = $scope.selectEntryCallback();
      $scope.hasRead = $scope.hasRead();
      $scope.isHasReadEnabled = $scope.isHasReadEnabled();
      $scope.handleDragStart = $scope.handleDragStart();
      $scope.handleDragEnd = $scope.handleDragEnd();

      $scope.openEntryCallback = $scope.openEntryCallback();
      if (!$scope.openEntryCallback) {
        $scope.openEntryCallback = function () {
        };
      }

      $scope.style = function() {
        var configuration = atex.onecms.ObjectUtils.getByPath($scope.configuration, "add-class");

        if(configuration) {
          var valid = UIConfigurationService.validate($scope.entry, configuration.rules).valid;

          if (valid) {
            $scope.rowStyle = configuration.css.join(" ");
          }
        }
      };

      UIConfigurationService.type($scope.componentName, $scope.componentId, $scope.type, $scope.profile).then(function (_configuration) {
        $scope.configuration = {
          rows: []
        };

        var thumbnail = atex.onecms.ObjectUtils.getByPath(_configuration, "thumbnail");
        var placeholder = atex.onecms.ObjectUtils.getByPath(_configuration, "placeholder");
        var displayThumbnails = atex.onecms.ObjectUtils.getByPath(_configuration, "display-thumbnails") || [];
        var addClass = atex.onecms.ObjectUtils.getByPath(_configuration, "add-class");

        if (thumbnail) {
          var path = atex.onecms.ObjectUtils.getByPath(thumbnail, "path");

          $scope.configuration.thumbnail = {};
          $scope.configuration.thumbnail.url = atex.onecms.ObjectUtils.getByPath($scope.entry, path);
          $scope.configuration.thumbnail.style = atex.onecms.ObjectUtils.getByPath(thumbnail, "style");
          $scope.configuration.thumbnail.css = atex.onecms.ObjectUtils.getByPath(thumbnail, "css");
        }

        if (placeholder) {
          var field = atex.onecms.ObjectUtils.getByPath(placeholder, "field");

          $scope.configuration.placeholder = {};
          $scope.configuration.placeholder.text = atex.onecms.ObjectUtils.getByPath($scope.entry, field) || "";
          $scope.configuration.placeholder.limit = atex.onecms.ObjectUtils.getByPath(placeholder, "limit") || 0;
          $scope.configuration.placeholder.style = atex.onecms.ObjectUtils.getByPath(placeholder, "style");
          $scope.configuration.placeholder.css = atex.onecms.ObjectUtils.getByPath(placeholder, "css");
        }

        if (displayThumbnails) {
          $scope.configuration['display-thumbnails'] = displayThumbnails;
        }

        $scope.configuration.section = {
          placeholder: true,
          thumbnail: false,
          thumbnails: false
        };

        if ($scope.isValidUrl()) {
          $scope.configuration.section.placeholder = false;
          $scope.configuration.section.thumbnails = false;
          $scope.configuration.section.thumbnail = true;
        } else if ($scope.canDisplayThumbnails()) {
          $scope.configuration.section.placeholder = false;
          $scope.configuration.section.thumbnail = false;
          $scope.configuration.section.thumbnails = true;
        }

        if(addClass) {
          $scope.configuration['add-class'] = addClass;
        }

        _.forEach(_configuration.rows, function (row) {
          var promises = UIConfigurationService._configuration(row.widgets);

          $q.all(promises).then(function (_widgets) {
            $scope.configuration.rows.push({"widgets": _widgets});
            $scope.style();
          });
        });
      });

      $scope.isValidUrl = function () {
        return ($scope.configuration.thumbnail && $scope.configuration.thumbnail.url);
      };

      $scope.canDisplayThumbnails = function () {
        var type = atex.onecms.ObjectUtils.getByPath($scope.entry, "_data/aspects/contentData/data/objectType") || "";
        return _.contains($scope.configuration['display-thumbnails'], type);
      };

      $scope.info = function () {
        var info = {};

        info.name = atex.onecms.ObjectUtils.getByPath($scope.entry, "_data/aspects/contentData/data/name") || "";
        info.id = atex.onecms.ObjectUtils.getByPath($scope.entry, "id") || "";
        info.type = atex.onecms.ObjectUtils.getByPath($scope.entry, "_data/aspects/contentData/data/inputTemplate") || "";
        info._type = atex.onecms.ObjectUtils.getByPath($scope.entry, "_data/aspects/contentData/data/_type") || "";
        info.dragUrl = atex.onecms.ObjectUtils.getByPath($scope.entry, "_data/aspects/contentData/data/thumbUrl") || "";

        return info;
      };
    },

    link: function (scope, element) {
      var publevents = atex.onecms.ObjectUtils.getByPath(scope.entry, "_data/aspects/atex.dam.standard.Publevents/data/publevents");

      if (publevents && publevents.length > 0) {
        if (!scope.publevent) {
          scope.publevent = {};
        }
        scope.publevent.outOfDate = publevents[0].outOfDate;
        scope.publevent.nonPlan = publevents[0].nonPlan;
      }
      scope.$on('$destroy', function () {
        element.remove();
      });

      if (!scope.selectEntryCallback) {
        scope.selectEntryCallback = function () {
        };
      }

      if (!scope.hasRead) {
        scope.hasRead = function () {
        };
      }

      if (!scope.isHasReadEnabled) {
        scope.isHasReadEnabled = function () {
        };
      }

      if (!scope.handleDragStart) {
        scope.handleDragStart = function (attributes) {
        };
      }

      if (!scope.handleDragEnd) {
        scope.handleDragEnd = function (attributes) {
        };
      }

      scope.select = function (entry, event) {
        scope.selectEntryCallback(entry, event);
      };


      scope.selectDbl = function (entry, event) {
        scope.selectEntryCallback(entry, event);
        if (entry._data && entry._data.aspects.contentData.data.objectType){
          $rootScope.$broadcast("dam:openPreviewImage",entry);
        }
      };

      scope.getContentUrl = function () {
        return 'views/ui-configuration/result-list/' + scope.componentName + '/template.html';
      };

      scope.getText = function (content) {
        return UIConfigurationService.getText(content);
      };

      scope.getTimeZoneDate = function (path, offset) {
        return UIConfigurationService.getTimeZoneDate(atex.onecms.ObjectUtils.getByPath(scope.entry, path) || "", offset);
      };

      scope.to_trusted = function (txt, limit, expand) {
        return UIConfigurationService.to_trusted(txt, limit, expand);
      };
    }
  };
}]).directive('uiFacet', ['UIConfigurationService', function (UIConfigurationService) {
  return {
    restrict: 'A',

    link: function (scope, element, attrs) {
      UIConfigurationService.facet(attrs.componentName, attrs.componentId, attrs.fieldId).then(function (configuration) {
        if (!configuration.visibility) {
          element.remove();
        }
      });
    }
  };
}]).directive('uiDropDownMenu', ['$rootScope', '$q', 'AuthenticationService', 'ApplicationConfigurationService', 'UIConfigurationService', 'UserProfileService', 'configuration', 'DamAuthorService',
  function ($rootScope, $q, AuthenticationService, ApplicationConfigurationService, UIConfigurationService, UserProfileService, configuration, DamAuthorService) {
    return {
      restrict: 'ACE',
      templateUrl: 'views/ui-configuration/menu/ui-dropdown-menu.html',
      replace: true,

      scope: {
        componentName: "@",
        componentId: "@",
      },

      controller: function ($scope) {
        $scope.check = [];
        $scope.items = [];

        var configuring = false;

        function configure() {
          if (configuring) {
            return;
          }
          configuring = true;
          AuthenticationService.getCurrentUser().then(function (user) {
            var promiseArray = [];
            promiseArray.push(UserProfileService.disableAction({'action': 'manage-authors', 'application': 'desk'}).then(function (disable) {
              $scope.check['canManageAuthors'] = (typeof disable === 'undefined') || !disable;
            }));
            $scope.check['isAdmin'] = (user && user.userId === "98");
            $scope.check['adminGUIUrl'] = configuration.getAdminGUIUrl();

            promiseArray.push(configuration.getPublishingScheduleEnabled().then(function (data) {
              $scope.check['publishingScheduleEnabled'] = data;
            }));

            promiseArray.push(configuration.getJobsEnabled().then(function (data) {
              $scope.check['jobsEnabled'] = data;
            }));

            promiseArray.push(ApplicationConfigurationService.getConfigurationFor(['printPageUrl']));
            promiseArray.push(DamAuthorService.loadAuthorByLoginName(user.username).then(function(author) {
              $scope.check['canEditMyAuthor'] = !!author;
              return $scope.check['canEditMyAuthor'];
            }));

            $q.all(promiseArray).then(function (result) {
              if (!_.isEmpty(result[0])) {
                $scope.check['printPageGUIUrl'] = result[0] + "/#/nopage";
              }
              list();
            }).finally(function() {
              configuring = false;
            });
          }).then(null, function(error) {
            configuring = false;
          });
        }

        function isVisible(item) {
          return item.check ? $scope.check[item.check] : true;
        }

        function list() {
              UIConfigurationService.dropDown($scope.componentName, $scope.componentId).then(function (configuration) {
                var items = atex.onecms.ObjectUtils.getByPath(configuration, "items") || [];
                _.each(items, function (item) {
                  if (isVisible(item)) {
                    if (item['href-config']) {
                      item.href = $scope.check[item['href-config']];
                    }

                    $scope.items.push(item);
                  }
                });
              });

        }

        $scope.$on("dam:logout", function() {
          $scope.check.length = 0;
          $scope.items.length = 0;
        });

        $scope.$on("onecms:authenticationSuccess", function() {
          configure();
        });

        configuration.whenReady().then(function () {
          configure();
        });
      },

      link: function (scope) {}
    };
  }]).directive('uiToolbar', ['UIConfigurationService', function (UIConfigurationService) {
  return {
    restrict: 'A',

    link: function (scope, element, attrs) {
      scope.$on('$destroy', function () {
        element.remove();
      });

      UIConfigurationService.toolbar(attrs.componentName, attrs.componentId).then(function (configuration) {
        if (!configuration) {
          element.remove();
        } else if (!configuration.visibility) {
          element.remove();
        }
      });
    }
  };
}]).directive('uiToolbarButton', ['UIConfigurationService', function (UIConfigurationService) {
  return {
    restrict: 'A',

    link: function (scope, element, attrs) {
      scope.$on('$destroy', function () {
        element.remove();
      });

      UIConfigurationService.button(attrs.componentName, attrs.componentId, attrs.buttonId).then(function (configuration) {
        if (!configuration.visibility) {
          element.remove();
        }
      });
    }
  };
}]).directive('uiToolbarOperation', ['UIConfigurationService', 'DamTemplateService', 'LocalAppService', '$window',
  function (UIConfigurationService, DamTemplateService, LocalAppService, $window) {
    return {
      restrict: 'ACE',
      templateUrl: 'views/ui-configuration/toolbar/ui-toolbar-operation.html',
      replace: true,

      scope: {
        componentName: "@",
        componentId: "@",
        entries: "=",
        buttonEnabled: "=",
        showEdit: "="
      },

      controller: function ($scope) {
        $scope.hasEditTemplates = false;
        $scope.hasPreviewTemplates = false;
        $scope.hasLocalAppTemplates = false;
        $scope.hasEditAllTemplates = false;

        $scope.visibility = {};
        $scope.localAppVisibility = true;

        UIConfigurationService.toolbar($scope.componentName, $scope.componentId).then(function (configuration) {
          $scope.toolbar = configuration;
        });

        function checkDisableFnc(_operation, editApp, entry) {
          var _visibility = atex.onecms.ObjectUtils.getByPath(_operation, editApp + "/visibility");
          var _excludeType = atex.onecms.ObjectUtils.getByPath(_operation, editApp + "/excludeType");
          if (_excludeType !== undefined){
            _visibility = !_excludeType.includes(entry._data.aspects.contentData.data.objectType);
          }
          $scope.visibility[editApp] = _visibility;
          if (_visibility) {
            var disFnc = atex.onecms.ObjectUtils.getByPath(_operation, editApp + "/disableFn");
            if (disFnc) {
              /*jslint evil: true */
              var disableFn = new Function(disFnc);
              if (disableFn && disableFn.call(null, entry._data)) {
                $scope.visibility[editApp] = false;
              }
              /*jslint evil: false */
            }
          }
        }

        function getEditRule() {
          $scope.entries.forEach(function (entry) {
            var template = atex.onecms.ObjectUtils.getByPath(entry, "_data/aspects/contentData/data/inputTemplate");

            var name = (atex.onecms.ObjectUtils.getByPath($scope.toolbar, "operations/edit/name"));
            var id = (atex.onecms.ObjectUtils.getByPath($scope.toolbar, "operations/edit/id"));

            UIConfigurationService.operation(name, id).then(function (_operation) {

              checkDisableFnc(_operation, "inline", entry);
              checkDisableFnc(_operation, "localapp", entry);

              $scope.toolbar.edit = _operation;

              if ($scope.toolbar.edit && template) {
                $scope.hasEditTemplates = ($scope.toolbar.edit.templates[0] !== "*") ? ($scope.toolbar.edit.templates.indexOf(template) > -1) : true;

                if (LocalAppService && LocalAppService.isConfigured() && $scope.toolbar.edit.localapp && $scope.toolbar.edit.localapp.templates) {
                  $scope.hasLocalAppTemplates = ($scope.toolbar.edit.localapp.templates[0] !== "*") ?
                    ($scope.toolbar.edit.localapp.templates.indexOf(template) > -1) : true;

                  if ($scope.hasLocalAppTemplates) {
                    $scope.toolbar.edit.localapp.isAvailable = LocalAppService.isAvailable();
                  }
                }

                if ($scope.hasEditTemplates && $scope.toolbar.edit.callback) {
                  DamTemplateService.getActTemplateFor(entry, false, $scope.toolbar.edit.doNotCheckInputTemplate).then(function (templates) {
                    if($scope.toolbar.edit.visibilityChecks){
                      for (var check in $scope.toolbar.edit.visibilityChecks) {
                        var disFnc = atex.onecms.ObjectUtils.getByPath(_operation, "visibilityChecks/"+ check + "/disableFn");
                        var templateVisible = true;
                        if(disFnc) {
                          /*jslint evil: true */
                          var disableFn = new Function(disFnc);
                          if (disableFn && disableFn.call(null, entry._data)) {
                            templateVisible = false;
                          }
                          /*jslint evil: false */
                        }
                        for(var i=0; i < templates.length; i++){
                          if(templates[i].id === check && !templateVisible){
                            templates.splice(i, 1);
                          }
                        }
                      }
                    }
                    $scope.toolbar.edit.editorTemplates = templates;
                    $scope.hasEditTemplates = (templates.length > 0);
                  });
                }
              }
            });
            if (template === "p.DamImage" && $scope.entries.length > 1) {
              $scope.hasEditAllTemplates = true;
            } else {
              $scope.hasEditAllTemplates = false;
              $scope.hasEditTemplates = false;
            }
          });
        }

        function getPreviewRule() {
          $scope.entries.forEach(function (entry) {
            var template = atex.onecms.ObjectUtils.getByPath(entry, "_data/aspects/contentData/data/inputTemplate");

            var name = (atex.onecms.ObjectUtils.getByPath($scope.toolbar, "operations/preview/name")) || "";
            var id = (atex.onecms.ObjectUtils.getByPath($scope.toolbar, "operations/preview/id")) || "";

            UIConfigurationService.operation(name, id).then(function (_operation) {
              $scope.toolbar.preview = _operation;

              if ($scope.toolbar.preview && template) {
                $scope.hasPreviewTemplates = ($scope.toolbar.preview.templates[0] !== "*") ? ($scope.toolbar.preview.templates.indexOf(template) > -1) : true;
              }
            });
          });
        }

        function reset() {
          $scope.hasEditTemplates = false;
          $scope.hasPreviewTemplates = false;

          if ($scope.toolbar && $scope.toolbar.edit && $scope.toolbar.edit.editorTemplates) {
            $scope.toolbar.edit.editorTemplates.length = 0;
          }
        }

        $scope.$watch('entries', function (newValues, oldValues) {
          if (newValues !== oldValues && newValues.length > 0) {
            reset();

            getEditRule();
            getPreviewRule();
          }
        }, true);
      },

      link: function (scope, element) {
        scope.$on('$destroy', function () {
          element.remove();
        });

        scope.translate = function (message) {
          if (!message) {
            console.error("scope.translate (uiToolbarOperation): UNDEFINED message for componentId: " + scope.componentId + " - componentName: " + scope.componentName);
          }
          return UIConfigurationService.translate(message);
        };

        scope.edit = function () {
          var ids = atex.dam.AngularUtils.getIdsArray(scope.entries);
          $window.atex.analytics('event', {e: 'edit', d1: ids});
          UIConfigurationService.editInCurrentWindow();
          return UIConfigurationService.edit(scope.entries, scope.showEdit);
        };

        scope.editAll = function () {
          var ids = atex.dam.AngularUtils.getIdsArray(scope.entries);
          $window.atex.analytics('event', {e: 'edit', d1: ids});
          return UIConfigurationService.edit(scope.entries, scope.showEdit);
        };

        scope.getConditionalLabel = function(condition) {
          if (condition[scope.entries[0]._data.aspects.contentData.data.objectType]){
            return scope.translate(condition[scope.entries[0]._data.aspects.contentData.data.objectType]);
          }else{
            return scope.translate(condition["default"]);
      }
    };
      }
    };
  }]).directive('uiToolbarMenu', ['UIConfigurationService','AuthenticationService','$http', 'DamNotificationService',
    function(UIConfigurationService,AuthenticationService, $http, DamNotificationService) {
  return {
    restrict: 'ACE',
    templateUrl: 'views/ui-configuration/toolbar/ui-toolbar-menu.html',
    replace: true,

    scope: {
      "componentName": "@",
      "componentId": "@",
      "entries": "=",
      "showList": "="
    },

    controller: function ($scope) {
      UIConfigurationService.toolbar($scope.componentName, $scope.componentId).then(function (configuration) {
        $scope.toolbar = configuration;
        var buttons = (atex.onecms.ObjectUtils.getByPath($scope.toolbar, "buttons")) || [];
        $scope.shortcut = _.find(buttons, function (button) {
          return button.default;
        });
      });

      $scope.$watch('entries', function (newValues, oldValues) {
        if (newValues !== oldValues && newValues.length > 0) {
          $scope.reset();

          $scope.entries.forEach(function (entry) {
            var template = entry._data.aspects.contentData.data.inputTemplate;
            var partitionDimensions;
            if (entry._data.aspects["atex.Metadata"]) {
              partitionDimensions = _.where(entry._data.aspects["atex.Metadata"].data.metadata.dimensions, {"id": "dimension.partition"});
            }
            $scope.toolbar.buttons.forEach(function (button) {

              if (button.templates && button.templates[0] !== "*") {
                if (button.templates.indexOf(template) === -1) {
                  button.display = false;
                }
              }

              if (button.excludeTemplates) {
                if (button.excludeTemplates.indexOf(template) !== -1) {
                  button.display = false;
                }
              }

              if (partitionDimensions && partitionDimensions.length > 0 && button.partitions && button.partitions[0] !== "*") {
                var count = 0;
                button.partitions.forEach(function (partition) {
                  if (_.where(partitionDimensions[0].entities, {"id": partition}).length > 0) {
                    count++;
                  }
                });
                if (count === 0) {
                  button.display = false;
                }
              }

            });
          });
        }
      }, true);

      $scope.reset = function () {
        var buttons = atex.onecms.ObjectUtils.getByPath($scope.toolbar, 'buttons');
        if (buttons) {
          buttons.forEach(function (button) {
            button.display = true;
          });
        }
      };
    },

    link: function (scope, element) {
      scope.$on('$destroy', function () {
        element.remove();
      });

      scope.callback = function (jsString) {
        /*jslint evil: true */
        try {
          var fn = new Function(jsString);
          var param = {
            "entries": scope.entries,
            "AuthenticationService": AuthenticationService,
            "$http": $http,
            "DamNotificationService": DamNotificationService
          };
          fn.call(null, param);
        } catch (e) {
          if (e instanceof SyntaxError) {
            alert(e.message);
          }
        }

        /*jslint evil: false */
      };

      scope.method = function (operation, button) {
        return scope.$parent[operation](button);
      };

      scope.translate = function (message) {
        if (!message && scope.field !== undefined) {
          console.error("scope.translate (uiToolbarMenu): UNDEFINED message for " + scope.field.value.model.attribute);
        }
        return UIConfigurationService.translate(message);
      };

      scope.disabled = function () {
        return !(scope.showList && scope.entries.length > 0);
      };

      scope.active = function () {
        return !(this.disabled());
      };

      scope.check = function (condition) {
        var visible = true;

        if (condition) {
          visible = (condition.endsWith("()")) ? this.method(condition.split("()")[0]) : scope.$parent[condition];
        }

        return visible;
      };

      scope.isToolbarButtonEnabled = function (shortcut) {
        var checkEnabled = true;
        if (shortcut) {
          scope.toolbar.buttons.forEach(function (button) {
            if (shortcut.buttonId === button.buttonId) {
              checkEnabled = button.display;
            }
          });
        }
        return checkEnabled;
      };

      scope.getTemplate = function (configurations, entries) {
        var template;

        if (configurations && entries) {
          var type = atex.onecms.ObjectUtils.getByPath(entries[0], '_data/aspects/contentData/data/objectType');

          var _configuration = _.find(configurations, function (configuration) {
            return configuration.type === type;
          });

          if (_configuration) {
            template = _configuration.template;
          }
        }

        return template;
      };
    }
  };
}]).directive('dynamic', function ($compile) {
  return {
    restrict: 'A',
    replace: true,

    link: function (scope, element, attrs) {
      scope.$watch(attrs.dynamic, function (html) {
        element.html(html);
        scope.generated = $compile(element.contents())(scope);
      });

      scope.$on('$destroy', function () {
        if (scope.generated) {
          scope.generated.remove();
        }
      });
    }
  };
}).directive('dynamicFieldSearch', function ($compile) {
  return {
    restrict: 'ACE',
    replace: true,

    scope: {
      "queryModel": "=",
      "html": "@"
    },

    link: function (scope, element) {
      element.html(scope.html);
      scope.generated = $compile(element.contents())(scope);

      scope.$on('$destroy', function () {
        if (scope.generated) {
          scope.generated.remove();
        }
      });
    }
  };
}).directive('dynamicController', ['$compile', '$parse', function ($compile, $parse) {
  return {
    restrict: 'A',
    replace: true,
    terminal: true,

    link: function (scope, element) {
      var name = $parse(element.attr('dynamic-controller'))(scope);
      element.removeAttr('dynamic-controller');
      element.attr('ng-controller', name);
      scope.generated = $compile(element)(scope);

      scope.$on('$destroy', function () {
        if (scope.generated) {
          scope.generated.remove();
        }
      });
    }
  };
}]).directive('dynamicUrl', ['$compile', '$parse', function ($compile, $parse) {
  return {
    restrict: 'A',
    replace: true,
    terminal: true,

    link: function (scope, element) {
      var value = $parse(element.attr('dynamic-url'))(scope);
      value = (!value) ? "true" : value;

      element.removeAttr('dynamic-url');
      if (value === "true") {
        element.attr('dam-lazy-src', '{{getPath(configuration.image.path)}}');
      } else {
        element.attr('ng-src', '{{getPath(configuration.image.path)}}');
      }
      scope.generated = $compile(element)(scope);

      scope.$on('$destroy', function () {
        if (scope.generated) {
          scope.generated.remove();
        }
      });
    }
  };
}]).directive('uiAutoCompleteQuery', ['$q', 'ContentConfigurationService', 'UIConfigurationService',
  function ($q, ContentConfigurationService, UIConfigurationService) {
    return {
      restrict: 'AE',

      scope: {
        query: '=',
        field: '='
      },

      controller: function ($scope) {
        $scope.create = function(tags, level) {
          var tag = {
            id: level.id,
            children: [],
            text: UIConfigurationService.translate(level.label)
          };

          tags.push(tag);
          return tag;
        };

        $scope.tags = function () {
          var deferred = $q.defer();

          var tags = [];
          var id = atex.onecms.ObjectUtils.getByPath($scope.field, 'value/external-id');

          ContentConfigurationService.getConfiguration({id: "externalid/" + id}).then(function (content) {
            var publications = atex.onecms.ObjectUtils.getByPath(content, 'data/aspects/contentData/data/publications') || [];
            var levels = atex.onecms.ObjectUtils.getByPath($scope.field, 'value/levels') || [];

            _.each(levels, function (level) {
              _.each(publications, function (publication, key) {
                if (!key.endsWith("_type") && !key.endsWith("_types")) {
                  var tag = _.find(tags, function (_tag) {
                    return _tag.id === level.id;
                  }) || $scope.create(tags, level);

                  if (publication.level === level.id) {
                    tag.children.push({id: publication.id, text: publication.id, publication: publication, level: level});
                  }
                }
              });
            });

            deferred.resolve(tags);
          });

          return deferred.promise;
        };
      },

      link: function (scope, element) {
        scope.$on('$destroy', function () {
          element.remove();
          scope.$destroy();
        });

        function filter(tags, term) {
          term = term.toLowerCase();
          var _results = [];

          _.each(tags, function (_tag) {
            _.each(_tag.children, function (child) {
              var text = child.text.toLowerCase();

              if (text.indexOf(term) > -1) {
                var tag = _.find(_results, function (_result) {
                  return _result.id === child.level.id;
                }) || scope.create(_results, child.level);

                tag.children.push(child);
              }
            });
          });

          _.each(tags, function (_tag) {
            var text = _tag.text.toLowerCase();

            if (text.indexOf(term) > -1) {
              _results.push(_tag);
            }
          });

          return _results;
        }

        function find(tags, id) {
          var _result;

          _.each(tags, function (_tag) {
            _.each(_tag.children, function (child) {

              if (child.id === id) {
                _result = child;
              }
            });
          });

          return _result;
        }

        function set(object) {
          if (!scope.query.set[object.level.model]) {
            scope.query.set[object.level.model] = [];
          }

          var content = _.find(scope.query.set[object.level.model], function (value) {
            return value.id === object.publication.id;
          });

          if (!content) {
            scope.query.set[object.level.model].push(UIConfigurationService.toJson(object.publication.id, object.publication));
          }

          if (object.publication.parent) {
            scope.tags().then(function (tags) {
              var content = find(tags, object.publication.parent);
              if (content) {
                return set(content);
              }
            });
          }
        }

        element.attr('title', UIConfigurationService.translate(scope.field.value.placeholder));

        $(element).select2({
          minimumInputLength: 2,

          placeholder: UIConfigurationService.translate(scope.field.value.placeholder),

          containerCss: UIConfigurationService.toCss(scope.field.value.style, {"width": "100%"}),

          formatInputTooShort: function () {
            return UIConfigurationService.translate('_AUTOCOMPLETE_MIN_CHARACTER_');
          },

          formatSelection: function (object) {
            return object.text;
          },

          query: _.debounce(function (query) {
            scope.tags().then(function (tags) {
              return query.callback({more: false, results: filter(tags, query.term)});
            });
          }, 200),

          tags: function () {
            return [];
          },

          formatNoMatches: function () {
            return '';
          }
        });

        element.on('change', function () {
          var objects = angular.copy(element.select2('data'));

          if (!scope.query.set) {
            scope.query.set = {};
          }

          var contents = [];
          _.each(objects, function(object) {
            if(object.children) {
              contents = contents.concat(object.children);
            } else {
              contents.push(object);
            }
          });

          contents.forEach(function (content) {
            set(content);
            element.select2('data', []);

            scope.$parent.$apply(function () {
              scope.queryModel = scope.query;
            });
          });
        });
      }
    };
  }]).directive('uiSuggestMetadata', ['$rootScope', '$q', 'ContentService', 'UIConfigurationService', function ($rootScope, $q, ContentService, UIConfigurationService) {
  return {
    require: '^ngModel',

    scope: {
      model: '=ngModel',
      field: '=field',
      useOperator: "="
    },

    controller: function ($scope) {
      if (!$rootScope.cache) {
        $rootScope.cache = {};
      }

      $scope.getSitesTags = function () {
        var deferred = $q.defer();

        var id = atex.onecms.ObjectUtils.getByPath($scope.field, 'value/id');
        if (!id) {
          id = '-internal-security-parent';
        }

        if ($rootScope.cache[id]) {
          deferred.resolve($rootScope.cache[id]);
        } else {
          if (id === '-internal-security-parent') {
            UIConfigurationService.getExcludedSites().then(function (excluded) {
              return UIConfigurationService.getWorkingSites(excluded).then(function (sites) {
                $rootScope.cache[id] = UIConfigurationService.flatWorkingSites(sites);
                deferred.resolve($rootScope.cache[id]);
              });
            });
          } else {
            var externalId = atex.onecms.ObjectUtils.getByPath($scope.field, 'value/external-id');

            UIConfigurationService.getLevels(externalId).then(function (sites) {
              $rootScope.cache[id] = UIConfigurationService.flatWorkingSites(sites);
              deferred.resolve($rootScope.cache[id]);
            });
          }
        }

        return deferred.promise;
      };
    },

    link: function (scope, element, attrs, ngModel) {
      scope.$on('$destroy', function () {
        element.remove();
        scope.$destroy();
      });

      element.attr('title', UIConfigurationService.translate(scope.field.value.placeholder));

      $(element).select2({
        minimumInputLength: 2,

        formatInputTooShort: function () {
          return UIConfigurationService.translate('_AUTOCOMPLETE_MIN_CHARACTER_');
        },

        formatSelection: function (object) {
          return object.text;
        },

        query: _.debounce(function (query) {
          scope.getSitesTags().then(function (tags) {
            return query.callback({more: false, results: UIConfigurationService.filterWorkingSites(tags, query.term)});
          });
        }, 200),

        tags: function () {
          return [];
        },

        placeholder: UIConfigurationService.translate(scope.field.value.placeholder),

        formatNoMatches: function () {
          return '';
        },
        containerCss: UIConfigurationService.toCss(scope.field.value.style, {"width": "100%"})
      });

      ngModel.$render = function () {
        scope.getSitesTags().then(function (tags) {
          var entries = angular.copy(ngModel.$viewValue) || [];

          var promises = entries.map(function (contentId) {
            return _.find(tags, function (_tag) {
              return _tag.id === contentId;
            });
          });

          $q.all(promises).then(function (tags) {
            tags = _.filter(tags, function (tag) {
              return (tag !== undefined);
            });

            element.select2('data', tags);
          });
        });
      };

      element.on('select2-open', function () {
        atex.dam.AngularUtils.width(element, 0);
        atex.dam.AngularUtils.getNode(element, '.input-group-addon').hide();

        var node = atex.dam.AngularUtils.getNode(element, '.select2-choices');
        $(node).css('border-radius', '4px 4px 0 0');
        if(scope.useOperator) {
          $(node).css('border-right', '1px solid #5897fb');
          $(node).css('box-shadow', 'none');
        }

        var width = atex.dam.AngularUtils.getWidth(element);
        $('.select2-drop-active').width(width - 2);
      });

      element.on('select2-close', function () {
        atex.dam.AngularUtils.getNode(element, '.input-group-addon').show();

        var node = atex.dam.AngularUtils.getNode(element, '.select2-choices');
        if(scope.useOperator) {
          $(node).css('border-radius', '4px 0 0 4px');
          $(node).css('border-right', 'none');
        } else {
          $(node).css('border-radius', '4px');
          $(node).css('border-right', '1px solid #aaa;');
        }

        var width = atex.dam.AngularUtils.getWidth(element);
        $('.select2-drop-active').width(width + 2);
      });

      element.on('change', function () {
        var objects = angular.copy(element.select2('data'));

        var values = [];
        objects.forEach(function (object) {
          values.push(object.id);
        });

        scope.$apply(function () {
          ngModel.$setViewValue(values);
        });

        if (scope.selectPresetCallBack) {
          scope.selectPresetCallBack();
        }
      });
    }
  };
}]).directive('uiSuggestField', ['DamService', 'UIConfigurationService', function (DamService, UIConfigurationService) {
  return {
    require: '^ngModel',

    scope: {
      model: '=ngModel',
      field: '=field',
      useOperator: "="
    },

    controller: function ($scope) {
    },

    link: function (scope, element, attrs, ngModel) {
      scope.$on('$destroy', function () {
        element.remove();
        scope.$destroy();
      });

      element.attr('title', UIConfigurationService.translate(scope.field.value.placeholder));

      $(element).select2({
        minimumInputLength: 2,

        formatInputTooShort: function () {
          return UIConfigurationService.translate('_AUTOCOMPLETE_MIN_CHARACTER_');
        },

        formatSelection: function (object) {
          return object.text;
        },


        query: _.debounce(function (query) {
          var solrQuery = query.term;
          DamService.autocomplete(solrQuery, scope.field.value.model.attribute).then(function(terms) {
            var tags = [];
            if (terms && terms.length > 0) {
              terms.forEach(function(term) {
                tags.push({
                  id: term,
                  text: term
                });
              });
            }

            return query.callback({more: false, results: tags});
          }).then(undefined, function (error) {
            console.log(error);
            return query.callback({more: false, results: []});
          });
        }, 200),

        tags: function () {
          return [];
        },

        placeholder: UIConfigurationService.translate(scope.field.value.placeholder),

        formatNoMatches: function () {
          return '';
        },
        containerCss: UIConfigurationService.toCss(scope.field.value.style, {"width": "100%"})
      });

      ngModel.$render = function () {
        var entries = angular.copy(ngModel.$viewValue) || [];

        var tags = [];
        entries.forEach(function (entry) {
          entry = {id: entry, text: entry};
          tags.push({id: entry.id, text: entry.id});
        });

        element.select2('data', tags);
      };

      element.on('select2-open', function () {
        atex.dam.AngularUtils.width(element, 0);
        atex.dam.AngularUtils.getNode(element,'.input-group-addon').hide();

        var node = atex.dam.AngularUtils.getNode(element,'.select2-choices');
        $(node).css('border-radius', '4px 4px 0 0');
        if(scope.useOperator) {
          $(node).css('border-right', '1px solid #5897fb');
          $(node).css('box-shadow', 'none');
        }

        var width = atex.dam.AngularUtils.getWidth(element);
        $('.select2-drop-active').width(width - 2);
      });

      element.on('select2-close', function () {
        atex.dam.AngularUtils.getNode(element,'.input-group-addon').show();

        var node = atex.dam.AngularUtils.getNode(element,'.select2-choices');
        if(scope.useOperator) {
          $(node).css('border-radius', '4px 0 0 4px');
          $(node).css('border-right', 'none');
        } else {
          $(node).css('border-radius', '4px');
          $(node).css('border-right', '1px solid #aaa;');
        }

        var width = atex.dam.AngularUtils.getWidth(element);
        $('.select2-drop-active').width(width + 2);
      });

      element.on('change', function () {
        var objects = angular.copy(element.select2('data'));

        var values = [];
        objects.forEach(function (object) {
          values.push(object.id);
        });

        scope.$apply(function () {
          ngModel.$setViewValue(values);
        });

        if (scope.selectPresetCallBack) {
          scope.selectPresetCallBack();
        }
      });
    }
  };
}]).directive('uiAutocompleteMetadata', ['$rootScope', '$q', 'ContentService', 'UIConfigurationService', function ($rootScope, $q, ContentService, UIConfigurationService) {
  return {
    require: '^ngModel',

    scope: {
      model: '=ngModel',
      field: '=field',
      useOperator: "="
    },

    controller: function ($scope) {
      if (!$rootScope.cache) {
        $rootScope.cache = {};
      }

      var excludedSiteRegexConfig = atex.onecms.ObjectUtils.getByPath($scope.field, "value/config/excludedSiteRegex") || "";

      if (excludedSiteRegexConfig) {
        var excludedSiteRegex = new RegExp(excludedSiteRegexConfig);
      }

      $scope.getSitesTags = function () {
        var deferred = $q.defer();

        var id = atex.onecms.ObjectUtils.getByPath($scope.field, 'value/id');
        if (!id) {
          id = '-internal-security-parent';
        }

        if ($rootScope.cache[id]) {
          deferred.resolve($rootScope.cache[id]);
        } else {
          if (id === '-internal-security-parent') {
            UIConfigurationService.getExcludedSites().then(function (excluded) {
              return UIConfigurationService.getWorkingSites(excluded, excludedSiteRegex).then(function (sites) {
                $rootScope.cache[id] = UIConfigurationService.flatWorkingSites(sites);
                deferred.resolve($rootScope.cache[id]);
              });
            });
          } else {
            var externalId = atex.onecms.ObjectUtils.getByPath($scope.field, 'value/external-id');

            UIConfigurationService.getLevels(externalId).then(function (sites) {
              $rootScope.cache[id] = UIConfigurationService.flatWorkingSites(sites);
              deferred.resolve($rootScope.cache[id]);
            });
          }
        }

        return deferred.promise;
      };
    },

    link: function (scope, element, attrs, ngModel) {
      scope.$on('$destroy', function () {
        element.remove();
      });

      element.attr('title', UIConfigurationService.translate(scope.field.value.placeholder));

      $(element).select2({
        minimumInputLength: 2,

        formatInputTooShort: function () {
          return UIConfigurationService.translate('_AUTOCOMPLETE_MIN_CHARACTER_');
        },

        formatSelection: function (object) {
          return object.text;
        },

        query: _.debounce(function (query) {
          scope.getSitesTags().then(function (tags) {
            return query.callback({more: false, results: UIConfigurationService.filterWorkingSites(tags, query.term)});
          });
        }, 200),

        tags: function () {
          return [];
        },

        placeholder: UIConfigurationService.translate(scope.field.value.placeholder),

        formatNoMatches: function () {
          return '';
        },
        containerCss: UIConfigurationService.toCss(scope.field.value.style, {"width": "100%"})
      });

      ngModel.$render = function () {
        scope.getSitesTags().then(function (tags) {
          var entries = angular.copy(ngModel.$viewValue) || [];

          var promises = entries.map(function (contentId) {
            return _.find(tags, function (_tag) {
              return _tag.id === contentId;
            });
          });

          $q.all(promises).then(function (tags) {
            tags = _.filter(tags, function (tag) {
              return (tag !== undefined);
            });

            element.select2('data', tags);
          });
        });
      };

      element.on('select2-open', function () {
        atex.dam.AngularUtils.width(element, 0);
        atex.dam.AngularUtils.getNode(element, '.input-group-addon').hide();

        var node = atex.dam.AngularUtils.getNode(element, '.select2-choices');
        $(node).css('border-radius', '4px 4px 0 0');
        if (scope.useOperator) {
          $(node).css('border-right', '1px solid #5897fb');
          $(node).css('box-shadow', 'none');
        }

        var width = atex.dam.AngularUtils.getWidth(element);
        $('.select2-drop-active').width(width - 2);
      });

      element.on('select2-close', function () {
        atex.dam.AngularUtils.getNode(element, '.input-group-addon').show();

        var node = atex.dam.AngularUtils.getNode(element, '.select2-choices');
        if (scope.useOperator) {
          $(node).css('border-radius', '4px 0 0 4px');
          $(node).css('border-right', 'none');
        } else {
          $(node).css('border-radius', '4px');
          $(node).css('border-right', '1px solid #aaa;');
        }

        var width = atex.dam.AngularUtils.getWidth(element);
        $('.select2-drop-active').width(width + 2);
      });

      element.on('change', function () {
        var objects = angular.copy(element.select2('data'));

        var values = [];
        objects.forEach(function (object) {
          values.push(object.id);
        });

        scope.$apply(function () {
          ngModel.$setViewValue(values);
        });

        if (scope.selectPresetCallBack) {
          scope.selectPresetCallBack();
        }
      });
    }
  };
}]).directive('uiAutocompleteField', ['DamService', 'UIConfigurationService', function (DamService, UIConfigurationService) {
  return {
    require: '^ngModel',

    scope: {
      model: '=ngModel',
      field: '=field',
      useOperator: "="
    },

    controller: function ($scope) {
    },

    link: function (scope, element, attrs, ngModel) {
      scope.$on('$destroy', function () {
        element.remove();
      });

      element.attr('title', UIConfigurationService.translate(scope.field.value.placeholder));

      $(element).select2({
        minimumInputLength: 2,

        formatInputTooShort: function () {
          return UIConfigurationService.translate('_AUTOCOMPLETE_MIN_CHARACTER_');
        },

        formatSelection: function (object) {
          return object.text;
        },

        query: _.debounce(function (query) {
          var solrQuery = query.term;
          DamService.autocomplete(solrQuery, scope.field.value.model.attribute).then(function(terms) {
            var tags = [];
            if (terms && terms.length > 0) {
              terms.forEach(function(term) {
                tags.push({
                  id: term,
                  text: term
                });
              });
            }

            return query.callback({more: false, results: tags});
          }).then(undefined, function (error) {
            console.log(error);
            return query.callback({more: false, results: []});
          });
        }, 200),

        tags: function () {
          return [];
        },

        placeholder: UIConfigurationService.translate(scope.field.value.placeholder),

        formatNoMatches: function () {
          return '';
        },
        containerCss: UIConfigurationService.toCss(scope.field.value.style, {"width": "100%"})
      });

      ngModel.$render = function () {
        var entries = angular.copy(ngModel.$viewValue) || [];

        var tags = [];
        entries.forEach(function (entry) {
          entry = {id: entry, text: entry};
          tags.push({id: entry.id, text: entry.id});
        });

        element.select2('data', tags);
      };

      element.on('select2-open', function () {
        atex.dam.AngularUtils.width(element, 0);
        atex.dam.AngularUtils.getNode(element, '.input-group-addon').hide();

        var node = atex.dam.AngularUtils.getNode(element, '.select2-choices');
        $(node).css('border-radius', '4px 4px 0 0');
        if (scope.useOperator) {
          $(node).css('border-right', '1px solid #5897fb');
          $(node).css('box-shadow', 'none');
        }

        var width = atex.dam.AngularUtils.getWidth(element);
        $('.select2-drop-active').width(width - 2);
      });

      element.on('select2-close', function () {
        atex.dam.AngularUtils.getNode(element, '.input-group-addon').show();

        var node = atex.dam.AngularUtils.getNode(element, '.select2-choices');
        if (scope.useOperator) {
          $(node).css('border-radius', '4px 0 0 4px');
          $(node).css('border-right', 'none');
        } else {
          $(node).css('border-radius', '4px');
          $(node).css('border-right', '1px solid #aaa;');
        }

        var width = atex.dam.AngularUtils.getWidth(element);
        $('.select2-drop-active').width(width + 2);
      });

      element.on('change', function () {
        var objects = angular.copy(element.select2('data'));

        var values = [];
        objects.forEach(function (object) {
          values.push(object.id);
        });

        scope.$apply(function () {
          ngModel.$setViewValue(values);
        });

        if (scope.selectPresetCallBack) {
          scope.selectPresetCallBack();
        }
      });
    }
  };
}]).directive('duplicateHeader', function($q, $timeout, UIConfigurationService, DamSearchService) {
  return {
    restrict: 'ACE',
    templateUrl: 'views/ui-configuration/result-list/table-list/float-header.html',
    scope: {
      componentName: "@",
      componentId: "@",
      profile: "@",
      toggleSelectAll: "&",
      isHasReadEnabled: "&"
    },

    controller: function ($scope) {
      $scope.headers = [];
      $scope.loading = true;

      function parse(value) {
        if (value) {
          if ('string' !== typeof value) {
            value = value.toString();
          }

          if (value.indexOf("px") === -1) {
            value = value + "px";
          }
        }
        return value;
      }

      function reset() {
        $scope.headers.length = 0;
        $scope.getHeader();
      }

      function filter(widgets) {
        _.each(widgets, function (widget, key) {
          var rules = atex.onecms.ObjectUtils.getByPath(widget, "display");
          if (rules) {
            var remove = UIConfigurationService.validate(DamSearchService.getCurrentAdvQuery(), rules);
            if (!remove.valid) {
              widgets = _.without(widgets, _.findWhere(widgets, {
                id: widget.id
              }));
            }
          }
        });

        return widgets;
      }

      $scope.toggleSelectAll = $scope.toggleSelectAll();
      if (!$scope.toggleSelectAll) {
        $scope.toggleSelectAll = function () {
        };
      }

      $scope.isHasReadEnabled = $scope.isHasReadEnabled();
      if (!$scope.isHasReadEnabled) {
        $scope.isHasReadEnabled = function () {
        };
      }

      $scope.getHeader = function () {
        var table = $('#ui-result-set-table').width();

        $('#float-header').width(table).css("height", "31px");
        $('#float-header .row').width(table).css("height", "31px");

        var head = $('#ui-result-set-table thead');
        var tr = $(head).find('tr');
        if (tr) {
          var th = $(tr).find('th');

          for (var i = 0; i < th.length; i++) {
            var width = parse($(th[i]).width());
            var paddingLeft = parse($(th[i]).css('padding-left'));
            var paddingRight = parse($(th[i]).css('padding-right'));

            $scope.headers.push({
                "width": width,
                "margin-left": paddingLeft,
                "margin-right": paddingRight,
              }
            );
          }

          if (!$scope.$$phase) {
            $scope.$apply();
          }

          $scope.loading = false;
        }
      };

      function build() {
        UIConfigurationService.type($scope.componentName, $scope.componentId, "default", $scope.profile).then(function (_configuration) {
          $scope.configuration = _configuration;
          if (_configuration.widgets) {
            var widgets = filter(angular.copy(_configuration.widgets));
            var promises = UIConfigurationService._configuration(widgets);

            $q.all(promises).then(function (_widgets) {
              $scope.widgets = _widgets;
            });
          }
        });
      }

      build();

      angular.element("#table-wrapper").bind("scroll", function () {
        reset();
        angular.element("#header-wrapper").scrollLeft(angular.element("#table-wrapper").scrollLeft());
      });

      $scope.$root.$on('ui-config:last-element', function () {
        $scope.loading = true;
        $timeout(function () {
          reset();
        }, 1);
      });

      $scope.$on("dam:view-change", function () {
        $scope.loading = true;
        $timeout(function () {
          reset();
        }, 1);
      });

      $(window).on("resize", function () {
        reset();
      });

      $scope.$on("dam:search", function () {
        build();
      });
    },

    link: function (scope, element) {
      scope.$on('$destroy', function () {
        element.remove();
      });

      scope.selectAll = function () {
        scope.toggleSelectAll();
      };
    }
  };
}).directive('updateBorder', ['$parse', function($parse) {
  return {
    restrict: 'A',
    link: function (scope, element) {
      scope.operator = $parse(element.attr('use-operator'))(scope);

      element.bind('focusout', function () {
        var node = atex.dam.AngularUtils.getNode(element, '.input-group-addon');
        var choices = atex.dam.AngularUtils.getNode(element, '.select2-choices');

        if (scope.operator) {
          var color = choices.css('border');
          choices.css('border-right', 'none');
          $(node).attr('style', 'border: ' + color + ' !important; border-left:none !important;');
        }
      });
    }
  };
}]).directive('visibleOnOver', function () {
  return {
    restrict: 'A',
    link: function (scope, element) {
      var show = function () {
        scope.$parent.updateFocused(true);
      };

      var hide = function () {
        scope.$parent.updateFocused(false);
      };

      element.bind('mouseleave', hide);
      element.bind('mouseover', show);
      element.bind('mouseenter', show);
    }
  };
}).directive('uiOverflow', ['$parse', function($parse) {
  return {
    restrict: 'A',
    link: function (scope, element) {
      scope.fit = $parse(element.attr('fit'))(scope);

      scope.$on('uis:activate', function () {
        if(scope.fit) {
          element.find('.ui-select-choices').css('max-height', 'fit-content');
        }
      });
    }
  };
}]).directive('uiSelectEvent', ['$parse', function($parse) {
  return {
    restrict: 'A',
    link: function (scope, element) {
      scope.operator = $parse(element.attr('use-operator'))(scope);

      scope.$on('uis:activate', function () {
        atex.dam.AngularUtils.width(element, 0);
        atex.dam.AngularUtils.getNode(element, '.input-group-addon').hide();

        var node = atex.dam.AngularUtils.getNode(element, '.select2-choices');
        $(node).css('border-radius', '4px 4px 0 0');
        if (scope.operator) {
          $(node).css('border-right', '1px solid #5897fb');
          $(node).css('box-shadow', 'none');
        }

        node = atex.dam.AngularUtils.getNode(element, '.select2-drop-active');
        node.width(element.width() - 2);
      });

      scope.$on('uis:close', function () {
        atex.dam.AngularUtils.getNode(element, '.input-group-addon').show();

        var node = $(element).find('.select2-choices');
        if (scope.operator) {
          $(node).css('border-radius', '4px 0 0 4px');
          $(node).css('border-right', 'none');
        } else {
          $(node).css('border-radius', '4px');
          $(node).css('border-right', '1px solid #aaa;');
        }

        node = atex.dam.AngularUtils.getNode(element, '.select2-drop-active');
        node.width(element.width());
      });
    }
  };
}]).directive('uiDateTimePicker', ['$translate', '$rootScope', 'UIConfigurationService','configuration',
  function($translate, $rootScope, UIConfigurationService, configuration) {
    return {
      restrict: 'ACE',
      templateUrl: 'views/ui-configuration/search-form/widget/date-time-picker.html',
      scope: {
        enabledDates: "=",
        active: "=",
        date: "=",
        placeholder: "@"
      },

      link: function (scope, element) {
        function format(date) {
          var month = '' + (date.getMonth() + 1);
          var day = '' + date.getDate();
          var year = date.getFullYear();

          if (month.length < 2) {
            month = '0' + month;
          }

          if (day.length < 2) {
            day = '0' + day;
          }

          return [year, month, day].join('-');
        }

        function enable(enabled) {
          var picker = element.find('.datetimepicker').data("DateTimePicker");
          var container = element.find('.datetimepicker');
          var button = element.find('.datetimepicker-addon');

          if (enabled) {
            if (picker) {
              picker.enable();
            }

            if (container) {
              container.removeClass("disabled");
              container.removeClass("datetime-no-border");
            }

            if (button) {
              button.prop('disabled', false);
              button.removeClass('disabled');
            }
          } else {
            if (picker) {
              picker.disable();
            }

            if (container) {
              container.addClass("disabled");
              container.addClass("datetime-no-border");
            }

            if (button) {
              button.prop('disabled', true);
              button.addClass('disabled');
            }
          }
        }

        function init(reset) {
          scope.dates = [];
          _.each(scope.enabledDates, function (_enabled) {
            scope.dates.push(moment.utc(_enabled.id, "YYYY-MM-DD"));
          });
          var options;
          options = {
            format: 'DD-MM-YYYY',
            locale: $translate.use(),

            icons: {
              previous: 'fa fa-chevron-left',
              next: 'fa fa-chevron-right'
            },

            enabledDates: scope.dates,
            useCurrent: false,
            timeZone: moment.tz.guess()
          };

          if (scope.date && scope.date.length > 0) {
            options.date = scope.date[0].id;
          }

          if (reset) {
            element.find('.datetimepicker').val('');
          }

          element.find('.datetimepicker').datetimepicker(options).on('dp.show dp.update', function () {
            var edit = $('.dam-edit-query');
            edit = edit.length > 0;

            var modal = $('.selectModal');
            modal = modal.length > 0;

            var menu = $(".bootstrap-datetimepicker-widget.dropdown-menu");
            var picker = element.find('.datetimepicker');
            var width = picker.outerWidth();

            var offset;
            var height;

            if (!edit && !modal) {
              offset = picker.offset();
              height = picker.outerHeight();

              menu.css("top", offset.top + height);
              menu.css("left", offset.left);
              menu.css("width", width);
            } else if (modal) {
              offset = picker.offset();
              height = picker.outerHeight();
              menu.css("top", offset.top + height);
              menu.css("left", 30);
              menu.css("width", width);
            } else {
              menu.removeClass("top");
              menu.removeClass("bottom");
              menu.css("left", 15);
              menu.css("width", width + 1);
            }

            $(".picker-switch").removeAttr('title')
            .on('click', function (e) {
              e.stopPropagation();
            });
          });

          element.find('.datetimepicker-addon').on('click', function () {
            if ($(this).prev('input.datetimepicker').data('DateTimePicker') !== undefined){$(this).prev('input.datetimepicker').data('DateTimePicker').show();
          }});

          element.find('input.datetimepicker').on('click', function () {
            $(this).data('DateTimePicker').show();
          });

          element.on('dp.change', function (event) {
            scope.date = [];
            if (event.date) {
              $('#publications-date').find('.select2-chosen span').text(UIConfigurationService.translate("__PH_PAGE_CUSTOM__"));
              scope.date.push({id: format(event.date.toDate())});

              $rootScope.$broadcast("dam:dp.change", scope.date);
            }
          });

          enable(scope.active);
        }

        init(false);

        scope.$watch("date", function (current, previous) {
          if (current !== previous) {
            var picker = element.find('.datetimepicker').data("DateTimePicker");
            if(picker) {
              picker.destroy();
              var id = atex.onecms.ObjectUtils.getByPath(current, 'id');
              init(id === "TODAY" || id === "NEXT" || id === undefined);
            }
          }
        }, true);

        scope.$watch("enabledDates", function (current, previous) {
          if (current !== previous) {
            element.find('.datetimepicker').data("DateTimePicker").destroy();
            init(false);
          }
        }, true);

        scope.$watch("active", function (current, previous) {
          if (current !== previous) {
            enable(current);
          }
        }, true);
      }
    };
  }]).directive('uiEditionSort', function($rootScope, $q, $modal, $translate,  $timeout, $http, AuthenticationService, UIConfigurationService, DamNotificationService) {
  return {
    restrict: 'ACE',
    templateUrl: 'views/ui-configuration/toolbar/ui-edition-sort.html',
    scope: {},

    controller: function ($scope) {
      function editions() {
        return AuthenticationService.callWithAuthentication(function () {
          return $http.get("/onecms/dam/print-page/publications/editions").then(function (editions) {
            return editions.data;
          });
        });
      }

      $scope.pack = function () {
        return editions().then(function (_editions) {
          var data = { editions: [], removed:[] };
          return UIConfigurationService.userprofile("print-data/editions", $scope.profile).then(function (editions) {
            if (editions && editions.length > 0) {
              _.each(editions, function (edition) {
                if (_.contains(_editions, edition)) {
                  data.editions.push({id: edition, status: "saved"});
                  _editions = _.without(_editions, edition);
                } else {
                  data.removed.push({id: edition, status: "removed"});
                }
              });

              if (_editions.length > 0) {
                _.each(_editions, function (_edition) {
                  data.editions.push({id: _edition, status: "added"});
                });
              }
            } else {
              data.editions = _.map(_editions, function (_edition) {
                return {id: _edition, status: "saved"};
              });
            }

            return data;
          });
        });
      };
    },

    link: function (scope, element) {
      scope.$on('$destroy', function () {
        element.remove();
      });

      scope.order = function () {
        scope.pack().then(function (data) {
          var modalScope = scope.$new(true);
          modalScope.editions = data.editions;
          modalScope.removed = data.removed;
          modalScope.backup = angular.copy(data.editions);
          modalScope.dirty = false;

          modalScope.select = function (key) {
            modalScope.current = key;
          };

          modalScope.reset = function () {
            modalScope.dirty = false;
            modalScope.editions = angular.copy(modalScope.backup);
          };

          modalScope.swap = function (current, next) {
            modalScope.dirty = true;
            var temp = modalScope.editions[next];

            modalScope.editions[next] = modalScope.editions[current];
            modalScope.editions[current] = temp;
            modalScope.current = next;

            var selected = $('.edition-item.selected').offset();
            var list = $('#edition-modal .editions-group').offset();
            var height = $('#edition-modal .editions-group').height();
            if (selected.top > (list.top + height - 61)) {
              var top = selected.top + 21;
              $('#edition-modal .editions-group').scrollTop(top);
            } else if (current > next) {
              var _current = $('#edition-modal .editions-group').scrollTop();
              if (_current > (selected.top - 45) || next === 0) {
                $timeout(function () {
                  var _top = next * 40;
                  $('#edition-modal .editions-group').scrollTop(_top);
                });
              }
            }
          };

          var modal = $modal({
            show: true,
            scope: modalScope,

            template: 'views/ui-configuration/toolbar/modal/ui-edition-sort-modal.html',
            modalClass: 'editions-content confirm-modal ng-cloak',
            backdrop: 'static',
            keyboard: false
          });

          modalScope.verified = (modalScope.confirm !== true);
          var deferred = $q.defer();

          var destroyModal = function () {
            modal.then(function (modalEl) {
              modalEl.on('hidden.bs.modal', function () {
                modalScope.$destroy();
                modalEl.remove();
              });

              modalEl.modal('hide');
            });
          };

          modalScope.doClose = function () {
            destroyModal();
            deferred.resolve("close");
          };

          modalScope.doSave = function (close) {
            modalScope.saving = true;
            UIConfigurationService.profile().then(function (_profile) {
              if (_profile['print-data']) {
                _profile['print-data'].editions = _.pluck(modalScope.editions, "id");

                UIConfigurationService.save(_profile).then(function (_updated) {
                  scope.profile = _updated.data;
                  $rootScope.$broadcast("dam:user-profile-updated",scope.profile);
                  modalScope.dirty = false;
                  modalScope.saving = false;
                  modalScope.backup = angular.copy(modalScope.editions);
                  DamNotificationService.addNotification(atex.dam.Notification({
                    type: 'success',
                    message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__
                  }), false);

                  if (close) {
                    destroyModal();
                    deferred.resolve("save");
                  }
                });
              } else {
                modalScope.dirty = false;
                modalScope.saving = false;
                var message = UIConfigurationService.translate('__PH_PAGE_PAGE_EDITION_SORT_ERROR__');
                DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);

                if (close) {
                  destroyModal();
                  deferred.resolve("save");
                }
              }
            });
          };

          return deferred.promise;
        });
      };
    }
  };
}).directive('uiDateRange', function($translate) {
  var silentWatch = false;

  var customOpt;
  $translate.onReady().then(function () {
    customOpt = {
      'label': $translate.getTranslationTable().__CUSTOM_DATE_RANGE__,
      'value': "custom"
    };
  });

  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'views/ui-configuration/search-form/widget/date-range/ui-date-range.html',

    scope: {
      label: "=",
      objects: "=",
      dates: "=",
      sets: "=",
      hideCustom: "=",
      selectPresetCallBack: '&',
      hideLabel: "=",
      dateFormat: "=",
      searchFormat: "=",
      allowClear: "=?",
      defaultPresetIndex: "=?"
    },

    link: function (scope, element) {
      function random() {
        return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      }

      function id() {
        return [random(), random()];
      }

      function checkAndSetDefaultPreset() {
        if (scope.defaultPresetIndex && !isNaN(scope.defaultPresetIndex)) {
          if (scope.presets && scope.presets.length > scope.defaultPresetIndex) {
            scope.model.selectedOption = scope.presets[scope.defaultPresetIndex];
            scope.preset = angular.copy(scope.presets[scope.defaultPresetIndex]);
            scope.setPreset(scope.presets[scope.defaultPresetIndex]);
          }
        }
      }

      scope.preset = {};

      if (scope.sets) {
        scope.presets = angular.copy(scope.sets);
      } else {
        scope.presets = [];
      }

      if (!scope.hideCustom) {
        if (customOpt === undefined) {
          $translate.onReady().then(function () {
            return {
              'label': $translate.getTranslationTable().__CUSTOM_DATE_RANGE__,
              'value': "custom"
            };
          }).then(function (result) {
            customOpt = result;
            var index = scope.presets.indexOf(function (preset) {
              return preset.value === result.value;
            });
            if (index === -1) {
              scope.presets.push(customOpt);
            }
          });
        } else {
          scope.presets.push(customOpt);
        }
      }

      scope.model = {
        selectedOption: undefined
      };

      scope.allowClear = (scope.allowClear !== false);

      var clearDateRange = function () {
        if (!scope.dates) {
          scope.dates = [];
        }
        scope.dates.length = 0;
        scope.dates.push('');
        scope.dates.push('');
      };

      if (scope.objects === 'random') {
        scope.id = id();
      } else {
        scope.id = scope.objects.split('-');
      }

      scope.showDateRange = false;

      scope.presetChanged = function (val) {
        if (scope.selectPresetCallBack) {
          scope.selectPresetCallBack();
        }
      };

      scope.open = function (index) {
        var obj = element.find("input[date-picker-id='" + scope.id[index] + "']");
        obj.data("DateTimePicker").show();
      };

      scope.setPreset = function (preset) {
        if (preset === undefined) {
          clearDateRange();
          scope.showDateRange = false;
          scope.preset = {};
        } else if (preset === customOpt) {
          if (!scope.dates || scope.dates[0] || scope.dates[1]) {
            silentWatch = true;
          }
          clearDateRange();
          scope.showDateRange = true;
          scope.preset = {};
        } else {
          scope.dates = [];
          scope.showDateRange = false;
          scope.preset = angular.copy(preset);
          scope.dates.push(preset.value);
          delete scope.dates[1];
        }
        scope.presetChanged();
      };

      checkAndSetDefaultPreset();

      scope.$watch(function () {
        return scope.dates;
      }, function (newValue, oldValue) {
        if (silentWatch) {
          silentWatch = false;
          return;
        }
        if (!scope.dates || scope.dates.length === 0) {

          scope.model.selectedOption = undefined;
          scope.showDateRange = false;
          checkAndSetDefaultPreset();
          return;
        }
        // Check the array in case has been cleared by clearAdvancedFields of DamSearchFormController
        if (!(scope.dates instanceof Array)) {
          var a = scope.dates[0] === undefined ? '' : scope.dates[0];
          var b = scope.dates[1] === undefined ? '' : scope.dates[1];
          scope.dates = [];
          scope.dates.push(a);
          scope.dates.push(b);
        }
        var from = scope.dates[0];
        var to = scope.dates[1];
        if (from && to && from !== to && from !== "*" && to !== "*") {
          scope.showDateRange = true;
          scope.model.selectedOption = customOpt;
          var fromDate = new Date(from);
          var toDate = new Date(to);
          if (toDate < fromDate) {
            if (newValue[0] !== oldValue[0]) {
              scope.dates[1] = from;
            } else if (newValue[1] !== oldValue[1]) {
              scope.dates[0] = to;
            }
          }
        } else {
          var presetFound = false;
          if (from && !to) {
            angular.forEach(scope.presets, function (preset) {
              if (from === preset.value) {
                scope.model.selectedOption = preset;
                scope.showDateRange = false;
                presetFound = true;
              }
            });
          }
          if ((from || to) && !presetFound) {
            if (from && !to) {
              scope.dates[1] = from;
            } else if (to && !from) {
              scope.dates[0] = to;
            }

            scope.model.selectedOption = customOpt;
            scope.showDateRange = true;
          } else if (!from && !to) {
            scope.showDateRange = false;
            scope.model.selectedOption = undefined;
          }
        }
      }, true);
    }
  };
}).directive('uiDatePicker', ['$translate', '$timeout', '$window', 'UIConfigurationService', function ($translate, $timeout, $window, UIConfigurationService) {
  var linker = function (scope, element, attrs) {
    UIConfigurationService.getSearchOptions().then(function (options) {
      var format = attrs.dateFormat || atex.onecms.ObjectUtils.getByPath(options, 'dateFormat') || "DD/MM/YYYY";
      var searchFormat = attrs.searchFormat || atex.onecms.ObjectUtils.getByPath(options, 'searchFormat') || "YYYY-MM-DD";

      var parent = $('#date-wrapper');
      var config = {
        widgetParent: parent,
        locale: $translate.use(),
        showClose: true,
        showTodayButton: true,
        format: format,
        useCurrent: false,
        timeZone: "UTC",

        icons: {
          time: 'fa fa-clock-o',
          date: 'fa fa-calendar',
          up: 'fa fa-chevron-up',
          down: 'fa fa-chevron-down',
          previous: 'fa fa-chevron-left',
          next: 'fa fa-chevron-right',
          today: 'fa fa-calculator',
          clear: 'fa fa-trash',
          close: 'fa fa-times'
        }
      };

      var picker = element.datetimepicker(config);
      var dt = picker.data("DateTimePicker");

      picker.on("dp.show", function () {
        var top = 0;
        var left = 0;

        var datepicker = $('.bootstrap-datetimepicker-widget:last');
        if (datepicker.hasClass('bottom')) {
          top = $(this).offset().top + $(this).outerHeight();
          left = $(this).offset().left - 34;
        } else if (datepicker.hasClass('top')) {
          top = $(this).offset().top - datepicker.outerHeight();
          left = $(this).offset().left - 32;
        }

        var windowSize = Number(angular.element($window).width());
        var position = Number(left) + Number(datepicker.width());

        if (position > windowSize) {
          left = left - (position - windowSize) - 30;
        }

        datepicker.css({
          position: "fixed",
          "z-index": 101001,
          top: top,
          left: left,
          bottom: "auto",
          right: "auto",
          "font-family": "sans-serif",
          "font-weight": "normal"
        });
      });

      scope.$on('dam:clearAdvancedFields', function () {
        if (scope.date) {
          dt.date(null);
          scope.date = "";
        }
      });

      picker.on('dp.change', function (e) {
        $timeout(function () {
          scope.date = (e.date) ? e.date.format(searchFormat) : "";

          if (scope.callBack) {
            scope.callBack();
          }
        });
      });

      scope.$watch(function () {
        return scope.date;
      }, function (newValue, oldValue) {
        if (!newValue) {
          return;
        }

        if (newValue && newValue !== '*') {
          var _date = new Date(newValue);

          var m = moment(_date);
          if (m.isValid()) {
            dt.date(_date);
          }
        } else {
          dt.date(null);
        }
      });
    });
  };

  return {
    restrict: 'AE',
    scope: {
      date: "=",
      callBack: "&"
    },

    link: linker
  };
}]).directive('uiSelectMru', ['$parse', '$window', 'AuthenticationService', function($parse, $window, AuthenticationService) {
  return {
    restrict: 'A',
    link: function (scope, element) {
      function deepClone(value) {
        return angular.fromJson(angular.toJson(value)); // deep clone and renove $$haskKey
      }
      function hasLabel( model, value ) {
        if( model ) {
          if (_.isArray(model)) {
            return !!_.find(model, function (mValue) {
              return  mValue.label === value.label;
            });
          }

          return hasLabel([model], value);
        }

        return false;
      }

      function setMru( model ) {
        if (model) {
          if (_.isArray(model)) {
            model.forEach(function (modelValue) {
              setMru(modelValue);
            });
          } else {
            if (model.mruId) {
              model.id = model.mruId;
            }
          }
        }
      }

      function addToMru( model, mruValues, selectMru, mruSortLatest ) {
        if (model) {
          if (_.isArray(model)) {
            if ( mruSortLatest ) {
              for (var idx = mruValues.length - 1; idx >= 0; idx--) {
                if (mruValues[idx] && hasLabel(model, mruValues[idx])) {
                  mruValues.splice(idx, 1);
                }
              }
              model.forEach(function (modelValue) {
                if ( modelValue.label ) {
                  mruValues.unshift(deepClone(modelValue));

                  if (mruValues.length > selectMru) {
                    mruValues.splice(mruValues.length - 1, 1);
                  }
                }
              });
            } else {
              model.forEach(function (modelValue) {
                if ( modelValue.label ) {
                  if (!hasLabel(mruValues, modelValue)) {
                    mruValues.unshift(deepClone(modelValue));
                  }

                  if (mruValues.length > selectMru) {
                    mruValues.splice(mruValues.length - 1, 1);
                  }
                }
              });
            }
          } else {
            addToMru([model], mruValues, selectMru, mruSortLatest);
          }
        }
      }

      function onActivate() {
        for (var idm = scope.model.length - 1; idm >= 0; idm--) {
          if ( scope.model[idm].mruId ) {
            scope.model.splice(idm,1);
          }
        }
        scope.model.forEach(function(modelValue) {
          if (scope.ngModel) {
            modelValue.disabled = hasLabel(scope.ngModel.$modelValue, modelValue);
          } else if (scope.$select && scope.$select.ngModel) {
            modelValue.disabled = hasLabel(scope.$select.ngModel.$modelValue, modelValue);
          }
        });
        if (scope.mru.length > 0) {
          scope.model.unshift({
            id: '-------',
            label: '-------',
            text: true,
            disabled: true,
            mruId: '-------'
          });
          for (var idx = scope.mru.length - 1; idx >= 0; idx--) {
            var mruValue = deepClone(scope.mru[idx]);
            if (scope.ngModel) {
              mruValue.disabled = hasLabel(scope.ngModel.$modelValue, mruValue);
            } else if (scope.$select && scope.$select.ngModel) {
              mruValue.disabled = hasLabel(scope.$select.ngModel.$modelValue, mruValue);
            }
            mruValue.mruId = mruValue.id;
            mruValue.id = mruValue.id + Date.now();
            scope.model.unshift(mruValue);
          }
        }
      }

      function onSelect() {
        if (scope.ngModel) {
          setMru(scope.ngModel.$modelValue);
        } else if (scope.$select && scope.$select.ngModel) {
          setMru(scope.$select.ngModel.$modelValue);
          if ( scope.$select && scope.$select.selected && scope.$select.selected.mruId) {
            scope.$select.selected.id = scope.$select.selected.mruId;
          }
        }
      }

      function onClose() {
        var mru = scope.mru.slice();

        if ( scope.ngModel ) {
          addToMru(scope.ngModel.$modelValue, mru, scope.selectMru, scope.mruSortLatest );
        } else if (scope.$select && scope.$select.ngModel ) {
          addToMru(scope.$select.ngModel.$modelValue, mru, scope.selectMru, scope.mruSortLatest );
        }

        if (!_.isEqual(scope.mru, mru)) {
          scope.mru = mru;
          if (scope.mruKey) {
            $window.localStorage.setItem(scope.mruKey, angular.toJson(scope.mru));
          }
        }
      }

      // mru-ui-select (select-mru)  - number of items in list
      // mru-sort-latest = true => latest on top - false = maintain mru order
      // mru-storage-key - default selectMru_{principalId}_{componentId}

      scope.selectMru = scope.field.value['mru-ui-select'];
      if (scope.selectMru > 0) {
        scope.mruSortLatest = false;
        if (!scope.mruKey) {
          AuthenticationService.getCurrentUser().then(function (currentUser) {
            var storageKey = 'selectMru_{principalId}_{componentId}';

            if ( scope.field && scope.field.value ) {
              scope.mruSortLatest = !!scope.field.value['mru-sort-latest'];
              if ( scope.field.value['mru-storage-key'] ) {
                storageKey = scope.field.value['mru-storage-key'];
              }
            }

            scope.mruKey = storageKey.replace('{principalId}', currentUser.principalId).
            replace('{componentId}', scope.field.componentId);

            var json = $window.localStorage.getItem(scope.mruKey);

            if (json) {
              scope.mru = angular.fromJson(json);
            }
            if (!scope.mru) {
              scope.mru = [];
            }
          });

          scope.$on('uis:select', onSelect);

          scope.$on('uis:activate', onActivate);

          scope.$on('uis:close', onClose);
        }
      }
    }
  };
}]);
